// sizesArr items are objects: { name: '5.5', size_range: 'Womens Footwear' }
// size_range is always present (no legacy bare-size support)
var sizesArr = [];
var colorsArr = [];

// ---- Size URL helpers (Option 1: ?s.womens-footwear=5.5&s.mens-footwear=10) ----
// Maps user-sizes locals -> backend size_range labels.
// TODO: confirm size_range labels with the values your backend expects.
var USER_SIZES_RANGE_MAP = {
  accessories: 'Accessories',
  headwear: 'Headwear',
  littleKidsFootwear: 'Little Kids Footwear',
  mensClothing: 'Mens Clothing',
  mensFootwear: 'Mens Footwear',
  mensSuiting: 'Mens Suiting',
  womensClothing: 'Womens Clothing',
  womensFootwear: 'Womens Footwear',
  womensSuiting: 'Womens Suiting'
};

// Registry of all user-size categories. Each entry pairs the raw comma-separated
// Liquid-rendered string (defined in the parent template) with its backend
// size_range label and the index of the .filter-variant-list-N container in the DOM.
// TODO: verify filterIndex values against the actual rendered filter order.
function getUserSizeCategories() {
  return [
    { raw: typeof userSizesMensClothing    !== 'undefined' ? userSizesMensClothing    : '', range: USER_SIZES_RANGE_MAP.mensClothing,       filterIndex: 0 },
    { raw: typeof userSizesMensFootwear    !== 'undefined' ? userSizesMensFootwear    : '', range: USER_SIZES_RANGE_MAP.mensFootwear,       filterIndex: 1 },
    { raw: typeof userSizesHeadwear        !== 'undefined' ? userSizesHeadwear        : '', range: USER_SIZES_RANGE_MAP.headwear,           filterIndex: 2 },
    { raw: typeof userSizesAccessories     !== 'undefined' ? userSizesAccessories     : '', range: USER_SIZES_RANGE_MAP.accessories,        filterIndex: 3 },
    { raw: typeof userSizesLittleKidsFootwear !== 'undefined' ? userSizesLittleKidsFootwear : '', range: USER_SIZES_RANGE_MAP.littleKidsFootwear, filterIndex: 4 },
    { raw: typeof userSizesMensSuiting     !== 'undefined' ? userSizesMensSuiting     : '', range: USER_SIZES_RANGE_MAP.mensSuiting,        filterIndex: 5 },
    { raw: typeof userSizesWomensClothing  !== 'undefined' ? userSizesWomensClothing  : '', range: USER_SIZES_RANGE_MAP.womensClothing,     filterIndex: 6 },
    { raw: typeof userSizesWomensFootwear  !== 'undefined' ? userSizesWomensFootwear  : '', range: USER_SIZES_RANGE_MAP.womensFootwear,     filterIndex: 7 },
    { raw: typeof userSizesWomensSuiting   !== 'undefined' ? userSizesWomensSuiting   : '', range: USER_SIZES_RANGE_MAP.womensSuiting,      filterIndex: 8 }
  ];
}

// Split a comma-separated user-size string into a clean array (no empties / whitespace).
function splitUserSizes(raw) {
  if (!raw) return [];
  var parts = String(raw).split(',');
  var out = [];
  for (var i = 0; i < parts.length; i++) {
    var v = parts[i] != null ? String(parts[i]).trim() : '';
    if (v) out.push(v);
  }
  return out;
}

function sizeRangeToSlug(range) {
  return String(range || '').toLowerCase().trim().replace(/\s+/g, '-');
}

function slugToSizeRange(slug) {
  // 'womens-footwear' -> 'Womens Footwear'
  return String(slug || '')
    .split('-')
    .map(function(w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; })
    .join(' ');
}

// Find index of {name, size_range} in sizesArr. Returns -1 if absent.
function findSizeIndex(arr, name, range) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] && arr[i].name === name && arr[i].size_range === range) {
      return i;
    }
  }
  return -1;
}

// Parse window.location.search into an array of {name, size_range}.
// Keys look like s.mens-footwear, s.womens-footwear, etc.
function parseSizesFromSearch(search) {
  var out = [];
  if (!search) return out;
  var qs = search.charAt(0) === '?' ? search.substring(1) : search;
  var pairs = qs.split('&');
  for (var i = 0; i < pairs.length; i++) {
    if (!pairs[i]) continue;
    var eq = pairs[i].indexOf('=');
    var rawKey = eq === -1 ? pairs[i] : pairs[i].substring(0, eq);
    var rawVal = eq === -1 ? '' : pairs[i].substring(eq + 1);
    var key = decodeURIComponent(rawKey);
    var val = decodeURIComponent(rawVal);
    if (key.indexOf('s.') === 0) {
      var range = slugToSizeRange(key.substring(2));
      if (val && findSizeIndex(out, val, range) === -1) {
        out.push({ name: val, size_range: range });
      }
    }
  }
  return out;
}

// Build the size portion of a search string (no leading ? or &).
function sizesToSearchString(arr) {
  var parts = [];
  for (var i = 0; i < arr.length; i++) {
    var s = arr[i];
    if (!s || !s.name) continue;
    var key = 's.' + sizeRangeToSlug(s.size_range);
    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(s.name));
  }
  return parts.join('&');
}
// ---- end size helpers ----

var vintageShowProductsFromApp = false;
var vintageSortingEnabled = false;
var vintageHideSoldOut = false;
var vintageFilteringEnabled = false;
var vintageCategoriesArray = [];

var collectionHandle, coll;

let remainingProductsFromFilters = [];

// the filters api can return products without a resolved local price for the
// current market - rendering those blows up, so drop them from the results
function withValidLocalPrice(products) {
  if(!Array.isArray(products)) {
    return products;
  }

  return products.filter(function(product) {
    return !!product && !!product.local_price && product.local_price.price != null;
  });
}

// filter state lives in the collection url as v= (sold out toggle), ss= (sale
// only), c= (colors) and s.<size-range>= (sizes) - any of them means the grid
// has to be rebuilt from the api on load, e.g. when coming back from a pdp
function hasCollectionFilterParams() {
  var params = new URLSearchParams(window.location.search);
  var found = false;

  params.forEach(function(value, key) {
    if(key === 'v' || key === 'ss' || key === 'c' || key.indexOf('s.') === 0) {
      found = true;
    }
  });

  return found;
}

function is_touch_enabled() {
  return ( 'ontouchstart' in window ) ||
   ( navigator.maxTouchPoints > 0 ) ||
   ( navigator.msMaxTouchPoints > 0 );
}

var temporarilyDisableFilters = false;

var events = '';
var hidx = '';
var singleBooking = true;

var viewLast = '';

function showCollectionLoader() {
  $('.products-collection.grid-products > *').not('.loading-collection-products').remove();
  $('.loading-collection-products').css('display', 'flex');
  $('.loading-collection-products-text').hide();
}

function hideCollectionLoader() {
  $('.products-collection.grid-products').removeClass('initial-loading-products');
  $('.loading-collection-products').css('display', 'none');
  $('.loading-collection-products-text').hide();
}

function waitForProductImages(targetCount = 8, timeout = 4000) {
  const images = $('.products-collection.grid-products .plp-product .product-image img[src]')
    .slice(0, targetCount)
    .toArray();
  const needed = images.length;
  if (needed === 0) {
    return Promise.resolve();
  }

  return new Promise(function(resolve) {
    let resolved = false;
    let loaded = 0;

    const finish = function() {
      if (resolved) {
        return;
      }
      resolved = true;
      clearTimeout(timeoutId);
      resolve();
    };

    const check = function() {
      if (loaded >= needed) {
        finish();
      }
    };

    const timeoutId = setTimeout(finish, timeout);

    images.forEach(function(img) {
      if (img.complete && img.naturalWidth) {
        loaded += 1;
        check();
      } else {
        const handler = function() {
          img.removeEventListener('load', handler);
          img.removeEventListener('error', handler);
          loaded += 1;
          check();
        };
        img.addEventListener('load', handler);
        img.addEventListener('error', handler);
      }
    });

    check();
  });
}



var plpCarousel = true;


var customTagName = '';
var customTagText = '';


function currentCollectionHandle() {
  var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
  return m ? m[1] : '';
}

function getOverImageBadges(product, excludeTags) {
  var here = currentCollectionHandle();
  var excluded = excludeTags || [];
  var matched = badgeConfig.filter(function(b) {
    if (!b.active) return false;
    if (excluded.indexOf(b.tag) > -1) return false; // caller opted out of this badge
    if (product.tags.indexOf(b.tag) === -1) return false;
    if (b.collectionHandle && b.collectionHandle === here) return false; // suppress on scoped collection
    if (b.collectionHandles && b.collectionHandles.indexOf(here) > -1) return false; // ...or any in the scoped list
    return true;
  });
  if (!matched.length) return '';

  matched.sort(function(a, b) { return (b.priority || 0) - (a.priority || 0); });

  return matched.map(function(b) {
    var cls = 'plp-product__tag' + (b.style == 'sentence case, closer positioning' ? ' plp-product__tag--nocaps' : '');
    var style = b.color ? ' style="color:' + b.color + ';"' : '';
    return '<div class="' + cls + '"' + style + '>' + b.name + '</div>  ';
  }).join('');
}


// var myElement = document.getElementById('shopify-section-collection-vintage');
// var hammertime = new Hammer(myElement);
// hammertime.on('panup pandown swipeup swipedown', function(ev) {
//   console.log('hammer', ev);
//           var height = $(window).height();
//           var scrollTop = $(window).scrollTop();
//           var scrollAmount = height;
//           var scrollTime = 1500
//           if(scrollTop >= height) {
//             scrollAmount = 2 * height - 59;
//             scrollTime = 750;
//           }
//           $('body, html').animate({
//               scrollTop: scrollAmount
//           }, scrollTime)
// });

// register AJAX prefilter : options, original options
/*
$.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
  console.log('>>>>>>> ajaxprefilter running')
   // retry not set or less than 2 : retry not requested
   if( !originalOptions.retryMax || !originalOptions.retryMax >=2 ) return;
   // no timeout was setup
   if( !originalOptions.timeout >0 ) return;

   if( originalOptions.retryCount ) {
      // increment retry count each time
      originalOptions.retryCount++;
   }else{
      // init the retry count if not set
      originalOptions.retryCount = 1;
      // copy original error callback on first time
      originalOptions._error = originalOptions.error;
   };

   // overwrite error handler for current request
   options.error = function( _jqXHR, _textStatus, _errorThrown ){
      // retry max was exhausted or it is not a timeout error
      if( originalOptions.retryCount >= originalOptions.retryMax || _textStatus!='timeout' ){
         // call original error handler if any
         if( originalOptions._error ) originalOptions._error( _jqXHR, _textStatus, _errorThrown );
         return;
      };
      // Call AJAX again with original options
      $.ajax( originalOptions);
   };
});
*/
(function ($) {

  'use strict';

  // paging through filtered results is a new page of products, not a return
  // from a pdp, so the saved persistentTop offset must not be restored
  var scrollToTopAfterFilters = false;

  var aldsec = {
    /**
    * Init Function
    */
    init: function () {

      $('.main-wrapper .container').on('click', '.pagination-plp a', function() {
        const url = new URL(location);
        let page = $(this).data('searchpage');
        if(page !== undefined) {
          url.searchParams.set("page", page);
          // the stored product position belongs to the page we are leaving
          url.searchParams.delete("startIndex");
          url.searchParams.delete("startIndexOffset");
          history.pushState({}, "", url);
        }

        scrollToTopAfterFilters = true;
        aldsec.getFilteredProducts();

        return false;
      });

      var productsShown = 0;
      var productsAlreadyShown = 0;
      var visibleRows = 0;

      // to do send first event on load
      var isShopAll = window.location.href.indexOf('/shop-all') > -1 ? true : false;
      isShopAll = window.location.pathname.indexOf('collections/') > -1 ? true : false;
      if(isShopAll) {
        var deviceType = $(window).width() < 1025 ? 'm' : 'd';
        var itemsPerRow = 0;
        if(deviceType == 'm') {
          itemsPerRow = localStorage.getItem('plpmobile')
          if(itemsPerRow == null) {
            itemsPerRow = 2;
          }
        } else {
          var desktopItems = localStorage.getItem('plpdesktop');
          if(desktopItems != null) {
            if(desktopItems == 5) {
              itemsPerRow = 4;
            } else if(desktopItems == 3) {
              itemsPerRow = 8;
            } else {
              itemsPerRow = 2;
            }
          } else {
            itemsPerRow = 4;
          }
        }
        console.log('items per row', itemsPerRow, desktopItems);
        /*
        if($('.plp-product').length) {
          var offsetTop = $('.plp-product').first().offset().top;
          var screenHeight = $(window).height();
          var scrolledDistance = $(window).scrollTop();
          var productHeight = $('.plp-product').first().height();
          var windowHeight = $(window).height();

          var counter = 0;
          // console.log('calculations', productHeight * counter + offsetTop, scrolledDistance + windowHeight);
          while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
            // console.log('calculations', productHeight * counter + offsetTop, scrolledDistance + windowHeight);
            // console.log('counter', counter)
            counter++;
          }

          var productsShown =  itemsPerRow * (counter - 1);
          var eventName = 'infinite_scroll_' + deviceType + '_' + itemsPerRow + '_' + productsShown;
          if(typeof gtag === 'function') {
            productsAlreadyShown = productsShown;
            console.log(eventName)
            gtag('event', eventName);
          }
        }
        */
      }

      if(isShopAll) {

        var isFiltersEnabled = $('.filter-toggle sup').text() != '' ? true : false;

        var itemsPerRow = 0;
        if(deviceType == 'm') {
          itemsPerRow = localStorage.getItem('plpmobile')
          if(itemsPerRow == null) {
            itemsPerRow = 2;
          }
        } else {
          var desktopItems = localStorage.getItem('plpdesktop');
          if(desktopItems != null) {
            if(desktopItems == 5) {
              itemsPerRow = 4;
            } else if(desktopItems == 3) {
              itemsPerRow = 8;
            } else {
              itemsPerRow = 2;
            }
          } else {
            itemsPerRow = 4;
          }
        }

        var offsetTop = $('.plp-product').first().offset().top;
        var screenHeight = $(window).height();
        var scrolledDistance = $(window).scrollTop();
        var productHeight = $('.plp-product').first().height();
        var windowHeight = $(window).height();

        var counter = 0;
        while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
          counter++;
        }

        var productsShown =  itemsPerRow * (counter - 1);
        // pagination_page-title_device_page#_view_row
        var collectionSlug = window.location.pathname;
        collectionSlug = collectionSlug.replace('/collections/', '');
        var urlParams   = new URLSearchParams(window.location.search);
        var currentPage = urlParams.get('page');
        if(currentPage === null) {
          currentPage = 1;
        }
        var eventName = 'pagination';
        var eventParams = {
          page: collectionSlug,
          device: deviceType,
          page_number: currentPage,
          view: itemsPerRow,
          row: productsShown
        }
        if(productsShown > productsAlreadyShown) {
          if($('.plp-product').length >= productsShown) {
            if(typeof gtag === 'function') {
              productsAlreadyShown = productsShown;
              gtag('event', eventName, eventParams);
            }
          }
        }

        $(window).scroll(function() {
          var isFiltersEnabled = $('.filter-toggle sup').text() != '' ? true : false;

          var itemsPerRow = 0;
          if(deviceType == 'm') {
            itemsPerRow = localStorage.getItem('plpmobile')
            if(itemsPerRow == null) {
              itemsPerRow = 2;
            }
          } else {
            var desktopItems = localStorage.getItem('plpdesktop');
            if(desktopItems != null) {
              if(desktopItems == 5) {
                itemsPerRow = 4;
              } else if(desktopItems == 3) {
                itemsPerRow = 8;
              } else {
                itemsPerRow = 2;
              }
            } else {
              itemsPerRow = 4;
            }
          }

          var offsetTop = $('.plp-product').first().offset().top;
          var screenHeight = $(window).height();
          var scrolledDistance = $(window).scrollTop();
          var productHeight = $('.plp-product').first().height();
          var windowHeight = $(window).height();

          var counter = 0;
          while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
            counter++;
          }

          var productsShown =  itemsPerRow * (counter - 1);
          // pagination_page-title_device_page#_view_row
          var collectionSlug = window.location.pathname;
          collectionSlug = collectionSlug.replace('/collections/', '');
          var urlParams   = new URLSearchParams(window.location.search);
          var currentPage = urlParams.get('page');
          if(currentPage === null) {
            currentPage = 1;
          }
          var eventName = 'pagination';
          var eventParams = {
            page: collectionSlug,
            device: deviceType,
            page_number: currentPage,
            view: itemsPerRow,
            row: productsShown
          }
          if(productsShown > productsAlreadyShown) {
            if($('.plp-product').length >= productsShown) {
              if(typeof gtag === 'function') {
                productsAlreadyShown = productsShown;
                gtag('event', eventName, eventParams);
              }
            }
          }
        });
      }

      $('#displayall').on('click', function() {
        $('.plp-product').show();
        $(this).hide();
        return false;
      });

      // Sonny Tournament JS code
      if($('section.sonny-tournament').length) {
        var form = $('#sonny-tournament-form');
        var tournamentDateValue = form.find('input[name=tournament_date]').val();
        var isTournamentDateMoment = moment(tournamentDateValue, 'YYYY-MM-DD', true);
        if(!isTournamentDateMoment.isValid() || !isTournamentDateMoment.isAfter(moment(), 'day')) {
          $('section.sonny-tournament').hide();
          console.error('Tournament date is valid: ' + tournamentDateValue)
        }

        // Date input mask
        var birthInputs = $('input[name="birthday"]')
        var im = new Inputmask("99/99/9999", {
          placeholder: 'MM/DD/YYYY'
        });
        if(im) {
          im.mask(birthInputs);
        }

        // Accordion logic
        $('.sonny-tournament__member-header').on('click', function (event) {
          var parent = $(event.target).parent();
          if(parent) {
            const content = parent.find('.sonny-tournament__member-content');
            if(content.is(":visible")) {
              content.slideUp();
              parent.removeClass('isOpen')
            } else {
              content.slideDown();
              parent.addClass('isOpen')
            }
          }
        })


        var validateEmail = function (email) {
          return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
        }

        // Form submit
        $('#sonny-tournament-form').on('submit', function (event) {
          event.preventDefault();
          var error = false;
          var form = $('#sonny-tournament-form');
          var teamName = form.find('input[name=team_name]');
          var teamNameVal = teamName.val();

          // teamname required error
          var isTeamNameValid = !!teamNameVal.split(' ').filter(function (value) { return !!value.length }).length;
          if(isTeamNameValid) {
            teamName.parent().removeClass('withError');
          } else {
            teamName.parent().addClass('withError');
            error = true;
          }

          var teammates = [];
          form.find('.sonny-tournament__member').each(function(_, member){
            var memberError = false;
            var name = $(member).find("input[name=name]");
            var email = $(member).find('input[name=email]');
            var birth = $(member).find('input[name=birthday]');
            var nameVal = name.val();
            var emailVal = email.val();
            var birthVal = birth.val();

            // member required error
            if(!isNameValid && !emailVal && !birthVal) {
              error = true;
              memberError = true;
            }

            // member fields validation
            var isNameValid = !!nameVal.split(' ').filter(function (value) { return !!value.length }).length;
            var isEmailValid = validateEmail(emailVal);
            var birthMoment = moment(birthVal, 'MM/DD/YYYY', true);
            var isBirthValid = birthMoment.isValid();

            if(!isNameValid || !isEmailValid || !isBirthValid) {
              error = true;
              memberError = true;
            }

            if(isNameValid) {
              name.parent().removeClass('withError');
            } else {
              name.parent().addClass('withError');
            }

            if(isEmailValid) {
              email.parent().removeClass('withError');
            } else {
              email.parent().addClass('withError');
            }

            if(isBirthValid) {
              birth.parent().removeClass('withError');
            } else {
              birth.parent().addClass('withError');
            }

            if(memberError) {
              $(member).addClass('withError');
              $(member).find('.sonny-tournament__label--success').hide();
              $(member).find('.sonny-tournament__label--error').show();
            } else {
              $(member).removeClass('withError');
              $(member).find('.sonny-tournament__label--success').show();
              $(member).find('.sonny-tournament__label--error').hide();

              teammates.push({
                name: nameVal,
                email: emailVal,
                birthday: birthMoment.format('YYYY-MM-DD')
              })
            }
          });

          // add_team request
          var isNotSpam = !form.find('input[name=bot_secure]').val().length;
          var apiDomain = 'https://ald-filter-staging.herokuapp.com/api';
          var sonnyTournamentHeader = $('.sonny-tournament__header');
          if(!error && isNotSpam) {
            var dataToSend = {
              tournament_date: tournamentDateValue,
              team_name: teamNameVal,
              teammates
            }
            $.ajax({
              url: apiDomain + '/tournament/add_team',
              type: 'POST',
              data: JSON.stringify(dataToSend),
              accept: 'application/json',
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
              success: function() {
                form.hide();
                sonnyTournamentHeader.hide();
                $('.sonny-tournament__success-message').show();
              },
              error: function() {
                form.hide();
                sonnyTournamentHeader.hide();
                $('.sonny-tournament__error-message').show();
              }
            });
            $([document.documentElement, document.body]).animate({
              scrollTop: $("section.sonny-tournament").offset().top - 50
            }, 500);
          }
        });
      }


if($('body').hasClass('page-sonny') || $('body').hasClass('page-masaryk-gym-signup')) {
      $('#shopify-section-page-sonny__booking .sonny-link-back').on('click', function() {
//          $('.sonny-main').show();
  //        $('.sonny-booking').hide();

          if($('#step-1').is(':visible')) {
            $('.sonny-main').show();
            $('.sonny-booking').hide();

            $('html, body').animate({
              scrollTop: $('.sonny-visit-section').offset().top - 80
            }, 50);

            $('.header').removeClass('header--no-fixed');
          }

          if($('#step-15').is(':visible')) {
            $('.sonny-main').show();
            $('.sonny-booking').hide();

            $('.header').removeClass('header--no-fixed');
          }

          if($('#step-2').is(':visible')) {
            if(viewLast.indexOf('-2') > -1) {
              $('#step-2').hide();
              $('#step-15').show();
            } else {
              $('#step-2').hide();
              $('#step-1').show();
            }
          }

          if($('#step-3').is(':visible')) {
            $('.sonny-main').show();
            $('.sonny-booking').hide();
          }

/*          $('.header').addClass('header--light').addClass('header--fixed');
          setTimeout(function() {
            $('.header').addClass('header--light').addClass('header--fixed');
          }, 250);  */
        return false;
      });

      console.log('>>>>>>>>>>>>>>>>>>   calendar   >>>>>>>>>>>>>>>>>>>>>')

      var today = new Date();
      var currentDay = moment(today);
      var currentWeekMonday = currentDay.startOf('isoWeek');
      var stringCurrentDay = currentWeekMonday.format('D');
      var stringCurrentMonth = currentWeekMonday.format('MMMM').toUpperCase();
      var stringCurrentYear = currentWeekMonday.format('YYYY');

      var nextWeekDay = moment().add(7, 'days');
      var mondayNextWeek = nextWeekDay.startOf('isoWeek');
      var stringNextWeekDay = mondayNextWeek.format('D');
      var stringNextWeekMonth = mondayNextWeek.format('MMMM').toUpperCase();
      var stringNextWeekYear = mondayNextWeek.format('YYYY');

      console.log('momentjs: ... ', currentDay, mondayNextWeek, nextWeekDay);

      $('.sn-title-week').text('WEEK OF '+stringCurrentMonth+' '+stringCurrentDay+', '+stringCurrentYear);

console.log('>>>>>>>>>>>>>>>>', moment().startOf('isoWeek').format('D'));

      $('.calendar-visit__days-desktop th').eq(0).text(moment().startOf('isoWeek').format('D'));
      $('.calendar-visit__days-desktop th').eq(1).text(moment().startOf('isoWeek').add(1, 'days').format('D'));
      $('.calendar-visit__days-desktop th').eq(2).text(moment().startOf('isoWeek').add(2, 'days').format('D'));
      $('.calendar-visit__days-desktop th').eq(3).text(moment().startOf('isoWeek').add(3, 'days').format('D'));
      $('.calendar-visit__days-desktop th').eq(4).text(moment().startOf('isoWeek').add(4, 'days').format('D'));
      $('.calendar-visit__days-desktop th').eq(5).text(moment().startOf('isoWeek').add(5, 'days').format('D'));
      $('.calendar-visit__days-desktop th').eq(6).text(moment().startOf('isoWeek').add(6, 'days').format('D'));

      $('.calendar-visit__days-desktop th').eq(0).attr('data-month', moment().startOf('isoWeek').format('M'));
      $('.calendar-visit__days-desktop th').eq(1).attr('data-month', moment().startOf('isoWeek').add(1, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(2).attr('data-month', moment().startOf('isoWeek').add(2, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(3).attr('data-month', moment().startOf('isoWeek').add(3, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(4).attr('data-month', moment().startOf('isoWeek').add(4, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(5).attr('data-month', moment().startOf('isoWeek').add(5, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(6).attr('data-month', moment().startOf('isoWeek').add(6, 'days').format('M'));

      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).text(moment().startOf('isoWeek').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).text(moment().startOf('isoWeek').add(1, 'days').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).text(moment().startOf('isoWeek').add(2, 'days').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).text(moment().startOf('isoWeek').add(3, 'days').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).text(moment().startOf('isoWeek').add(4, 'days').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).text(moment().startOf('isoWeek').add(5, 'days').format('D'));
      $('.calendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).text(moment().startOf('isoWeek').add(6, 'days').format('D'));

      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).attr('data-month', moment().startOf('isoWeek').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).attr('data-month', moment().startOf('isoWeek').add(1, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).attr('data-month', moment().startOf('isoWeek').add(2, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).attr('data-month', moment().startOf('isoWeek').add(3, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).attr('data-month', moment().startOf('isoWeek').add(4, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).attr('data-month', moment().startOf('isoWeek').add(5, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).attr('data-month', moment().startOf('isoWeek').add(6, 'days').format('M'));

      $('.calendar-visit__days-mobile li').each(function() {
        if($(this).text() == moment().format('D')) {
          $(this).addClass('visit-day--active');
        }

        if($(this).text() < moment().format('D') && moment().format('M') == $(this).data('month')) {
          $(this).addClass('visit-day--past');
        }
      })

      var counter = 0;
      $('.visit-box-table tbody td').each(function() {
        $(this).attr('data-day', moment().startOf('isoWeek').add(counter, 'days').format('YYYY-MM-DD'));
        counter++;
      });



      /* ------ clean above ------ */

      $('.calendar-visit__days-mobile .visit-day').on('click', function() {
        $('.visit-day--active').removeClass('visit-day--active');
        $(this).addClass('visit-day--active');

        // here swap display of mobile reservations
        $('.visit-box__item--mobile .daily-session').hide();
        // alert($(this).text())
        if(parseInt($(this).text()) < 10) {
          //alert('[data-date="2022-'+$(this).data('month')+'-0'+$(this).text()+'"]')
          //alert($('.visit-box__item--mobile').find('[data-date="2022-'+$(this).attr('data-month')+'-0'+$(this).text()+'"]').length);
          if(parseInt($(this).attr('data-month')) < 10) {
            $('.visit-box__item--mobile').find('[data-date="2023-0'+$(this).attr('data-month')+'-0'+$(this).text()+'"]').show();
          } else {
            $('.visit-box__item--mobile').find('[data-date="2023-'+$(this).attr('data-month')+'-0'+$(this).text()+'"]').show();
          }
          
        } else {
          //console.log('[data-date="2022-'+$(this).data('month')+'-'+$(this).text()+'"]')
          if(parseInt($(this).attr('data-month')) < 10) {
            $('.visit-box__item--mobile').find('[data-date="2023-0'+$(this).attr('data-month')+'-'+$(this).text()+'"]').show();
          } else {
            $('.visit-box__item--mobile').find('[data-date="2023-'+$(this).attr('data-month')+'-'+$(this).text()+'"]').show();
          }
          
        }

        return false;
      })

      $('.calendar-visit-arrow--next').on('click', function() {
        $('.calendar-visit-arrow--prev').show();
        $('.calendar-visit-arrow--next').hide();
        // $('.calendar-visit__heading h3').text('WEEK OF APRIL 11, 2022');
        $('.sn-title-week').text('WEEK OF '+stringNextWeekMonth+' '+stringNextWeekDay+', '+stringNextWeekYear);

console.log('>>>>>>>>', moment().add(7, 'days').startOf('isoWeek').format('D'), moment().add(7, 'days'))

        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).text(moment().add(7, 'days').startOf('isoWeek').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(0).text(moment().add(7, 'days').startOf('isoWeek').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).text(moment().add(7, 'days').startOf('isoWeek').add(1, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(1).text(moment().add(7, 'days').startOf('isoWeek').add(1, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).text(moment().add(7, 'days').startOf('isoWeek').add(2, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(2).text(moment().add(7, 'days').startOf('isoWeek').add(2, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).text(moment().add(7, 'days').startOf('isoWeek').add(3, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(3).text(moment().add(7, 'days').startOf('isoWeek').add(3, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).text(moment().add(7, 'days').startOf('isoWeek').add(4, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(4).text(moment().add(7, 'days').startOf('isoWeek').add(4, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).text(moment().add(7, 'days').startOf('isoWeek').add(5, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(5).text(moment().add(7, 'days').startOf('isoWeek').add(5, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).text(moment().add(7, 'days').startOf('isoWeek').add(6, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(6).text(moment().add(7, 'days').startOf('isoWeek').add(6, 'days').format('D'));


      $('.calendar-visit__days-desktop th').eq(0).attr('data-month', moment().add(7, 'days').startOf('isoWeek').format('M'));
      $('.calendar-visit__days-desktop th').eq(1).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(1, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(2).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(2, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(3).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(3, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(4).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(4, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(5).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(5, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(6).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(6, 'days').format('M'));

      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).attr('data-month', moment().add(7, 'days').startOf('isoWeek').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(1, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(2, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(3, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(4, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(5, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).attr('data-month', moment().add(7, 'days').startOf('isoWeek').add(6, 'days').format('M'));

        $('.visit-box-table tbody').eq(0).hide();
        $('.visit-box-table tbody').eq(1).show();

        $('.visit-day--active').removeClass('visit-day--active');

        // $('.visit-box__item--mobile .daily-session').hide();

        $('.calendar-visit__days-mobile .visit-day').eq(0).trigger('click');

      $('.calendar-visit__days-mobile li').removeClass('visit-day--past')

        return false;
      });

      $('.calendar-visit-arrow--prev').on('click', function() {
        $('.calendar-visit-arrow--next').show();
        $('.calendar-visit-arrow--prev').hide();
        // $('.calendar-visit__heading h3').text('WEEK OF APRIL 4, 2022');
        $('.sn-title-week').text('WEEK OF '+stringCurrentMonth+' '+stringCurrentDay+', '+stringCurrentYear);

        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).text(moment().startOf('isoWeek').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).text(moment().startOf('isoWeek').add(1, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).text(moment().startOf('isoWeek').add(2, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).text(moment().startOf('isoWeek').add(3, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).text(moment().startOf('isoWeek').add(4, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).text(moment().startOf('isoWeek').add(5, 'days').format('D'));
        $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).text(moment().startOf('isoWeek').add(6, 'days').format('D'));

        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(0).text(moment().startOf('isoWeek').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(1).text(moment().startOf('isoWeek').add(1, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(2).text(moment().startOf('isoWeek').add(2, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(3).text(moment().startOf('isoWeek').add(3, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(4).text(moment().startOf('isoWeek').add(4, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(5).text(moment().startOf('isoWeek').add(5, 'days').format('D'));
        $('.calendar-visit__days-desktop th, .xcalendar-visit__days-mobile li').eq(6).text(moment().startOf('isoWeek').add(6, 'days').format('D'));





      $('.calendar-visit__days-desktop th').eq(0).attr('data-month', moment().startOf('isoWeek').format('M'));
      $('.calendar-visit__days-desktop th').eq(1).attr('data-month', moment().startOf('isoWeek').add(1, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(2).attr('data-month', moment().startOf('isoWeek').add(2, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(3).attr('data-month', moment().startOf('isoWeek').add(3, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(4).attr('data-month', moment().startOf('isoWeek').add(4, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(5).attr('data-month', moment().startOf('isoWeek').add(5, 'days').format('M'));
      $('.calendar-visit__days-desktop th').eq(6).attr('data-month', moment().startOf('isoWeek').add(6, 'days').format('M'));

      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(0).attr('data-month', moment().startOf('isoWeek').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(1).attr('data-month', moment().startOf('isoWeek').add(1, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(2).attr('data-month', moment().startOf('isoWeek').add(2, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(3).attr('data-month', moment().startOf('isoWeek').add(3, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(4).attr('data-month', moment().startOf('isoWeek').add(4, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(5).attr('data-month', moment().startOf('isoWeek').add(5, 'days').format('M'));
      $('.xcalendar-visit__days-desktop th, .calendar-visit__days-mobile li').eq(6).attr('data-month', moment().startOf('isoWeek').add(6, 'days').format('M'));

        $('.visit-box-table tbody').eq(0).show();
        $('.visit-box-table tbody').eq(1).hide();

        $('.visit-box__item--mobile .daily-session').hide();


      $('.calendar-visit__days-mobile li').each(function() {
        if($(this).text() < moment().format('D') && moment().format('M') == $(this).data('month')) {
          $(this).addClass('visit-day--past');
        }
      })



        $('.visit-day--active').removeClass('visit-day--active');
        $('.calendar-visit__days-mobile .visit-day').not('.visit-day--past').eq(0).trigger('click');

        return false;
      });

      $('.visit-box-table').on('click', '.daily-session', function() {
        if(!$(this).hasClass('daily-session--inactive')) {
          $('.daily-session--active').removeClass('daily-session--active');
          $(this).addClass('daily-session--active');

          hidx = $(this).data('index');
          $('.event-date').text($(this).data('day'));

          $('.ev-error').hide();

        }
      });

      $('.visit-box__item--mobile').on('click', '.daily-session', function() {
          $('.daily-session--active').removeClass('daily-session--active');
          $(this).addClass('daily-session--active');

          hidx = $(this).data('index');
          $('.event-date').text($(this).data('day'));

          // $('.ev-error').hide();
      });

      // $('.daily-session').not('.daily-session--inactive').on('click', function() {
      //   $('.daily-session--active').removeClass('daily-session--active');
      //   $(this).addClass('daily-session--active');

      //   hidx = $(this).data('index');
      //   $('.event-date').text($(this).data('day'));
      // });

      $('#book-for-myself').on('click', function() {
        if($('.daily-session--active').length) {

$('.header').addClass('header--no-fixed');

          var day = $('.daily-session--active').parent().index();
          var dayint = day;
          if(day === 0) {
            day = 'Monday';
          }
          if(day === 1) {
            day = 'Tuesday';
          }
          if(day === 2) {
            day = 'Wednesday';
          }
          if(day === 3) {
            day = 'Thursday';
          }
          if(day === 4) {
            day = 'Friday';
          }
          if(day === 5) {
            day = 'Saturday';
          }
          if(day === 6) {
            day = 'Sunday';
          }

                var startTime = events[hidx].start_time;
                startTime = startTime.slice(startTime.indexOf('T')+1, startTime.indexOf('T')+6);

                var startHour = parseInt(startTime.slice(0, 2));
                var startMinutes = parseInt(startTime.slice(3, 5));
                  var minDisplay = startMinutes;
                  if(minDisplay == 0) {
                    minDisplay = '00';
                  }
                                var extStartTime = startHour+':'+minDisplay+' AM';
                if(startHour > 12) {
                  extStartTime = (startHour-12)+':'+minDisplay+' PM';

                }
                  if(startHour == 12) {
                    extStartTime = startHour+':'+minDisplay+' PM';
                  }

          $('.book-ev-name').text(events[hidx].service_name);
          $('.book-ev-time').text(extStartTime);
          $('.book-ev-day').text(day);

                  var dxday = events[hidx].day;
                  dxday = dxday.slice(8, 10);
            dxday = parseInt(dxday);

var month = $('.calendar-visit__days-desktop th').eq(dayint).attr('data-month');
console.log('month', month, dayint);

          // if(dxday > 25) {
          //   $('.book-ev-month').text('September');
          // } else {
          //   $('.book-ev-month').text('September');
          // }

$('.book-ev-month').text(moment.months(parseInt(month) - 1));

          $('.book-ev-avail').text(events[hidx].available_spots)

$('#step-15, #step-2, #step-3').hide()

          $('.sonny-main').hide();
          $('.sonny-booking').show();
          $('.header').addClass('header--light').addClass('header--fixed');
          setTimeout(function() {
            $('.header').addClass('header--light').addClass('header--fixed');
          }, 250);
        } else {
          $('.ev-error').show();
        }


        // var dataToSend = {
        //   'app_id': events[hidx].app_id,
        //   'resource_id': events[hidx].resource_id,
        //   'start_time': events[hidx].start_time,
        //   'end_time': events[hidx].end_time,
        //   'name': 'Matt',
        //   'email': 'mateusz@0xb8.net'
        // }

        // $.ajax({
        //   url: 'https://ald-filter-staging.herokuapp.com/api/onsched/book_event',
        //   type: 'POST',
        //   data: JSON.stringify(dataToSend),
        //   accept: 'application/json',
        //   cache: false,
        //   dataType: 'json',
        //   contentType: 'application/json',
        //   headers: {
        //     'Authorization': 'Basic ' + btoa(customer_id + ":" + token),
        //   },
        //   success: function(response) {
        //     console.log('> collection info >', response);
        //   }
        // });

        return false;
      });

      $('#book-for-group').on('click', function() {
        if($('.daily-session--active').length) {
$('.header').addClass('header--no-fixed');

          singleBooking = false;

          var day = $('.daily-session--active').parent().index();
          var dayint = day;
          if(day === 0) {
            day = 'Monday';
          }
          if(day === 1) {
            day = 'Tuesday';
          }
          if(day === 2) {
            day = 'Wednesday';
          }
          if(day === 3) {
            day = 'Thursday';
          }
          if(day === 4) {
            day = 'Friday';
          }
          if(day === 5) {
            day = 'Saturday';
          }
          if(day === 6) {
            day = 'Sunday';
          }

                var startTime = events[hidx].start_time;
                startTime = startTime.slice(startTime.indexOf('T')+1, startTime.indexOf('T')+6);

                var startHour = parseInt(startTime.slice(0, 2));
                var startMinutes = parseInt(startTime.slice(3, 5));
                  var minDisplay = startMinutes;
                  if(minDisplay == 0) {
                    minDisplay = '00';
                  }
                                var extStartTime = startHour+':'+minDisplay+' AM';
                if(startHour > 12) {
                  extStartTime = (startHour-12)+':'+minDisplay+' PM';
                }
                  if(startHour == 12) {
                    extStartTime = startHour+':'+minDisplay+' PM';
                  }
          $('.book-ev-name').text(events[hidx].service_name);
          $('.book-ev-time').text(extStartTime);
          $('.book-ev-day').text(day);



                  var dxday = events[hidx].day;
                  dxday = dxday.slice(8, 10);
            dxday = parseInt(dxday);



var month = $('.calendar-visit__days-desktop th').eq(dayint).attr('data-month');
console.log('month', month, dayint);


          // if(dxday > 25) {
          //   $('.book-ev-month').text('September');
          // } else {
          //   $('.book-ev-month').text('September');
          // }

$('.book-ev-month').text(moment.months(parseInt(month) - 1));

          $('.book-ev-avail').text(events[hidx].available_spots)

          $('.sonny-main').hide();
          $('#step-1, #step-2, #step-3').hide()
          $('.sonny-booking, #step-15').show();
          $('.header').addClass('header--light').addClass('header--fixed');
          setTimeout(function() {
            $('.header').addClass('header--light').addClass('header--fixed');
          }, 250);
        } else {
          $('.ev-error').show();
        }

        return false;
      });


      $('.select-add-guest__arrow').on('click', function() {
        // $('.form-booking__group-1').show();
        if($('.form-booking__group-1').length == 0) {

        $('.group-members-container').append(`
<div class="form-booking__group form-booking__group--remove-xxx form-booking__group-1">
        <input class="form-control form-control--border" name="add-g-email-1" id="add-g-email-1" placeholder="username@email.com" />
        <span class="btn-add-guest btn-add-guest--remove btn-add-guest-1"></span>
      </div>
          `)

        }



      });

      $('.group-members-container').on('click', '.btn-add-guest-1', function() {
        if($(this).hasClass('btn-add-guest--remove')) {
          // $(this).parent().hide();
          // $(this).prev().val('');
          $('.form-booking__group-1').remove();
        } else {
          if($('.form-booking__group-2').length == 0) {

            $('.btn-add-guest-1').addClass('btn-add-guest--remove')

            $('.group-members-container').append(`
                  <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-2">
                          <input class="form-control form-control--border" name="add-g-email-2" id="add-g-email-2" placeholder="username@email.com" />
                          <span class="btn-add-guest btn-add-guest--remove btn-add-guest-2"></span>
                        </div>
            `)

          } else {
            if($('.form-booking__group-3').length == 0) {

              $('.btn-add-guest-1').addClass('btn-add-guest--remove')

              $('.group-members-container').append(`
      <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-3">
              <input class="form-control form-control--border" name="add-g-email-3" id="add-g-email-3" placeholder="username@email.com" />
              <span class="btn-add-guest btn-add-guest--remove btn-add-guest-3"></span>
            </div>
                `)
            }
          }          
        }
      });

      $('.group-members-container').on('click', '.btn-add-guest-2', function() {
console.log('0')
        if($(this).hasClass('btn-add-guest--remove')) {
          // $(this).parent().hide();
          // $(this).prev().val('');

          $('.form-booking__group-2').remove();
        } else {
console.log('1')
          if($('.form-booking__group-1').length == 0) {
console.log('2')
            $('.btn-add-guest-2').addClass('btn-add-guest--remove')

            $('.group-members-container').append(`
                  <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-1">
                          <input class="form-control form-control--border" name="add-g-email-1" id="add-g-email-1" placeholder="username@email.com" />
                          <span class="btn-add-guest btn-add-guest--remove btn-add-guest-1"></span>
                        </div>
            `)

          } else {
            if($('.form-booking__group-3').length == 0) {

              $('.btn-add-guest-2').addClass('btn-add-guest--remove')

              $('.group-members-container').append(`
      <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-3">
              <input class="form-control form-control--border" name="add-g-email-3" id="add-g-email-3" placeholder="username@email.com" />
              <span class="btn-add-guest btn-add-guest--remove btn-add-guest-3"></span>
            </div>
                `)
            }
          } 

        }
      });

      $('.group-members-container').on('click', '.btn-add-guest-3', function() {
        if($(this).hasClass('btn-add-guest--remove')) {
          // $(this).parent().hide();
          // $(this).prev().val('');


          $('.form-booking__group-3').remove();
        } else {

          if($('.form-booking__group-1').length == 0) {

            $('.btn-add-guest-3').addClass('btn-add-guest--remove')

            $('.group-members-container').append(`
                  <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-1">
                          <input class="form-control form-control--border" name="add-g-email-1" id="add-g-email-1" placeholder="username@email.com" />
                          <span class="btn-add-guest btn-add-guest--remove btn-add-guest-1"></span>
                        </div>
            `)

          } else {
            if($('.form-booking__group-2').length == 0) {

              $('.btn-add-guest-3').addClass('btn-add-guest--remove')

              $('.group-members-container').append(`
      <div class="form-booking__group form-booking__group--remove-xxx form-booking__group-2">
              <input class="form-control form-control--border" name="add-g-email-2" id="add-g-email-2" placeholder="username@email.com" />
              <span class="btn-add-guest btn-add-guest--remove btn-add-guest-2"></span>
            </div>
                `)
            }
          } 


        }
      });

      $('.group-members-container').on('input', '#add-g-email-1, #add-g-email-2', function() {
        var txt = $(this).val();
        if(txt.length > 0) {
          console.log('a1')
          if($(this).parent().parent().hasClass('sonny-error')) {
console.log('a2')
          } else {
console.log('a3')
            $(this).next().removeClass('btn-add-guest--remove');  
          }
          
        } else {
          $(this).next().addClass('btn-add-guest--remove');
        }
      })

      $('#booking-confirm').on('click', function() {
        viewLast = $(this).attr('id');
        $('#step-1, #step-15').hide();
        $('#step-2').show();
        return false;
      });

      $('#booking-confirm-2').on('click', function() {
        $('.sonny-error').removeClass('sonny-error')
        var formValid = true;

        var validateEmail2 = function (email) {
          return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
        }

        if($('#add-g-email-1').length) {
          var em = $('#add-g-email-1').val();
          if(validateEmail2(em)) {

          } else {
            $('#add-g-email-1').parent().addClass('sonny-error');
            formValid = false;
          }
        }
        if($('#add-g-email-2').length) {
          var em = $('#add-g-email-2').val();
          if(validateEmail2(em)) {

          } else {
            $('#add-g-email-2').parent().addClass('sonny-error');
            formValid = false;
          }
        }
        if($('#add-g-email-3').length) {
          var em = $('#add-g-email-3').val();
          if(validateEmail2(em)) {

          } else {
            $('#add-g-email-3').parent().addClass('sonny-error');
            formValid = false;
          }
        }

        // $('.group-members-container .form-booking__group').length

        if(formValid) {
          viewLast = $(this).attr('id');
          $('#step-1, #step-15').hide();
          $('#step-2').show();  
        }

        return false;
      });

      $('#button-reset').on('click', function() {
        $('.sonny-booking').hide();
        $('.sonny-main').show();

        $('#step-1').show();

            $('html, body').animate({
              scrollTop: $('.sonny-visit-section').offset().top - 80
            }, 50);

        $('.header').removeClass('header--no-fixed');
        return false;
      });

      $('#button-agree').on('click', function() {

          $('.form-booking-signature').removeClass('signature-error');
          $('.form-booking .custom-checkbox').removeClass('signature-error');

        if($('#agree-name').val() != '' && $('#terms').prop('checked') == true) {

          $('#step-2').hide();

if(singleBooking) {
          var dataToSend = {
            'app_id': events[hidx].app_id,
            'resource_id': events[hidx].resource_id,
            'start_time': events[hidx].start_time,
            'end_time': events[hidx].end_time,
            'name': customer_name,
            'email': customer_email
          }

          $.ajax({
            url: 'https://ald-filter-staging.herokuapp.com/api/onsched/book_event',
            type: 'POST',
            data: JSON.stringify(dataToSend),
            accept: 'application/json',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            headers: {
              'Authorization': 'Basic ' + btoa(customer_id + ":" + token),
            },
            success: function(response) {
              console.log('> collection info >', response);

              $('#step-3').show();
            }
          });
} else {

var count = 0;
if($('#add-g-email-1').length > 0) {
  count++;
}
if($('#add-g-email-2').length > 0) {
  count++;
}
if($('#add-g-email-3').length > 0) {
  count++;
}

          var dataToSend = {
            'app_id': events[hidx].app_id,
            'resource_id': events[hidx].resource_id,
            'start_time': events[hidx].start_time,
            'end_time': events[hidx].end_time,
            'booked_by': customer_email,
            'name': customer_name,
            'email': customer_email,
            'group_size': count
          }

          $.ajax({
            url: 'https://ald-filter-staging.herokuapp.com/api/onsched/init_booking',
            type: 'POST',
            data: JSON.stringify(dataToSend),
            accept: 'application/json',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            headers: {
              'Authorization': 'Basic ' + btoa(customer_id + ":" + token),
            },
            success: function(response) {
              console.log('> group booking init >', response);

var groupMails = [];
if($('#add-g-email-1').length > 0) {
  groupMails.push($('#add-g-email-1').val())
}
if($('#add-g-email-2').length > 0) {
  groupMails.push($('#add-g-email-2').val())
}
if($('#add-g-email-3').length > 0) {
  groupMails.push($('#add-g-email-3').val())
}

              var newDataToSend = {
                'email': customer_email,
                'group_booking_ids': response.group_booking_ids,
                'group_mails': groupMails
              }

                          $.ajax({
                            url: 'https://ald-filter-staging.herokuapp.com/api/onsched/book_group/'+response.booking_id,
                            type: 'POST',
                            data: JSON.stringify(newDataToSend),
                            accept: 'application/json',
                            cache: false,
                            dataType: 'json',
                            contentType: 'application/json',
                            headers: {
                              'Authorization': 'Basic ' + btoa(customer_id + ":" + token),
                            },
                            success: function(response) {
                              console.log('> group booking init >', response);

                              $('#step-3').show();
                            }
                          });

              // $('#step-3').show();
            }
          });

}

        } else {

          if($('#agree-name').val() == '') {
            $('.form-booking-signature').addClass('signature-error');
          }

          if($('#terms').prop('checked') == false) {
            $('.form-booking .custom-checkbox').addClass('signature-error');
          }
        }


        return false;
      });

      console.log('>> token', token)

      if($('.calendar-visit').length) {
if(customer_id != '') {
                          if(token === '') {
                            var user = {
                              'customer_id': customer_id,
                              'name': 'aime-leon-dore'
                            }
                            $.ajax({
                              url: 'https://ald-filter-staging.herokuapp.com/api/shopify/token',
                              data: JSON.stringify(user),
                              type: 'POST',
                              accept: 'application/json',
                              cache: false,
                              dataType: 'json',
                              contentType: 'application/json',
                              success: function(response) {
                                // window.location.hash = 'edit';
                                window.location.reload();
                              },
                              error: function(response) {
                                console.log('>>e', response)
                              }
                            });
                          } else {
                            var store = 'aime-leon-dore';

                            var jsonCollection = {
                              'store_name': store
                            }

                            $.ajax({
                              url: 'https://ald-filter-staging.herokuapp.com/api/onsched/get_events',
                              type: 'POST',
                              data: '{"tag":""}',
                              accept: 'application/json',
                              cache: false,
                              dataType: 'json',
                              contentType: 'application/json',
                              headers: {
                                'Authorization': 'Basic ' + btoa(customer_id + ":" + token),
                              },
                              success: function(response) {
                                console.log('> events info >', response);
                                events = response;
                                for(i in events) {
                                  if(events[i].tag === customer_tag && customer_tag != '') {
                                    var startTime = events[i].start_time;
                                    startTime = startTime.slice(startTime.indexOf('T')+1, startTime.indexOf('T')+6);



                                    var startHour = parseInt(startTime.slice(0, 2));
                                    var startMinutes = parseInt(startTime.slice(3, 5));

                                    // if(startHour >= 12 && startHour < 22) {

                                      var top = (startHour - 9) * 49;

                                      var height = (events[i].duration / 60) * 49 - 6;

                                      var fontsize = 12;
                                      if(events[i].duration <= 60) {
                                        fontsize = 10;
                                      }

                                      console.log('>>>', events[i], startTime, startHour, startMinutes, events[i].duration);

                                      var dday = events[i].day;
                                      dday = dday.slice(8, 10);

                                      var tpl = `
                                        <div data-index="${i}" data-day="${dday}" class="daily-session" style="position: absolute; top: ${top}px; height: ${height}px; overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center; font-size: ${fontsize}px" data-height="${height}"><span>${events[i].service_name}</span></div>
                                      `;

                                      $('.visit-box-table-wrapper [data-day="'+events[i].day+'"]').append(tpl);


                                      // append mobile

                                      var currentDay = moment().format('YYYY-MM-DD');
                                      var eventDay = events[i].day;
                                      var visible = false;
                                      var show = ' style="display: none;"';
                                      if(currentDay == eventDay) {
                                        visible = true;
                                        show = '';
                                      }

                                      var minDisplay = startMinutes;
                                      if(minDisplay == 0) {
                                        minDisplay = '00';
                                      }

                                    var extStartTime = startHour+':'+minDisplay+' AM';
                                    if(startHour > 12) {
                                      extStartTime = (startHour-12)+':'+minDisplay+' PM';
                                    }
                                      if(startHour == 12) {
                                        extStartTime = startHour+':'+minDisplay+' PM';
                                      }
                    console.log('extstarttime', extStartTime, startTime)

                                      var tpl2 = `<div data-index="${i}" data-day="${dday}" class="daily-session" data-date="${eventDay}" ${show}>
                            <span class="daily-session__time">${extStartTime}</span>
                            <span class="daily-session__title">${events[i].service_name}</span>
                          </div>

                                      `;
                                      $('.visit-box__item--mobile').append(tpl2);

                                    // }

                                  } else {

                                    var startTime = events[i].start_time;
                                    startTime = startTime.slice(startTime.indexOf('T')+1, startTime.indexOf('T')+6);
                                    var endTime = events[i].end_time;
                                    endTime = endTime.slice(endTime.indexOf('T')+1, endTime.indexOf('T')+6);

                                    var startHour = parseInt(startTime.slice(0, 2));
                                    var endHour = parseInt(endTime.slice(0, 2));

                                    var startMinutes = parseInt(startTime.slice(3, 5));

                                    // if(startHour >= 12 && startHour < 22) {

                                      var top = (startHour - 9) * 49;

                                      var height = (events[i].duration / 60) * 49 - 6;
                                      if(endHour == 21) {
                                        height = height + 6 + 24;
                                      }

                                      var fontsize = 12;
                                      if(events[i].duration <= 60) {
                                        fontsize = 10;
                                      }

                                      console.log('>>>', events[i], startTime, startHour, startMinutes, events[i].duration);
                                      if(customer_tag == 'Sonny-F&F') {
                                      var tpl = `
                                        <div class="daily-session daily-session--inactive" style="position: absolute; top: ${top}px; height: ${height}px; overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center; font-size: ${fontsize}px" data-height="${height}"><span>${events[i].service_name}</span></div>
                                      `;

                                      $('.visit-box-table-wrapper [data-day="'+events[i].day+'"]').append(tpl);
                                      } else {
                                      var tpl = `
                                        <div class="daily-session daily-session--inactive" style="position: absolute; top: ${top}px; height: ${height}px; overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center; font-size: ${fontsize}px" data-height="${height}"><span>Unavailable</span></div>
                                      `;

                                      $('.visit-box-table-wrapper [data-day="'+events[i].day+'"]').append(tpl);
                                      }


                                      // append mobile

                                      var currentDay = moment().format('YYYY-MM-DD');
                                      var eventDay = events[i].day;
                                      var visible = false;
                                      var show = ' style="display: none;"';
                                      if(currentDay == eventDay) {
                                        visible = true;
                                        show = '';
                                      }

                                      var minDisplay = startMinutes;
                                      if(minDisplay == 0) {
                                        minDisplay = '00';
                                      }

                                    var extStartTime = startHour+':'+minDisplay+' AM';
                                    if(startHour > 12) {
                                      extStartTime = (startHour-12)+':'+minDisplay+' PM';
                                    }
                                      if(startHour == 12) {
                                        extStartTime = startHour+':'+minDisplay+' PM';
                                      }
                    console.log('extstarttime', extStartTime, startTime)
if(customer_tag == 'Sonny-F&F') {
                                      var tpl2 = `<div data-index="${i}" data-day="${dday}" class="daily-session daily-session--mobile-inactive" data-date="${eventDay}" ${show}>
                            <span class="daily-session__time">${extStartTime}</span>
                            <span class="daily-session__title">${events[i].service_name}</span>
                          </div>

                                      `;
                                      $('.visit-box__item--mobile').append(tpl2);
} else {
                                      var tpl2 = `<div data-index="${i}" data-day="${dday}" class="daily-session daily-session--mobile-inactive" data-date="${eventDay}" ${show}>
                            <span class="daily-session__time">${extStartTime}</span>
                            <span class="daily-session__title">Unavailable</span>
                          </div>

                                      `;
                                      $('.visit-box__item--mobile').append(tpl2);
}
                                      

                                  }
                                }
                                setTimeout(function() {
                                  $('.visit-box-loading').removeClass('visit-box-loading');
                                }, 2000);
                              }
                            });
                          }
                        }

    }

                // var filterJson = {
                //   "store_name": 'aime-leon-dore',
                //   "tag": ''
                // }

                // $.ajax({
                //   url: 'https://ald-filter-staging.herokuapp.com/api/onsched/get_events',
                //   type: 'post',
                //   data: JSON.stringify(filterJson),
                //   cache: false,
                //   dataType: 'json',
                //   contentType: 'application/json',
                //   success: function(response) {
                //     console.log('>>>> get events', response);
                //   }
                // });

}




      $('.select-wrapper').on('click', function() {
        $('.ge-switcher-flag').trigger('click');
      });

      // setTimeout(function() {
      //   $('.currencies-from-globale').text($('.ge-switcher-flag a span:last-child').text());
      // }, 2000)

      //pdp scrolling
      if($('body').hasClass('template-product')) {
        $(window).scroll( function() {
          if($(window).width() > 1024) {
            var scrollFactor = $(window).scrollTop();
            var sidebarHeight = $('.desc-wrapper').outerHeight();
            var windowHeight = $(window).height();
            var topMax = 98 + sidebarHeight - windowHeight;
            if(sidebarHeight + 98 > windowHeight) {
              if(scrollFactor - 98 > topMax) {
                $('.desc-wrapper').css('top', -topMax);
              } else {
                $('.desc-wrapper').css('top', 98 - scrollFactor);
              }
            }
          }
        });
      }

      //pdp scrolling issue

      if($('.hero-vintage__image').length) {

        console.log('>>> load products from: ', vintageCollectionsArray);
        for(var i = 0; i < vintageCollectionsArray.length; i++) {
          console.log('>>> load product from: ', vintageCollectionsArray[i]);
          $('[data-name="'+vintageCollectionsArray[i]+'"]').load('/collections/'+vintageCollectionsArray[i]+' .grid-products-vintage-visible > *')
        }

        setTimeout(function() {



        }, 1000);

        $('.vintages-list a').on('click', function() {


          $('.current-collection').removeClass('current-collection');
          $(this).addClass('current-collection');

          var id = $(this).data('id');
          $('.grid-products-vintage-visible').removeClass('grid-products-vintage-visible');
          $('.products-collection').parent().find('> div').eq(parseInt(id)-1).addClass('grid-products-vintage-visible');

          $('.collection-title').hide();
          $('.collection-title-'+id).show();

          var imgHero = '#' + $(this).data('img');
          $('.hero-vintage__image--block.active').removeClass('active');
          $(imgHero).addClass('active');

            // build search location
            var searchString = '?';
            for(var i in vintageCategoriesArray) {
              var categoryName = vintageCategoriesArray[i];
              categoryName = categoryName.replace('&', '--');
              searchString += 'c='+categoryName+'&';
            }
            if(vintageHideSoldOut) {
              searchString += 'sold=true&';
            } else {
              searchString += 'sold=false&';
            }
            if(vintageSortingEnabled) {
              searchString += 'sort=asc&';
              if($('#showall3').prop('checked') || $('#xshowall3').prop('checked')) {
                searchString += 'sort=asc&';
              }
            } else {
              searchString += 'sort_by=false&';
            }
            searchString += 'index='+$('.current-collection').index();

            console.log(searchString);
            window.history.pushState('', '', window.location.protocol+'//'+window.location.host+window.location.pathname+searchString);


          return false;
        });

        $('.vintage-arrow').on('click', function() {
          var height = $(window).height();
          var scrollTop = $(window).scrollTop();
          var scrollAmount = height;
          var scrollTime = 1500

          // alert('st:'+scrollTop+', h:'+height)

          if(Math.ceil(scrollTop) >= height) {
            scrollAmount = 2 * height - 59;
            if(is_touch_enabled()) {
              scrollAmount = 2 * height + 54;
            }
            scrollTime = 750;
          }
          $('body, html').animate({
              scrollTop: scrollAmount
          }, scrollTime)
        });

        $('.header--vintage').on('mouseover', function() {
          $(this).removeClass('header--light');
        });

        $('.header--vintage').on('mouseout', function() {
          var height = $(window).height();
          var scrollTop = $(window).scrollTop();
          if(scrollTop < (2 * height - 60)) {
            $(this).addClass('header--light');
          }
        });


        $(window).on('scroll', function() {
          console.log(vintageArtificialHeader);
          var height = $(window).height();
          var scrollTop = $(window).scrollTop();
          var vlistHeight = $('.vintages-list').outerHeight();

          if(scrollTop > height) {
            $('.hero-vintage__desc').css('opacity', 1);
            $('.hero-vintage__heading').css('opacity', 0);
          } else {
            $('.hero-vintage__desc').css('opacity', scrollTop/height);
            $('.hero-vintage__heading').css('opacity', 1-scrollTop/height);
          }

          if(!vintageArtificialHeader) {
            var vtgHeaderHeight = $('.vintages-list').outerHeight();

            if(scrollTop > (height - 60)) {
              $('.header--vintage').removeClass('header--light');
            } else {
              if(!$('.header--vintage').hasClass('header--light')) {
                $('.header--vintage').addClass('header--light');
                // $('.collection-control').removeClass('collection-control--fixed');
              }
            }

            if(scrollTop > (height - 60 + vlistHeight)) {
              
              $('.collection-control').addClass('collection-control--fixed');
            } else {
              // if(!$('.header--vintage').hasClass('header--light')) {
                // $('.header--vintage').addClass('header--light');
                $('.collection-control').removeClass('collection-control--fixed');
              // }
            }
          }
        });
      }



      $('.pagination-view-all a').on('click', function() {
        var paged = window.location.search.indexOf('?page=') > -1 ? window.location.search.substr(window.location.search.indexOf('?page=')+6, 1) : 1;
        localStorage.setItem('page-view-all', paged);
        localStorage.setItem('page-view-all-last', $('.plp-product:last-child').data('product-id'))
      });

      if(localStorage.getItem('page-view-all') && window.location.search.indexOf('view=all') > -1) {
        var paged = localStorage.getItem('page-view-all');
        var pid = localStorage.getItem('page-view-all-last');
        // if(paged > 1) {
          // console.log($('.plp-product[data-product-id='+pid+']').offset().top);
          $('html, body').scrollTop($('.plp-product[data-product-id='+pid+']').offset().top - 60);
        // }
      }

      aldsec.initiateTimer();
      // aldsec.greyOutInactiveMenuItems();
      if(location.href.indexOf('eu.') == -1) {
        //aldsec.retrieveSwatchDataOnPlp();
        //aldsec.retrieveSwatchDataOnPdp();
      }
      aldsec.enablePopupOnPdpImages();
      aldsec.addProductToCart();
      aldsec.selectProductVariant();
      aldsec.gdpr();

      aldsec.countryModal();
      aldsec.accessibility();
      aldsec.filtering();
    },

    getFilteredProducts: function() {

                var filters = decodeURIComponent(window.location.search.substring(1));
                filters = filters.split('&');
                var soldout = true;
                for(var i in filters) {
                  var filter = filters[i];
                  filter = filter.split('=');
                  var filterKey = filter[0];
                  var filterValue = filter[1];

                  if(filterKey == 'c') {
                    $('[name="'+filterValue+'"]').prop('checked', true);
                    var index = colorsArr.indexOf(filterValue);
                    if (index == -1) {
                      colorsArr.push(filterValue);
                    }
                  } else if(filterKey.indexOf('s.') === 0) {
                    var range = slugToSizeRange(filterKey.substring(2));
                    // Check the right checkbox: match by both name and size_range
                    $('input[data-type="size"][name="'+filterValue+'"][data-size-range="'+range+'"]').prop('checked', true);
                    if (findSizeIndex(sizesArr, filterValue, range) === -1) {
                      sizesArr.push({ name: filterValue, size_range: range });
                    }
                  } else if(filterKey == 'v') {
                    console.log(filterValue, '<<<<<<<<<<<<<<<<')
                    if(filterValue === 'true') {
                      soldout = false;
                      $('#showall').prop('checked', true);
                      $('#xshowall').prop('checked', true);

                      $('#showall4').prop('checked', true);

              $('#showall').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
              $('#showall').closest('.filter-custom-checkbox').addClass('blocked-label');
              $('#showall4').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
              $('#showall4').closest('.filter-custom-checkbox').addClass('blocked-label');
                    }
                  } else if(filterKey == 'ss') {
                    if(filterValue === 'true') {
                      // sale only - the toggle hides sold out products while it is on,
                      // so restore both parts of that state
                      $('#showsale').prop('checked', true);
                      $('#showsale7').prop('checked', true);
                      soldout = false;
                    }
                  }


                }

        if(window.location.href.indexOf('v=') > -1) {
          if(localStorage.getItem('mysizesenabled') === '1') {


            var completeUserSizes = [];

              getUserSizeCategories().forEach(function(category) {
                splitUserSizes(category.raw).forEach(function(value) {
                  completeUserSizes.push(value);
                });
              });

            console.log('sizesArr >>', sizesArr, completeUserSizes);

            if(sizesArr.length == completeUserSizes.length) {
                          $('#selectedSizes2').prop('checked', true);
              $('#selectedSizes1').prop('checked', true);
            }

          }
        }

                var showsales = false;
                if($('#showsale').prop('checked') || $('#showsale7').prop('checked')) {
                  showsales = true;
                }

                var store = 'aime-leon-dore';
                if(window.location.host.indexOf('eu') > -1) {
                  store = 'aime-leon-dore-eu';
                }
                if(window.location.host.indexOf('dev') > -1) {
                  store = 'aime-leon-dore-dev-store';
                }
                if(window.location.host.indexOf('eu-dev') > -1) {
                  store = 'aime-leon-dore-eu-dev';
                }

                var filterJson = {
                  "store_name":store,
                  "collection": coll[2],
                  "sizes": sizesArr,
                  "colors": colorsArr,
                  "display_sold_out": soldout,
                  'for_sales': showsales,
                  "iso_code": Shopify.country
                }

                if(window.location.host.indexOf('eu') > -1) {
                  var locationId = 50003247253;
                  if($('body').attr('data-country') == 'GB') {
                    locationId = 74146152597;
                  }

                  var filterJson = {
                    "store_name":store,
                    "collection": coll[2],
                    "sizes": sizesArr,
                    "colors": colorsArr,
                    "display_sold_out": soldout,
                    'for_sales': showsales,
                    "iso_code": Shopify.country,
                    "location_id": locationId
                  }
                }

                if(window.location.host.indexOf('eu-dev') > -1) {
                  var locationId = 53200584866;
                  if($('body').attr('data-country') == 'GB') {
                    locationId = 70879314089;
                  }

                  var filterJson = {
                    "store_name":store,
                    "collection": coll[2],
                    "sizes": sizesArr,
                    "colors": colorsArr,
                    "display_sold_out": soldout,
                    'for_sales': showsales,
                    "iso_code": Shopify.country,
                    "location_id": locationId
                  }
                }

                if(window.location.href.indexOf('price') > -1) {
                  filterJson['sort_type'] = 'price'
                }
                if(window.location.href.indexOf('created') > -1) {
                  filterJson['sort_type'] = 'created_at'
                }

                if(window.location.href.indexOf('descending') > -1) {
                  filterJson['sort_order'] = 'desc'
                }
                if(window.location.href.indexOf('ascending') > -1) {
                  filterJson['sort_order'] = 'asc'
                }

                // console.log('ga','Select Filter ' + type,'Filter value: '+val)
                // ga('send','event','Filtering','Select Filter ' + type,'Filter value: '+val);
                remainingProductsFromFilters = [];

                var filtersUrl = 'https://ald-filter-staging.herokuapp.com/api/filter_products_paginated';

                let params = new URLSearchParams(document.location.search);
                let filtersPage = params.get('page');
                if(filtersPage === null) {
                  filtersPage = 1;
                }

                filterJson['pagination'] = {'page': filtersPage}

                if(window.location.search.length > 0) {
                  showCollectionLoader();
                }
                console.log('pagination 1');

                $('.next-category-container').hide();
                $('html, body').scrollTop(0);

                $.ajax({
                  url: filtersUrl,
                  type: 'post',
                  data: JSON.stringify(filterJson),
                  cache: false,
                  dataType: 'json',
                  contentType: 'application/json',
    
                  success: function(response) {
          $('.loading-filters').remove();

                
                if(response.number_of_pages == 1 || response.number_of_pages == response.page_number) {
                  $('.products-collection').css('padding-bottom', '60px');
                  $('.next-category-container').show();
                }

                    $('.collection-title sup').text(response.length);

                    $('.products-collection.grid-products > .plp-product').remove();

                    hideCollectionLoader();

                    $('.products-collection.grid-products').removeClass('loading-products-patch');


                    var products = withValidLocalPrice(response.products);

                    for(var i in products) {
                  $('#response-length').text(products.length);
if(i < 64) {
                      var soldout = '';
                      var colorsAvailable = '';
                      if(products[i].swatch_count === '1') {
                        colorsAvailable = "1 Color Available";
                      } else {
                        colorsAvailable = products[i].swatch_count+" Colors Available";


                        if(products[i].swatch_count === null) {
                          colorsAvailable = '';
                        }
                      }
                      if(products[i].sold_out) {
                        soldout = '<div class="plp-product__tag">SOLD OUT</div>';
                      }

                      var dataFP = '';
                      if(products[i].metafields != null) {
                        var metaLength = products[i].metafields.length;
                        dataFP = 'data-fp="'+products[i].metafields[0]['data-fp']+'"';
                        if(metaLength > 1) {
                          if(dataFP == 'data-fp=""') {
                            dataFP = 'data-fp="'+products[i].metafields[1]['data-fp']+'"';
                          }
                        }
                      }
                      dataFP = dataFP.replace(/\s/g, '');

                      var customTagSupress = '';
                      if(products[i].metafields != null) {
                        var metaLength = products[i].metafields.length;
                        if(products[i].metafields[0]['custom_tag_name_text']) {
                          customTagSupress = products[i].metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(products[i].metafields[1]['custom_tag_name_text']) {
                            customTagSupress = products[i].metafields[1]['custom_tag_name_text'];  
                          }
                        }

                        
                      }
                      console.log('customtagsupress', customTagSupress);

                      var price = products[i].local_price.price + '';
                      // if(price.length == 6) {
                      //   price = price.charAt(0) + price.charAt(1) + price.charAt(2) + ',' + price.charAt(3) + price.charAt(4) + price.charAt(5);
                      // }
                      // if(price.length == 5) {
                      //   price = price.charAt(0) + price.charAt(1) + ',' + price.charAt(2) + price.charAt(3) + price.charAt(4);
                      // }
                      // if(price.length == 4) {
                      //   price = price.charAt(0) + ',' + price.charAt(1) + price.charAt(2) + price.charAt(3);
                      // }
                      // price = price;
                      var compareAtPrice = '';
                      if(!!products[i].local_price.compare_at_price && !products[i].sold_out) {
                        if(products[i].local_price.compare_at_price > products[i].local_price.price) {
var clocalizedString = Shopify.locale+'-'+Shopify.country;
var clocalizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: products[i].local_price.currency, maximumFractionDigits: 0}).format(products[i].local_price.compare_at_price)

clocalizedPriceWithSymbol = formatPrice(products[i].local_price.compare_at_price, products[i].local_price.currency);

                    compareAtPrice = '<s class="product__price product__price--sale"  style="font-size: inherit">'+clocalizedPriceWithSymbol+'</s>';
                        }
                      }
console.log('comapreatprice', compareAtPrice, '<<<<<<<<<<<<<<<<<<<<<<<<');

                      var imgToDisplay = products[i].images[1] ? products[i].images[1].url : products[i].image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in products[i].images) {
    if(j > 0) {
      if(products[i].images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" style="display: none" loading="lazy"></div></li>';
        } else {
                                  if(i >= 64) {
                                    imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';
                                  } else {
                                    imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';
                                  }
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}
                      var product = products[i];
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$' + price;

          var customTag = '';
          var additionalClassWide = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);

            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
              
            // }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            customTag = getOverImageBadges(product);
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            

            if(product.tags.indexOf('dev-product-wide-plp') > -1) {
              additionalClassWide = ' product-image-wide';
              soldOutHTML = widePlp;
            }
          }
var displayIt = true;
if(product.tags.indexOf('dev-product-wide-plp') > -1) {
  if(sizesArr.length > 0 || colorsArr.length > 0) {
    displayIt = false;
  }
  
  imgToDisplay = '';
  for(var j in products[i].images) {
    var wideProductImgClass = '';
    if(products[i].images[j].alt != null) {
      if(products[i].images[j].alt.indexOf('dev-wide-plp') > -1) {
        if(products[i].images[j].alt == 'dev-wide-plp-1') {
          wideProductImgClass = ' product-image--oc';
        }
        if(products[i].images[j].alt == 'dev-wide-plp-2') {
          wideProductImgClass = ' product-image--tc';
        }
        if(products[i].images[j].alt == 'dev-wide-plp-4') {
          wideProductImgClass = ' product-image--fc';
        }

        imgToDisplay += '<img src="'+products[i].images[j].url+'" alt="" class="product-wide'+wideProductImgClass+'">';
      }
    }
  }



}

var localizedString = Shopify.locale+'-'+Shopify.country;
var localizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: products[i].local_price.currency, maximumFractionDigits: 0}).format(products[i].local_price.price)

localizedPriceWithSymbol = formatPrice(products[i].local_price.price, products[i].local_price.currency);

  if(window.location.href.indexOf('end-of-season-sale') > -1) {
    if(!!products[i].local_price.compare_at_price) {
    if(products[i].local_price.compare_at_price == products[i].local_price.price) {
      displayIt = false;
    }
    }
  }

if(displayIt) {
      const createdAtStr = products[i]?.created_at;
      const createdAtMs = new Date(createdAtStr).getTime(); 
      let hasNewArrivals = false;
      if (products[i].tags && products[i].tags.indexOf('newarrivals') !== -1) {
        hasNewArrivals = true;
      }
      let shouldHidePrice = false;
      if (products[i].tags && products[i].tags.indexOf('dev-hide-product-price') !== -1) {
        shouldHidePrice = true;
      }

      var customHidingStyle = '';
      if(i >= 64) {
        customHidingStyle = ' style="display: none"';
      }

      if(product.tags.indexOf('dev-non-us-oos') > -1) {

        if(Shopify.country !== 'US') {
          for(const i in product.metafields) {
            if(product.metafields[i]['non_us_oos_label'] !== undefined) {
              localizedPriceWithSymbol = product.metafields[i]['non_us_oos_label']
            }
          }
        }
      }

      // sold out products show their status label instead of the price
      if(product.sold_out) {
        localizedPriceWithSymbol = soldOutHTML;
      }

      $('.products-collection.grid-products').append(`<a href="/products/${products[i].handle}" class="plp-product ${additionalClassWide} ${shouldHidePrice ? 'plp-product--hide-price' : ''}" data-product-id="4798156800097" data-price="${price}" data-title="${products[i].title}" data-created-at="${createdAtMs}" data-newarrival="${hasNewArrivals}" data-index="${i}" ${customHidingStyle}>

                  <div class="image-4-5 product-image">
                    ${customTag}
                    ${imgToDisplay}
                  </div>
            <div class="temp-fix-scaling"></div>
                  <div class="short-desc plp-product__details">

                    <h3 class="plp-product__title">${products[i].title}</h3>
                    <div class="plp-product__price ${ (products[i].local_price.compare_at_price > price && !products[i].sold_out) ? 'plp-product__price--compare' : ''}">

                      <span style="display: none;" class="money xxx2money" ${dataFP} data-currency-usd="${price}" data-currency="USD" data-ge-price  style="visibility: visible;">${ soldOutHTML }</span>
                      <span style="display: none;">${compareAtPrice}</span>
                      <span class="money">${ localizedPriceWithSymbol }</span>
                      ${compareAtPrice}
                    </div>
                  </div>
                </a>`)
              }
                    }
                    }

                    // build pagination
                    $('html, body').scrollTop(0);
                    if(response.number_of_pages > 1) {
                      $('.container .pagination').remove();
                      var paginationOutput = '';
                      var prevArrowOutput = '';
                      var nextArrowOutput = '';
                      var pagesOutput = '';

                      if(response.page_number == 1) {
                        prevArrowOutput = `
                          <span class="prev pagination-disabled">
                            <a></a>
                          </span>`;
                      } else {
                        prevArrowOutput = `
                          <span class="prev">
                            <a href="#" data-searchpage="${response.page_number - 1}"></a>
                          </span>`;
                      }

                      if(response.page_number == response.number_of_pages) {
                        nextArrowOutput = `
                          <span class="next pagination-disabled">
                            <a></a>
                          </span>`;
                      } else {
                        nextArrowOutput = `
                          <span class="next">
                            <a href="#" data-searchpage="${response.page_number + 1}"></a>
                          </span>`;
                      }

                      // for(let i = 1; i <= response.number_of_pages; i++) {
                      //   let numberDisplay = i;
                      //   if(i < 10) {
                      //     numberDisplay = '0'+i;
                      //   }
                      //   if(i == (response.page_number)) {
                      //     pagesOutput += `
                      //       <span class="page current">${numberDisplay}</span>`;
                      //   } else {
                      //     pagesOutput += `
                      //       <span class="page">
                      //         <a href="#" data-searchpage="${i}">${numberDisplay}</a>
                      //       </span>`;          
                      //   }
                      // }

                      var displayPages = getPagination(response.page_number, response.number_of_pages);

console.log('pagination results 2', response.page_number, response.number_of_pages)

                      for(let i = 0; i < displayPages.length; i++) {
                        let numberDisplay = displayPages[i];
                        if(numberDisplay < 10) {
                          numberDisplay = '0'+numberDisplay;
                        }
                        if(response.page_number == displayPages[i]) {
                          pagesOutput += `
                            <span class="page current">${numberDisplay}</span>`;
                        } else {
                          if(displayPages[i] == '...') {
                            pagesOutput += `<span class="page">...</span>`;
                          } else {
                            pagesOutput += `
                              <span class="page">
                                <a href="#" data-searchpage="${displayPages[i]}">${numberDisplay}</a>
                              </span>`;    
                          }
                        }
                      }

                      paginationOutput = `
                        <div class="pagination pagination-plp">
                          ${prevArrowOutput}
                          ${pagesOutput}
                          ${nextArrowOutput}
                        </div>`;

                      $('.main-wrapper .container').append(paginationOutput);
                    }

                    if(typeof sortProducts === 'function') {
                      sortProducts();
                    }
                    console.log('manage state 0.1', window.location.search);
                    aldsec.filteringShowHideActive();

                    if(scrollToTopAfterFilters) {
                      scrollToTopAfterFilters = false;
                      $('html, body').scrollTop(0);
                    } else {
                      // set position based on ls
                      $('html, body').scrollTop(localStorage.getItem('persistentTop'));
                    }

                  }
                });
    },

    initiateTimer: function() {
      if($('.top-bar, .nav__location').length) {
        aldsec.runTimer();
      }
    },

    runTimer: function() {
      setTimeout(function() {
        var currentDate = moment().tz('America/New_York').format('dddd, MMMM DD, YYYY');
        var currentTime = moment().tz('America/New_York').format('HH:mm');
        $('.top-bar').html('Queens, NY | '+currentDate+' <span class="d-none d-lg-block">&nbsp;| '+currentTime+' EST</span>');
        $('.nav__location').text('Queens, NY | '+currentDate+' | '+currentTime+' EST');
        aldsec.runTimer();
      }, 1000);
    },

    greyOutInactiveMenuItems: function() {
      $('.main-nav .submenu__item').on('mouseover', function() {
        $(this).siblings().addClass('greyed-out-menu-item');
      });

      $('.main-nav .submenu__item').on('mouseout', function() {
        $(this).siblings().removeClass('greyed-out-menu-item');
      });
    },

    retrieveSwatchDataOnPlp: function() {
      if($('.collection-control').length) {
        $('.plp-product').each(function() {
          var currentElement = $(this);
          var id = $(this).data('product-id');

          var appDomain = 'https://www.aimeleondore.com';
          var url = appDomain + '/apps/swatches?id='+id+'&shop=aime-leon-dore.myshopify.com&group=';
          $.ajax({
            type: 'get',
            url: url,
            cache: false,
            dataType: "json",
            success: function(data) {
              if(data.result[0]) {
                currentElement.find('.plp-product__variants').text(data.result[0].swatches.length+' Colors Available');
              } else {
                currentElement.find('.plp-product__variants').text('1 Color Available');
              }
            }
          });

        });
      }
    },

    retrieveSwatchDataOnPdp: function() {
      if($('.product__variants--colors').length) {
        var currentElement = $('.product__variants');
        var id = currentElement.data('product-id');

        var appDomain = 'https://www.aimeleondore.com';
        var url = appDomain + '/apps/swatches?id='+id+'&shop=aime-leon-dore.myshopify.com&group=';
        $.ajax({
          type: 'get',
          url: url,
          cache: false,
          dataType: "json",
          success: function(data) {
            if(data.result[0]) {
              currentElement.find('.product__variants-count').text('('+(data.result[0].swatches.length)+')');

              for(var i in data.result[0].swatches) {
                if(data.result[0].swatches[i].id != id) {
                  var el = data.result[0].swatches[i];
                  currentElement.find('.swiper-wrapper').append(`
                    <a href="${el.url}" class="swiper-slide swatch-colors__item">
                      <div class="image-4-5 product-image">
                        <img src="${el.featuredImage}" />
                      </div>
                    </a>`);
                } else {
                  var el = data.result[0].swatches[i];
                  currentElement.find('.swiper-wrapper').append(`
                    <a href="${el.url}" class="swiper-slide swatch-colors__item swatch-colors__item--selected">
                      <div class="image-4-5 product-image">
                        <img src="${el.featuredImage}" />
                      </div>
                    </a>`);
                }
              }

              currentElement.show();
              $('.product__variants--colors').show();
              window.dispatchEvent(new Event('resize'));
            }
          }
        });
      }
    },

    enablePopupOnPdpImages: function() {
      // The popup images ship with their sources in data-* (see product-template.liquid) so a
      // PDP view does not pay for full-res zoom assets nobody has asked for yet. Hydrate them
      // on first open; the width/height attributes mean the layout box is already correct, so
      // the scrollTop() below still lands on the right image.
      function hydratePopupImages() {
        $('.product-image-popup img[data-src]').each(function() {
          var $img = $(this);
          if ($img.data('srcset')) { $img.attr('srcset', $img.data('srcset')); }
          if ($img.data('sizes')) { $img.attr('sizes', $img.data('sizes')); }
          $img.attr('src', $img.data('src'));
          $img.removeAttr('data-src').removeAttr('data-srcset').removeAttr('data-sizes');
        });
      }

      $('.product__image-item, .product__images-item').on('click', function() {
        if($(window).width() > 1024) {
          hydratePopupImages();
          $('.pdp-recommendations').hide();
          $('.pdp.product').attr('style', 'display: none !important');
          $('.container-wrapper').attr('style', 'padding-top: 0 !important');
          $('.container.footer, .header, .announcement_bar').attr('style', 'display: none !important');
          $('.product-image-popup').show();
          var idx = $(this).data('index');
          $(window).scrollTop($('.image-popup-'+idx).offset().top);
        }
        return false;
      });

      $('.product-image-popup__close').on('click', function() {
        $('.pdp-recommendations').show();
        $('.pdp.product').removeAttr('style');
        $('.container-wrapper').removeAttr('style');
        $('.container.footer, .header, .announcement_bar').removeAttr('style');
        $('.product-image-popup').hide();
        $(window).scrollTop(0);
        return false;
      });
    },

    addProductToCart: function() {
      
      if($('body').hasClass('page-aime-leon-dore-gift-card')) {
        $('.Rise-popup-backdrop').parent().remove();
        
        $('#add-item-form input').on('mouseover', function() {
          console.log('?');
        $('.Rise-popup-backdrop').parent().remove();
//           $(this).off('keyup');
//           if (e.key === 'Enter' || e.keyCode === 13) {
//             return false;
//           }
        });
      }

      $('#add-item-form').on('submit', function() {
        if($('#notify_email').is(':visible')) {
          $('#notify').trigger('click');
          return false;
        } else {
        var action = $(this).attr('action');
        var datax = $(this).serialize();
        // old template
        var anySelectedVariant = $('.swatch-size__control:checked').length === 0 ? false : true;

        // new template
        if($('.swatch-size select').length) {
          anySelectedVariant = $('.swatch-size select').val() == '' ? false : true;

          if(!anySelectedVariant) {
            $('.swatch-size').addClass('select-error');
          } else {
            $('.swatch-size').removeClass('select-error');
          }
        }

        // if($('#add-submit').is(':visible')) {
        //   var anySelectedVariant = true;
        // }

        $('.atc-error').removeClass('atc-error');

        if($('body').hasClass('page-aime-leon-dore-gift-card')) {
          anySelectedVariant = true;
        }

if($('#egiftcard').hasClass('activebtn')) {
        var date = $('#egcdate').val();
  if($('.form-giftcard-desktop').is(':visible')) {
    date = $('#egcdate2').val();
  }
        date = date.split('/');
        date = date[2]+'-'+date[0]+'-'+date[1];

        var time = $('#time').val();
        var timezone = $('#timezone').val();
      
        const combinedDateTime = moment.tz(`${date} ${time}`, "YYYY-MM-DD hA", timezone);
        const formattedUTCTime = combinedDateTime.clone().utc().format();


        var giftid = '';

        var formValid = true;

        $('.label-error').removeClass('label-error')
        $('.input-error').removeClass('input-error')
        $('.error-button').removeClass('error-button')

        if($('#egcvalues').is(':visible')) {
          console.log($('#egcvalues select').val());
          if($('#egcvalues select').val() != '') {
            $('#egcvalues').removeClass('select-error');
          } else {
            $('#egcvalues').addClass('select-error');
            formValid = false;
          }

          if($('.form-giftcard-desktop').is(':visible')) {
            console.log('desktop')
            $('.form-giftcard-desktop input, .form-giftcard-desktop textarea').each(function() {
              if($(this).val() == '') {
                formValid = false;
                $(this).addClass('input-error');
                $(this).prev().addClass('label-error');
              }
            });

            if(($('#egcemail2').val() == '' || $('#egcemailc2').val() == '') || $('#egcemail2').val() != $('#egcemailc2').val()) {
              $('#egcemail2, #egcemailc2').addClass('input-error');
              $('#egcemail2, #egcemailc2').prev().addClass('label-error');
              formValid = false;
            }

            var validateEmail = function (email) {
              return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
            }
            
            if(!validateEmail($('#egcemail2').val())) {
              $('#egcemail2, #egcemailc2').addClass('input-error');
              $('#egcemail2, #egcemailc2').prev().addClass('label-error');
              formValid = false;
            }

            console.log('desktop', formValid)
            if(formValid) {
              $('#egcname').val($('#egcname2').val());
              $('#egcmess').val($('#egcmess2').val());
              $('#egcdate').val($('#egcdate2').val());
              $('#egcemail').val($('#egcemail2').val());
              $('#egcemailc').val($('#egcemailc2').val());
            }
          } else {
            //formValid = false;
          }


          console.log('>> egc hello');
        }


        // Rise.ai no longer needs a pre-created gifting session. Gift details are
        // passed as line item properties on the cart line (see edits below).


        // var formValid = true;

        // $('.input-error').removeClass('input-error')
        // $('.error-button').removeClass('error-button')

        if($('.egcname').val() == '') {
          $('.egcname').addClass('input-error');
          $('.egcname').prev().addClass('label-error');
          formValid = false;
        }

        if($('.egcdate').val() == '') {
          $('.egcdate').addClass('input-error');
          $('.egcdate').prev().addClass('label-error');
          formValid = false;
        }

        var currentDate = moment();
        var giftCardDate = moment(date, 'YYYY-MM-DD');
        if(giftCardDate.isBefore(currentDate, 'day')) {
          $('.egcdate').addClass('input-error');
          formValid = false;
        }

        if($('.egcmess').val() == '') {
          $('.egcmess').addClass('input-error');
          $('.egcmess').prev().addClass('label-error');
          formValid = false;
        }

        if(($('.egcemail').val() == '' || $('.egcemailc').val() == '') || $('.egcemail').val() != $('.egcemailc').val()) {
          $('.egcemail, .egcemailc').addClass('input-error');
          $('.egcemail, .egcemailc').prev().addClass('label-error');
          formValid = false;
        }
        
        var validateEmail = function (email) {
          return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
        }

        if(!validateEmail($('.egcemail').val())) {
          $('.egcemail, .egcemailc').addClass('input-error');
          $('.egcemail, .egcemailc').prev().addClass('label-error');
          formValid = false;
        }

        var currentDate = moment();
        var giftCardDate = moment(date);
        if(giftCardDate.isBefore(currentDate, 'day')) {
          $('#egcdate2').addClass('input-error');
          $('#egcdate2').prev().addClass('label-error');
          formValid = false;
        }

        // if($('#egcvalues .activebtn').not('.gwbutton').length === 0) {
        //   $('#egcvalues .value-button').addClass('error-button')
        //   formValid = false
        // }

        if($('#gcvalues').is(':visible')) {
          console.log('gcvalues sel', $('#gcvalues select').val());

          if($('#gcvalues select').val() != '') {
            $('#gcvalues').removeClass('select-error');
          } else {
            $('#gcvalues').addClass('select-error');
          }
          formValid = false;
        }

        if(formValid) {

          // Rise.ai auto-gifting via line item properties — no API call needed.
          // Rise detects the _recipient_*/_gift_* line item properties on the order
          // and sends the gift card automatically (see Rise "Custom Gift Card PDP" doc).
                  var jsonData = JSON.stringify({
                    id: $('#add-item-form input[name="id"]').val(),
                    quantity: $('#add-item-form input[name="quantity"]').val(),
                    properties: {
                      'Delivering on': $('#add-item-form input[name="properties[send_at]"]').val(),
                      'Time': $('#add-item-form input[name="properties[time]"]').val(),
                      'Timezone': $('#add-item-form input[name="properties[timezone_name]"]').val(),
                      'Delivered via email to': $('#egcemail').val(),
                      // Rise.ai reads these hidden properties to auto-send the gift card:
                      '_recipient_name': $('#egcname').val(),
                      '_recipient_email': $('#egcemail').val(),
                      '_gift_message': $('#egcmess').val(),
                      '_gift_send_at': formattedUTCTime,
                      '_gift_image': 'https://assets.rise-ai.com/static/7ce2d753f0384c7e833d724587d83e34.png'
                    }
                  });


                          $.ajax({
                            url: $('#add-item-form').attr('action'),
                            type: 'POST',
                            contentType: 'application/json',
                            data: jsonData,
                            success: function(response) {
                              var count = $('.cart-count').text();
                              // count = count.substring(1, count.length - 1);
                              count = parseInt(count) + 1;

                              
                              
                              if(increaseCounter) {
                                $('.cart-count').text(count);
                                if(limitedQty) {
                                  increaseCounter = false;
                                }
                              }

                              if($('.atc-box').hasClass('atc-box-reserved')) {
                                $('#add-submit').text('Product reserved');
                              } else {
                                $('#add-submit').text('Product added to bag');
                              }
                              $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

                              $('.cart-ic').addClass('active-cart');
                              $('.navbar').addClass('navbar--active-cart');

                              // if(raffle) {
                              //    productVariantCount++;
                              // }

                              if($('.atc-box').hasClass('atc-box-reserved')) {
                                setTimeout(function() {
                                  $('#add-submit').text('Reserve');
                                  $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                                }, 2500);
                              } else {
                                setTimeout(function() {
                                  $('#add-submit').text('Add To Bag');
                                  $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                                }, 2500);
                              }

                              if($('body').hasClass('page-aime-leon-dore-gift-card')) {
                                $('.form-group input:not(".egcdate"), .form-group textarea').val('')
                              }
                            },
                            error: function(data){
                              alert('No more units available.');
                            }
                          });
        } else {
          return false;
        }

    } else {

        if($('#regulargiftcard').length) {
          if($('#regulargiftcard').hasClass('activebtn')) {
            // if($('#gcvalues .activebtn').not('.gwbutton').length === 0) {
            //   $('#gcvalues .value-button').addClass('error-button')
            //   anySelectedVariant = false
            // }

              if($('#gcvalues select').val() != '') {
                $('#gcvalues').removeClass('select-error');
              } else {
                $('#gcvalues').addClass('select-error');
              formValid = false;
              anySelectedVariant = false
            }
          }  
        }


        if(!anySelectedVariant) {
          $('.swatch-size__item').not('.swatch-size-unavailable').addClass('atc-error');
          $('form .product-variants-title').addClass('atc-error');
        } else {

          var goforward = true;
          if(raffle) {
            if(nonraffleCount > 0) {
              goforward = false;
              $('.raffle-overlay, .raffle-mismatch').show();
            } else if(!thisRaffleProduct && raffleCount > 0) {
              goforward = false;
              $('.raffle-overlay, .raffle-mismatch-regular').show();
            } else if($('.swatch-size select').val() == '') {
              goforward = false;
              $('.raffle-overlay, .raffle-select-size').show();
            }
            // if(productVariantCount > 0) {
            //   goforward = false;
            //   $('.raffle-overlay, .raffle-limit').show();
            // }

            if(goforward) {

console.log('add to cart? 2');
              if(productWithQuantityLimit) {

              } else {

              $.ajax({
                url: '/cart.js',
                type: 'GET',
                dataType: 'json',
                success: function(response) {
                  console.log(response);
                  var lineitems = response.items;
                  var goforwardnext = true;
                  if(lineitems.length > 0) {
                    for(var i in lineitems) {
                      if(lineitems[i].product_id == $('#prodid').val()) {
                        goforwardnext = false;
                        if(productLimit === 1) {
                          $('.raffle-overlay, .raffle-limit').show();
                        } else {
                          $('.raffle-overlay, .raffle-limit-vip').show();
                        }
                      }
                    }
                    if(goforwardnext && productLimit === 1) {
                      goforwardnext = false;
                      $('.raffle-overlay, .raffle-limit').show();
                    }
                  }
                  console.log('>>', goforwardnext);
                  if(goforwardnext) {
                    $.ajax({
                      url: action,
                      type: 'POST',
                      dataType: 'json',
                      data: datax,
                      success: function(response) {
                        var count = $('.cart-count').text();
                        // count = count.substring(1, count.length - 1);
                        count = parseInt(count) + 1;

                        
                              
                        if(increaseCounter) {
                          $('.cart-count').text(count);
                          if(limitedQty) {
                            increaseCounter = false;
                          }
                        }

                        if($('.atc-box').hasClass('atc-box-reserved')) {
                          $('#add-submit').text('Product reserved');
                        } else {
                          $('#add-submit').text('Product added to bag');
                        }
                        
                        $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

                        $('.cart-ic').addClass('active-cart');
                        $('.navbar').addClass('navbar--active-cart');

                        // if(raffle) {
                        //    productVariantCount++;
                        // }
                        if($('.atc-box').hasClass('atc-box-reserved')) {
                          setTimeout(function() {
                            $('#add-submit').text('Reserve');
                            $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                          }, 2500);
                        } else {
                          setTimeout(function() {
                            $('#add-submit').text('Add To Bag');
                            $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                          }, 2500);
                        }
                      },
                      error: function(data){
                        alert('No more units available.');
                      }
                    });
                  }
                }
              });
                
              }
            }

          } else {

console.log('add to cart? 1');

if($('#pendant-price').length) {
  console.log('hello ajax')

  // add pendant
  $.ajax({
    url: $(this).attr('action'),
    type: 'POST',
    dataType: 'json',
    data: $(this).serialize(),
    success: function(response) {
      var count = $('.cart-count').text();
      // count = count.substring(1, count.length - 1);
      count = parseInt(count) + 1;

      if(increaseCounter) {
        $('.cart-count').text(count);
        if(limitedQty) {
          increaseCounter = false;
        }
      }

      if($('.atc-box').hasClass('atc-box-reserved')) {
        $('#add-submit').text('Product reserved');
      } else {
        $('#add-submit').text('Product added to bag');
      }
      $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

      $('.cart-ic').addClass('active-cart');
      $('.navbar').addClass('navbar--active-cart');

      // add chain
      var normalizeJewelryAttr = function(value) {
        if (!value) {
          return '';
        }
        return String(value)
          .split('//')
          .filter(function(entry) { return entry && entry.trim() !== ''; })
          .join('//');
      };

      var currentPair = $('#product-form-id').val() + '::' + chainId;
      var baseAttr = normalizeJewelryAttr(jewelryAtrributes);
      var updatedAttr = baseAttr ? (baseAttr + '//' + currentPair) : currentPair;

      if(chainId != 0) {

        var chainData = {
          quantity: 1,
          id: chainId,
          note: $('#product-form-id').val() + '::' + chainId,
          attributes: {
            'jewelry': updatedAttr
          }
        }

        $.ajax({
          url: '/cart/add',
          type: 'POST',
          dataType: 'json',
          data: chainData,
          success: function(response) {
            
            jewelryAtrributes = updatedAttr;

            if($('.atc-box').hasClass('atc-box-reserved')) {
              setTimeout(function() {
                $('#add-submit').text('Reserve');
                $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
              }, 2500);
            } else {
              setTimeout(function() {
                $('#add-submit').text('Add To Bag');
                $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
              }, 2500);
            }
            
            
          },
          error: function(data){
            alert('No more units available.');
          }
        });

      } else {
        $.ajax({
          url: '/cart/update.js',
          data: 'attributes[jewelry]=' + updatedAttr,
          method: 'POST',
          async: false,
          dataType: 'json',
          cache: false,
          success: function() {
            jewelryAtrributes = updatedAttr;

            
          }
        });


          if($('.atc-box').hasClass('atc-box-reserved')) {
            setTimeout(function() {
              $('#add-submit').text('Reserve');
              $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
            }, 2500);
          } else {
            setTimeout(function() {
              $('#add-submit').text('Add To Bag');
              $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
            }, 2500);
          }
      }

    },
    error: function(data){
      alert('No more units available.');
    }
  });

} else {

console.log('add to cart? 3');
var formElement = $(this);

if(productWithQuantityLimit) {
  var currentProductId = $('#prodid').val();
  var totalSum = 0;
console.log('qty-limit 1');
$.getJSON('/cart.js', function(cart) {
  console.log('qty-limit 2', cart);
  console.log('qty-limit 3', cart.items); // array of cart items
  var lineitems = cart.items;
  for(var i in lineitems) {
    if(lineitems[i].product_id == currentProductId) {
      totalSum = totalSum + lineitems[i].quantity;
    }
  }
  console.log('qty-limit 3.5 ', totalSum, productQuantityLimit);
  if(totalSum < productQuantityLimit) {
    console.log('qty-limit 4', formElement.serialize());
              $.ajax({
                url: formElement.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: formElement.serialize(),
                success: function(response) {
                  var count = $('.cart-count').text();
                  // count = count.substring(1, count.length - 1);
                  count = parseInt(count) + 1;
                  
                  
                  
                  if(increaseCounter) {
                    $('.cart-count').text(count);
                    if(limitedQty) {
                      increaseCounter = false;
                    }
                  }

                  if($('.atc-box').hasClass('atc-box-reserved')) {
                    $('#add-submit').text('Product reserved');
                  } else {
                    $('#add-submit').text('Product added to bag');
                  }
                  $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

                  $('.cart-ic').addClass('active-cart');
                  $('.navbar').addClass('navbar--active-cart');

                  // if(raffle) {
                  //    productVariantCount++;
                  // }

                  if($('.atc-box').hasClass('atc-box-reserved')) {
                    setTimeout(function() {
                      $('#add-submit').text('Reserve');
                      $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                    }, 2500);
                  } else {
                    setTimeout(function() {
                      $('#add-submit').text('Add To Bag');
                      $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                    }, 2500);
                  }

                  if($('body').hasClass('page-aime-leon-dore-gift-card')) {
                    $('.form-group input, .form-group textarea').val('')
                  }
                },
                error: function(data){
                  alert('No more units available.');
                }
              });
  } else {
    alert('You have reached maximum quantity for this product per customer.')
  }
});
} else {

              $.ajax({
                url: formElement.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: formElement.serialize(),
                success: function(response) {
                  var count = $('.cart-count').text();
                  // count = count.substring(1, count.length - 1);
                  count = parseInt(count) + 1;
                  
                  
                  
                  if(increaseCounter) {
                    $('.cart-count').text(count);
                    $('#mobile-quickcart-view-cart').text('View Cart ('+count+')')
                    if(limitedQty) {
                      increaseCounter = false;
                    }
                  }

                  $('.extra-desc div').text(response.variant_title)

                  if($('.atc-box').hasClass('atc-box-reserved')) {
                    $('#add-submit').text('Product reserved');
                  } else {
                    $('#add-submit').text('Product added to bag');
                  }
                  $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

                  $('.cart-ic').addClass('active-cart');
                  $('.navbar').addClass('navbar--active-cart');

                  // if(raffle) {
                  //    productVariantCount++;
                  // }

                  if($('.atc-box').hasClass('atc-box-reserved')) {
                    setTimeout(function() {
                      $('#add-submit').text('Reserve');
                      $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                    }, 2500);
                  } else {
                    setTimeout(function() {
                      $('#add-submit').text('Add To Bag');
                      $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
                    }, 2500);
                  }

                  if($('body').hasClass('page-aime-leon-dore-gift-card')) {
                    $('.form-group input, .form-group textarea').val('')
                  }
                },
                error: function(data){
                  alert('No more units available.');
                }
              });
  
}

}



          }
        }
}
        }

        return false;
      });
    },

    selectProductVariant: function() {
      $('.swatch-size__item').on('click', function() {
        $('.atc-error').removeClass('atc-error');

        if($(this).hasClass('swatch-size-unavailable')) {
          $('#add-submit').hide();
          $('.notify').show();
          $('#notify_email').removeAttr('disabled');
          $('#product-form-id').val($(this).find('input').val());
        } else {
          $('#add-submit').show();
          $('.notify').hide();
          $('#notify_email').attr('disabled', true);
          $('#product-form-id').val($(this).find('input').val());
        }
      });
    },

    gdpr: function() {
      // ALD-975: US visitors get the consent banner (Reject/Accept) instead of the
      // cookie-management modal. Consentmo.openDialog('notice') shows the banner;
      // 'preferences' (== window.showPreferences) shows the management modal.
      var isUSVisitor = function() {
        try {
          if (window.ALDConsent && window.ALDConsent.regionCode()) return true; // US state resolved
          var cache = localStorage.getItem('gdprCache');
          if (cache) {
            var cd = JSON.parse(cache).countryDetection;
            cd = cd ? JSON.parse(cd) : null;
            if (cd && cd.country === 'US') return true;
          }
        } catch (e) {}
        return false;
      };
      // ALD-975: the US-vs-not decision reads Consentmo's detected geo. On a
      // fresh load the hash fires before geo resolves, so wait for it (up to
      // geoWaitAttempts) before deciding, otherwise isUSVisitor() is false and a
      // US visitor wrongly gets the preferences panel.
      var geoReady = function() {
        if (!window.ALDConsent) return true; // no consent gate -> nothing to wait for
        try {
          var c = localStorage.getItem('gdprCache');
          if (!c) return false;
          var cd = JSON.parse(c).countryDetection;
          cd = cd ? JSON.parse(cd) : null;
          return !!(cd && cd.country); // wait until Consentmo has actually resolved a country
        } catch (e) { return true; }
      };
      var legacySettingsSelector = '.cc-settings-view, #cookieconsent\\:settings, [id="cookieconsent:settings"]';
      var dialogRetryTimer = null;
      var requestedDialog = null;
      var dialogOpened = false;

      document.addEventListener('consentmo:dialogOpened', function(e) {
        if (requestedDialog && e.detail && e.detail.dialog === requestedDialog) {
          dialogOpened = true;
          clearTimeout(dialogRetryTimer);
        }
      });

      // Consentmo defines Consentmo.openDialog and window.showPreferences before it has finished
      // loading, and until then a call does nothing or shows the wrong dialog - so a function
      // existing is not readiness. Keep retrying until Consentmo reports the dialog we asked for
      // opened: 'notice' = Reject/Accept banner (US), 'preferences' = cookie-management panel
      var openPreferences = function(trigger) {
        var attemptsLeft = 60;
        var geoWaitAttempts = 20;
        dialogOpened = false;
        requestedDialog = null;
        clearTimeout(dialogRetryTimer);

        var attempt = function() {
          if (dialogOpened) {
            return;
          }

          if (geoReady() || geoWaitAttempts-- <= 0) {
            var cp = window.Consentmo;
            requestedDialog = isUSVisitor() ? 'notice' : 'preferences';

            if (cp && typeof cp.openDialog === 'function') {
              cp.openDialog(requestedDialog);
            } else if (requestedDialog === 'preferences' && typeof window.showPreferences === 'function') {
              window.showPreferences(trigger || document.body);
            } else if ($(legacySettingsSelector).length) {
              $(legacySettingsSelector).fadeIn(100);
              return;
            }
          }

          if (!dialogOpened && --attemptsLeft > 0) {
            dialogRetryTimer = setTimeout(attempt, 250);
          }
        };

        attempt();
      };
      var tryOpenPreferencesFromHash = function() {
        if (window.location.hash === '#change-settings') {
          openPreferences();
        }
      };

      $('body').on('click', '.pp-settings-button', function(e) {
        e.preventDefault();
        openPreferences(this);
      });

      $('body').on('click', '.cc-settings, .pp-settings-button', function() {
        $('.cc-window, .isense-cc-window').hide();
        $('body').addClass('noscroll');
        $('.menu-toggle').css('display', 'none')
        $('.navbar__cart').hide();
      });


      $('body').on('click', '.cc-btn-accept-all', function () {
        $('.cc-settings-dialog input, .isense-cc-settings-dialog input').each(function (index, elem) {
          if (index !== 0 && !elem.checked) {
            elem.click();
          }
        });
      });

      $('body').on('click', '.cc-btn-accept-selected, .cc-btn-accept-all, .cc-btn-close-settings, .isense-cc-btn-accept-selected, .isense-cc-btn-accept-all, .isense-cc-close, .isense-cc-save', function() {
        $('body').removeClass('noscroll');
        $('.menu-toggle').css('display', '')
        $('.navbar__cart').show();
      });

      var observer = new MutationObserver(function (mutationsList, observer) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            if($(mutation.addedNodes[j]).hasClass && ($(mutation.addedNodes[j]).hasClass('cc-window') || $(mutation.addedNodes[j]).hasClass('isense-cc-window'))) {
              if (($('.cc-message').length === 1 || $('.isense-cc-message').length === 1) && $('.cc-title').length === 0) {
                var $msg = $('.cc-message').length ? $('.cc-message') : $('.isense-cc-message');
                $msg.wrap('<div class="cc-message-wrapper"></div>');
                $('.cc-message-wrapper').prepend('<div class="cc-title">Cookies Preferences</div>');
                $('.cc-settings-dialog > br, .isense-cc-settings-dialog > br').remove();
              }
              observer.disconnect();
              return;
            }
          }
        }
      });

      observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
      tryOpenPreferencesFromHash();
      window.addEventListener('hashchange', tryOpenPreferencesFromHash);
    },

    countryModal: function() {
      // if(!readCookie('countrymodal')) {
      //   $('.popup-country-switcher, .popup-country-switcher-overlay').show();
      // }

      // $('.popup-country-switcher__close').on('click', function() {
      //   $('.popup-country-switcher, .popup-country-switcher-overlay').remove();
      //   createCookie('countrymodal', 'x', 30);
      //   return false;
      // });

      // $('.popup-country-switcher .btn').on('click', function() {
      //   createCookie('countrymodal', 'x', 30);
      //   $('.popup-country-switcher, .popup-country-switcher-overlay').remove();
      // });

      // $('.popup-country-switcher-overlay').on('click', function() {
      //   $('.popup-country-switcher, .popup-country-switcher-overlay').hide();
      //   createCookie('countrymodal', 'x', 30);
      //   return false;
      // });
    },

    /**
    * Accessibility
    */
    accessibility: function() {
      $('#accessibility-link').on('click', function() {
        $('#accessibility-popup').addClass('popup-a--visible');
        /* Search on desktop */
        $('.search-visible').removeClass('search-visible');
        $('.search-collapse').removeClass('search-collapse');
        $('.header--search').removeClass('header--search');
        /* Main Menu */
        $('.menu-collapse').removeClass('menu-collapse');
        $('.nav-collapse').removeClass('nav-collapse');
        $('.active-menu-toggle').removeClass('active-menu-toggle');
        return false;
      });

      $('.popup-a__close').on('click', function() {
        var accessibilityCookie = readCookie('accessibility');
        $('#accessibility-popup').removeClass('popup-a--visible');

        if(accessibilityCookie) {
          $('#accessibility-popup').addClass('popup-a--enabled');
        }
        return false;
      });

      $('.popup-a__icon').on('click', function() {
        $('#accessibility-popup').removeClass('popup-a--enabled');
        $('#accessibility-popup').addClass('popup-a--visible');
        return false;
      });

      $('#accessibility-blackandwhite').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');
        $(this).addClass('popup-a-list__link--active');

        createCookie('accessibility', 'blackandwhite', 1);

        $('body > *').not('.popup-a').css('filter', 'grayscale(1)');
        $('body').css('background', '#fff');

        return false;
      });

      $('#accessibility-highcontrast').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');
        $(this).addClass('popup-a-list__link--active');

        createCookie('accessibility', 'highcontrast', 1);

        $('body > *').not('.popup-a').css('filter', 'contrast(200%)');
        $('body').css('background', '#fff');

        return false;
      });

      $('#accessibility-imageinvert').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');
        $(this).addClass('popup-a-list__link--active');

        createCookie('accessibility', 'imageinvert', 1);

        $('body > *').not('.popup-a').css('filter', 'invert(1)');
        $('body').css('background', '#000');

        return false;
      });

      $('#accessibility-removeallstyling').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');

        createCookie('accessibility', 'nostyles', 1);

        $('body > *').css('filter', 'none');
        $('link[rel="stylesheet"]').remove();
        $('style').remove();
        $('body').css('background', '#fff');
        return false;
      });

      $('#accessibility-keyboard').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');
        $(this).addClass('popup-a-list__link--active');

        createCookie('accessibility', 'keyboard', 1);

        return false;
      });

      $('#accessibility-turnoff').on('click', function() {
        $('.popup-a-list__link--active').removeClass('popup-a-list__link--active');

        eraseCookie('accessibility');
        location.reload();

        return false;
      });

      $('#accessibility-commitment').on('click', function() {
        $('html, body').scrollTop(0);
        $('body').addClass('commitment-popup-overflow');
        $('#commitment-overlay').addClass('commitment-overlay--visible');
        $('#commitment-popup').addClass('commitment-popup--visible');
        return false;
      });

      $('#accessibility-commitment-close').on('click', function() {
        $('#commitment-overlay').removeClass('commitment-overlay--visible');
        $('#commitment-popup').removeClass('commitment-popup--visible');
        return false;
      });

      $(document).keyup(function(e) {
        if(e.keyCode === 27) {
          if($('#commitment-popup').hasClass('commitment-popup--visible')) {
            $('#commitment-overlay').removeClass('commitment-overlay--visible');
            $('#commitment-popup').removeClass('commitment-popup--visible');
          }
        }
      });

      var accessibilityCookie = readCookie('accessibility');

      if(accessibilityCookie) {
        $('#accessibility-popup').addClass('popup-a--enabled');
        switch(accessibilityCookie) {
          case 'blackandwhite':
            $('#accessibility-blackandwhite').addClass('popup-a-list__link--active');
            $('body > *').not('.popup-a').css('filter', 'grayscale(1)');
            $('body').css('background', '#fff');
            break;
          case 'highcontrast':
            $('#accessibility-highcontrast').addClass('popup-a-list__link--active');
            $('body > *').not('.popup-a').css('filter', 'contrast(200%)');
            $('body').css('background', '#fff');
            break;
          case 'imageinvert':
            $('#accessibility-imageinvert').addClass('popup-a-list__link--active');
            $('body > *').not('.popup-a').css('filter', 'invert(1)');
            $('body').css('background', '#000');
            break;
          case 'nostyles':
            $('body > *').css('filter', 'none');
            $('link[rel="stylesheet"]').remove();
            $('style').remove();
            $('body').css('background', '#fff');
            break;
          case 'keyboard':
            break;
          default:
            break;
        }
      }
    },
      
    filtering: function() {
      if($('body').hasClass('template-search')) {
        $('body').removeClass('plp-loadtime');
      }

      if($('body').hasClass('template-collection') && $('.filters-vintage').length === 0) {
        $('body').on('click', '.plp-product', function() {
          localStorage.setItem('persistentTop', $('html, body').scrollTop());
        });

        collectionHandle = window.location.pathname;
        coll = collectionHandle.split("/");
        console.log('>> persistent 1');

        if(window.location.href.indexOf('/collections/') > -1 && window.location.href.indexOf('=') > -1) {
          $('.products-collection.grid-products').addClass('loading-products-patch');
        }


        if(!hasCollectionFilterParams()) {
          //  $('.products-collection.grid-products > *').css('visibility', 'visible');
          $('body').removeClass('plp-loadtime');
          $('.products-collection.grid-products').removeClass('loading-products-patch');
        }

        if(hasCollectionFilterParams()) {
          console.log('>> persistent 2');
          $('.products-collection.grid-products > .plp-product').remove();
          $('body').removeClass('plp-loadtime');
          $('#shopify-section-collection-template .pagination').remove();

          console.log('>> persistent');
          var store = 'aime-leon-dore';
          if(window.location.host.indexOf('eu') > -1) {
            store = 'aime-leon-dore-eu';
          }
          if(window.location.host.indexOf('dev') > -1) {
            store = 'aime-leon-dore-dev-store';
          }
          if(window.location.host.indexOf('eu-dev') > -1) {
            store = 'aime-leon-dore-eu-dev';
          }
          var jsonCollection = {
            'store_name': store,
            'collection': coll[2]
          }

          if(window.location.host.indexOf('eu') > -1) {
            var locationId = 50003247253;
            if($('body').attr('data-country') == 'GB') {
              locationId = 74146152597;
            }

            var jsonCollection = {
              'store_name': store,
              'collection': coll[2],
              'location_id': locationId
            }
          }

          $.ajax({
            url: 'https://ald-filter-staging.herokuapp.com/api/collection_info',
            type: 'post',
            data: JSON.stringify(jsonCollection),
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
    
            success: function(response) {
              console.log('> collection info >', response);
              var uniqueGroups = [];
              var uniqueSizes = 0;
              for(var i in response) {
                if(response[i].size_range != null) {
                  if(uniqueGroups.indexOf(response[i].size_range) == -1) {
                    uniqueGroups.push(response[i].size_range);
                  }
                  uniqueSizes++;
                }
              }
            if(uniqueSizes === 0 && coll[2] !== 'shop-all') {
              $('.filter-menu__item').eq(0).hide();
            
              if(coll[2] === 'gift-cards') {
                $('.filter-menu__item').eq(0).show();
                $('.filter-menu__item').eq(1).hide();
                $('.filter-menu__item').eq(2).hide();
              }
            }

              var singleSize = true;
              if(uniqueGroups.length == 1) {

              } else {
                singleSize = false;
                for(var j in uniqueGroups) {
                  $('.filter-variant-list--sizes').append(`         <li>
                    <div class="filter-variant" role="button">${uniqueGroups[j]}<i class="filter-variant__ico"></i></div>
                    <ul class="filter-variant-list filter-variant-list-${j}" data-sizename="${uniqueGroups[j]}"></ul>
                  </li>`);

                  // $('.filter-menu-mobile .filter-variant-list--sizes').append(`         <li>
                  //   <div class="filter-variant" role="button">${uniqueGroups[j]}<i class="filter-variant__ico"></i></div>
                  //   <ul class="filter-variant-list filter-variant-list-${j}"></ul>
                  // </li>`);
                }
              }

              for(var i in response) {
                if(response[i].size_range != null) {
                  if(singleSize) {
                    var disabledClass = !response[i].available ? 'filter-disabled' : '';
                    $('.filter-menu-desktop .filter-variant-list--sizes').append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="item-${i}">
                        <label for="item-${i}">${response[i].name}</label>
                      </div>
                    </li>`)

                    $('.filter-menu-mobile .filter-variant-list--sizes').append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="mitem-${i}">
                        <label for="mitem-${i}">${response[i].name}</label>
                      </div>
                    </li>`)
                  } else {
                    var disabledClass = !response[i].available ? 'filter-disabled' : '';
                    var idx = uniqueGroups.indexOf(response[i].size_range);
                    $('.filter-menu-desktop .filter-variant-list-'+idx).append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="item-${i}">
                        <label for="item-${i}">${response[i].name}</label>
                      </div>
                    </li>`)

                    $('.filter-menu-mobile .filter-variant-list-'+idx).append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="mitem-${i}">
                        <label for="mitem-${i}">${response[i].name}</label>
                      </div>
                    </li>`)
                  }
                } else {
                  var disabledClass = !response[i].available ? 'filter-disabled' : '';
                  //var lowerCase = i.charAt(0) + i.toLowerCase().slice(1);
                  $('.filter-menu-desktop .filter-variant-list--color').append(`         <li>
                    <div class="filter-custom-checkbox ${disabledClass}">
                      <input type="checkbox" data-type="color" name="${response[i].name}" id="item-${i}">
                      <label for="item-${i}">${response[i].name}</label>
                    </div>
                  </li>`)

                  $('.filter-menu-mobile .filter-variant-list--color').append(`         <li>
                    <div class="filter-custom-checkbox ${disabledClass}">
                      <input type="checkbox" data-type="color" name="${response[i].name}" id="mitem-${i}">
                      <label for="mitem-${i}">${response[i].name}</label>
                    </div>
                  </li>`)
                }
              }

          setTimeout(function() {
            if(window.location.search.length > 0) {
              showCollectionLoader();
            }

            aldsec.getFilteredProducts();

          }, 500);
        }
          });

          $('.filter-dropdown').addClass('loaded');
        }



        $('.applied-filters__list').on('click', 'li', function() {
          var thisText = $(this).text();
          var thisRange = $(this).attr('data-size-range');
          var sel;
          if (thisRange) {
            // Size pill: scope to the matching size_range so we only toggle the right checkbox.
            sel = '.filter-dropdown .filter-custom-checkbox input[name="'+thisText+'"][data-size-range="'+thisRange+'"]';
          } else {
            // Color pill (or anything without a range)
            sel = '.filter-dropdown .filter-custom-checkbox input[name="'+thisText+'"]';
          }
          $(sel).next().trigger('click');
          console.log(thisText, thisRange, $(sel+':checked').length);
        });


        $('.remove-all-filters').on('click', function() {
          showCollectionLoader();
          remainingProductsFromFilters = [];
              $('#showall').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall').closest('.filter-custom-checkbox').removeClass('blocked-label');
              $('#showall4').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall4').closest('.filter-custom-checkbox').removeClass('blocked-label');
          sizesArr = [];
          colorsArr = [];
          $('.filter-dropdown input:checked').addClass('blocked');
          $('.filter-dropdown input:checked').trigger('change');
          $('.filter-dropdown input:checked').prop('checked', false)
          $('.filter-dropdown input.blocked').removeClass('blocked');

          $('.filter-menu-mobile input:checked').addClass('blocked');
          $('.filter-menu-mobile input:checked').trigger('change');
          $('.filter-menu-mobile input:checked').prop('checked', false)
          $('.filter-menu-mobile input.blocked').removeClass('blocked');    

                var showsales = false;
                if($('#showsale').prop('checked') || $('#showsale7').prop('checked')) {
                  showsales = true;
                }

            console.log(colorsArr, sizesArr);
            var store = 'aime-leon-dore';
            if(window.location.host.indexOf('eu') > -1) {
              store = 'aime-leon-dore-eu';
            }
            if(window.location.host.indexOf('dev') > -1) {
              store = 'aime-leon-dore-dev-store';
            }
            if(window.location.host.indexOf('eu-dev') > -1) {
              store = 'aime-leon-dore-eu-dev';
            }

            var urlParams   = new URLSearchParams(window.location.search);
            var currentSort = urlParams.get('sort_by');

            window.history.pushState('', '', window.location.protocol+'//'+window.location.host+window.location.pathname+ (currentSort ? `?sort_by=${currentSort}` : ''));

            ajaxLoadMoreAfterClearFilters();
            console.log('manage state 0.2', window.location.search);
            aldsec.filteringShowHideActive();

          return false;
        });

        $('.filter-dropdown').on('mouseover', function() {
          console.log('hover');
          if(!$(this).hasClass('loaded')) {
            var store = 'aime-leon-dore';
            if(window.location.host.indexOf('eu') > -1) {
              store = 'aime-leon-dore-eu';
            }
            if(window.location.host.indexOf('dev') > -1) {
              store = 'aime-leon-dore-dev-store';
            }
            if(window.location.host.indexOf('eu-dev') > -1) {
              store = 'aime-leon-dore-eu-dev';
            }
            var jsonCollection = {
              'store_name': store,
              'collection': coll[2]
            }

            if(window.location.host.indexOf('eu') > -1) {
              var locationId = 50003247253;
              if($('body').attr('data-country') == 'GB') {
                locationId = 74146152597;
              }

              var jsonCollection = {
                'store_name': store,
                'collection': coll[2],
                'location_id': locationId
              }
            }

            $.ajax({
              url: 'https://ald-filter-staging.herokuapp.com/api/collection_info',
              type: 'post',
              data: JSON.stringify(jsonCollection),
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
    
              success: function(response) {
            $('.loading-filters').remove();
                console.log('> collection info >', response);
                var uniqueGroups = [];
                var uniqueSizes = 0;
                for(var i in response) {
                  if(response[i].size_range != null) {
                    if(uniqueGroups.indexOf(response[i].size_range) == -1) {
                      uniqueGroups.push(response[i].size_range);
                    }
                    uniqueSizes++;
                  }
                }
                if(uniqueSizes === 0 && coll[2] !== 'shop-all') {
                  $('.filter-menu__group-with-filters .filter-menu__item').eq(0).hide();

              if(coll[2] === 'gift-cards') {
                $('.filter-menu__item').eq(0).show();
                $('.filter-menu__item').eq(1).show();
                $('.filter-menu__item').eq(2).show();
              }
                }

                var singleSize = true;
                if(uniqueGroups.length == 1) {


                } else {
                  singleSize = false;

                  for(var j in uniqueGroups) {
                    $('.filter-variant-list--sizes').append(`         <li>
                      <div class="filter-variant" role="button">${uniqueGroups[j]}<i class="filter-variant__ico"></i></div>
                      <ul class="filter-variant-list filter-variant-list-${j}" data-sizename="${uniqueGroups[j]}"></ul>
                    </li>`);
                  }
                }

                for(var i in response) {
                  if(response[i].size_range != null) {
                    if(singleSize) {
                      var disabledClass = !response[i].available ? 'filter-disabled' : '';
                      $('.filter-menu-desktop .filter-variant-list--sizes').append(`         <li>
                        <div class="filter-custom-checkbox ${disabledClass}">
                          <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="item-${i}">
                          <label for="item-${i}">${response[i].name}</label>
                        </div>
                      </li>`)

                    $('.filter-menu-mobile .filter-variant-list--sizes').append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="mitem-${i}">
                        <label for="mitem-${i}">${response[i].name}</label>
                      </div>
                    </li>`)
                    } else {
                      var disabledClass = !response[i].available ? 'filter-disabled' : '';
                      var idx = uniqueGroups.indexOf(response[i].size_range);
                      $('.filter-menu-desktop .filter-variant-list-'+idx).append(`         <li>
                        <div class="filter-custom-checkbox ${disabledClass}">
                          <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="item-${i}">
                          <label for="item-${i}">${response[i].name}</label>
                        </div>
                      </li>`)

                    $('.filter-menu-mobile .filter-variant-list-'+idx).append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="size" data-size-range="${response[i].size_range}" name="${response[i].name}" id="mitem-${i}">
                        <label for="mitem-${i}">${response[i].name}</label>
                      </div>
                    </li>`)
                    }
                  } else {
                    var disabledClass = !response[i].available ? 'filter-disabled' : '';
                    //var lowerCase = i.charAt(0) + i.toLowerCase().slice(1);
                    $('.filter-menu-desktop .filter-variant-list--color').append(`         <li>
                      <div class="filter-custom-checkbox ${disabledClass}">
                        <input type="checkbox" data-type="color" name="${response[i].name}" id="item-${i}">
                        <label for="item-${i}">${response[i].name}</label>
                      </div>
                    </li>`)

                  $('.filter-menu-mobile .filter-variant-list--color').append(`         <li>
                    <div class="filter-custom-checkbox ${disabledClass}">
                      <input type="checkbox" data-type="color" name="${response[i].name}" id="mitem-${i}">
                      <label for="mitem-${i}">${response[i].name}</label>
                    </div>
                  </li>`)
                  }
                }
              }
            });

            $(this).addClass('loaded');
          }
        });

              $('#showall').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall').closest('.filter-custom-checkbox').removeClass('blocked-label');
              $('#showall4').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall4').closest('.filter-custom-checkbox').removeClass('blocked-label');
console.log('xxx');

$('.filter-dropdown').on('click', '.filter-custom-checkbox label', function() {
  console.log('click');
});


$('.loading-collection-products-text a').on('click', function() {
  window.location = window.location.pathname
  return false;
});

        var tempSizesArr = [];

        $('.filter-dropdown, .filter-menu.d-lg-none').on('change', '.filter-custom-checkbox input', function() {

console.log('CLICK :: custom checkbox filters')

                $('.products-collection.grid-products > *').not('.loading-collection-products').remove();


          if($(this).hasClass('sizeselection')) {
            if($(this).hasClass('blocked')) {
              sizesArr = [];

                tempSizesArr = [];
              localStorage.setItem('mysizesenabled', '0');
            } else {
            // clear out all enabled size filters
            console.log('sizeselection 1');
            if($(this).prop('checked')) {
              console.log('sizeselection 2');
              localStorage.setItem('mysizesenabled', '1');

              $('.filter-variant-list--sizes input:checked').each(function() {
                $(this).addClass('blocked');
                $(this).prop('checked', false);
                $(this).removeClass('blocked');
              });

              // mark all size filters
              tempSizesArr = sizesArr;
              sizesArr = [];
console.log('>> selected my sizes 1', getUserSizeCategories())
              getUserSizeCategories().forEach(function(category) {
                var values = splitUserSizes(category.raw);
                if (values.length === 0) return;
console.log('>> selected my sizes 1.1', category, category.filterIndex, values)
                values.forEach(function(value) {
                  // Match the size inputs directly by size range + name. This works for BOTH
                  // layouts: multiple ranges (inputs nested under a per-range heading that
                  // carries data-sizename) AND a single range (inputs rendered flat under
                  // "Size" with no heading and no data-sizename wrapper). The old container
                  // lookup ('.filter-variant-list[data-sizename=...]') matched nothing in the
                  // single-range case, so no checkbox got checked and sizesArr stayed empty
                  // (which is why the Refine counter never updated either).
                  var $inputs = $('input[data-type="size"][data-size-range="' + category.range + '"][name="' + value + '"]');
                  if ($inputs.length) {
                    $inputs.addClass('blocked').prop('checked', true).removeClass('blocked');
                    sizesArr.push({ name: value, size_range: category.range });
                  }
                });
              });
console.log('>> selected my sizes 1.2', $('#item-0').prop('checked'));
              console.log('sizesarr 1', sizesArr)

              $('#showall').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
              $('#showall').closest('.filter-custom-checkbox').addClass('blocked-label');
              $('#showall4').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
              $('#showall4').closest('.filter-custom-checkbox').addClass('blocked-label');

            } else {
              localStorage.setItem('mysizesenabled', '0');
              if(tempSizesArr.length === 0) {
                sizesArr = [];
                tempSizesArr = [];
                // Uncheck every user-size that was auto-selected. Match by range + name so it
                // works for the single-range (flat, no data-sizename) layout too. The old
                // '.filter-variant-list-<filterIndex>' selector relied on a per-range list
                // that does not exist when there is only one size range.
                getUserSizeCategories().forEach(function(category) {
                  var values = splitUserSizes(category.raw);
                  if (values.length === 0) return;
                  values.forEach(function(value) {
                    $('input[data-type="size"][data-size-range="' + category.range + '"][name="' + value + '"]').addClass('blocked').prop('checked', false).removeClass('blocked');
                  });
                });

                $('#showall').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
                $('#showall').closest('.filter-custom-checkbox').removeClass('blocked-label');
                $('#showall4').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
                $('#showall4').closest('.filter-custom-checkbox').removeClass('blocked-label');
              } else {
                sizesArr = tempSizesArr;
                // tempSizesArr holds {name, size_range} objects (a copy of sizesArr), so match
                // on both fields. Re-check the sizes that were selected before My Sizes was on.
                tempSizesArr.forEach(function(size) {
                  $('input[data-type="size"][data-size-range="' + size.size_range + '"][name="' + size.name + '"]').addClass('blocked').prop('checked', true).removeClass('blocked');
                });

                // Uncheck the user-size values that are NOT part of the restored selection.
                getUserSizeCategories().forEach(function(category) {
                  var values = splitUserSizes(category.raw);
                  if (values.length === 0) return;
                  values.forEach(function(value) {
                    if (findSizeIndex(sizesArr, value, category.range) === -1) {
                      $('input[data-type="size"][data-size-range="' + category.range + '"][name="' + value + '"]').addClass('blocked').prop('checked', false).removeClass('blocked');
                    }
                  });
                });

                tempSizesArr = [];
              }
            }

            }
          }

          // if(!$(this).hasClass('blocked')) {

          //   aldsec.getFilteredProducts();

          // }


          if(!$(this).hasClass('blocked')) {

            $('.products-collection.grid-products > *').not('.loading-collection-products').remove();

            $('.loading-collection-products').css('display', 'flex');
            $('.loading-collection-products-text').hide();


            $('#shopify-section-collection-template .pagination').remove();

            if(!$(this).hasClass('sizeselection')) {
              $('#selectedSizes, #selectedSizes2').prop('checked', false);
            }
            console.log('manage state 0.01', window.location.search);
            var status = $(this).prop('checked');
            var type = $(this).data('type');
            var val = $(this).prop('name');
            var soldout = false; // display_sold_out
            console.log('manage state 0.010', window.location.search, colorsArr);
            if(type === 'color') {
              if(status) {
                colorsArr.push(val);
                $('#showall').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
                $('#showall').closest('.filter-custom-checkbox').addClass('blocked-label');
                $('#showall4').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
                $('#showall4').closest('.filter-custom-checkbox').addClass('blocked-label');
              } else {
                var index = colorsArr.indexOf(val);
                if (index > -1) {
                  colorsArr.splice(index, 1);
                }
              }
            } else if (type === 'size') {
              var sizeRange = $(this).data('size-range');
              if(status) {
                if (findSizeIndex(sizesArr, val, sizeRange) === -1) {
                  sizesArr.push({ name: val, size_range: sizeRange });
                }
                $('#showall').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
                $('#showall').closest('.filter-custom-checkbox').addClass('blocked-label');
                $('#showall4').attr('readonly', true).prop('checked', true).addClass('readonly blocked').attr('disabled', true);
                $('#showall4').closest('.filter-custom-checkbox').addClass('blocked-label');
              } else {
                var index = findSizeIndex(sizesArr, val, sizeRange);
                if (index > -1) {
                  sizesArr.splice(index, 1);
                }
              }
            } else {
              if(!status) {
                soldout = true;
                val = "show soldout";
              } else {
                val = "hide soldout";
              }
            }
            console.log('manage state 0.011', window.location.search, colorsArr);
            var urlParams   = new URLSearchParams(window.location.search);
            var currentSort = urlParams.get('sort_by'); // "new" / "price_low" / "price_high"

            // build search location
            var searchString = '?';
            for(var i in colorsArr) {
              searchString += 'c='+colorsArr[i]+'&';
            }
            var sizesQs = sizesToSearchString(sizesArr);
            if (sizesQs) {
              searchString += sizesQs + '&';
            }
            if($('#showall').prop('checked') == true || $('#showall4').prop('checked') == true) {
              searchString += 'v=true';
            } else {
              searchString += 'v=false';
            }

            if(sizesArr.length === 0 && colorsArr.length === 0 && (type !== 'viewtype' && type !== 'viewtypesale')) {
              $('#showall').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall').closest('.filter-custom-checkbox').removeClass('blocked-label');
              $('#showall4').attr('readonly', false).prop('checked', false).removeClass('readonly blocked').attr('disabled', false);
              $('#showall4').closest('.filter-custom-checkbox').removeClass('blocked-label');
              // $('#showall').prop('checked', true);
              soldout = true;
              searchString = '';
            }
            
            if (searchString === '?v=false') {
                searchString = '';
            }

            var showsales = false;
            if($('#showsale').prop('checked') || $('#showsale7').prop('checked')) {
              showsales = true;
              if(searchString == '') {
                searchString += '?ss=true';
              } else {
                searchString += '&ss=true';
              }

            }
            if (currentSort) {
              if (searchString === '') {
                searchString += '?sort_by=' + currentSort;
              } else if (searchString === '?') {
                searchString += 'sort_by=' + currentSort;
              } else {
                if (!searchString.endsWith('?') && !searchString.endsWith('&')) {
                  searchString += '&';
                }
                searchString += 'sort_by=' + currentSort;
              }
            }

            window.history.pushState('', '', window.location.protocol+'//'+window.location.host+window.location.pathname+searchString);
            console.log('manage state 0.02', window.location.search);
            
            console.log('status:: ', status)

            var store = 'aime-leon-dore';
            if(window.location.host.indexOf('eu') > -1) {
              store = 'aime-leon-dore-eu';
            }
            if(window.location.host.indexOf('dev') > -1) {
              store = 'aime-leon-dore-dev-store';
            }
            if(window.location.host.indexOf('eu-dev') > -1) {
              store = 'aime-leon-dore-eu-dev';
            }
            var filterJson = {
              "store_name":store,
              "collection": coll[2],
              "sizes": sizesArr,
              "colors": colorsArr,
              "display_sold_out": soldout,
              'for_sales': showsales,
              "iso_code": Shopify.country
            }

            if(window.location.host.indexOf('eu') > -1) {
              var locationId = 50003247253;
              if($('body').attr('data-country') == 'GB') {
                locationId = 74146152597;
              }

              var filterJson = {
                "store_name":store,
                "collection": coll[2],
                "sizes": sizesArr,
                "colors": colorsArr,
                "display_sold_out": soldout,
                'for_sales': showsales,
                "iso_code": Shopify.country,
                "location_id": locationId
              }
            }

            if(window.location.host.indexOf('eu-dev') > -1) {
              var locationId = 53200584866;
              if($('body').attr('data-country') == 'GB') {
                locationId = 70879314089;
              }

              var filterJson = {
                "store_name":store,
                "collection": coll[2],
                "sizes": sizesArr,
                "colors": colorsArr,
                "display_sold_out": soldout,
                'for_sales': showsales,
                "iso_code": Shopify.country,
                "location_id": locationId
              }
            }

            if(window.location.href.indexOf('price') > -1) {
              filterJson['sort_type'] = 'price'
            }
            if(window.location.href.indexOf('created') > -1) {
              filterJson['sort_type'] = 'created_at'
            }

            if(window.location.href.indexOf('descending') > -1) {
              filterJson['sort_order'] = 'desc'
            }
            if(window.location.href.indexOf('ascending') > -1) {
              filterJson['sort_order'] = 'asc'
            }

            if(typeof gtag === 'function') {                
                var eventName = 'Filtering';
                var customEventDetail = {};
                
                if( type === 'size') {
                    eventName += ' size';
                    var sizeType = $(this).closest('.filter-variant-list').prev('.filter-variant').text();
                    customEventDetail.size_category = sizeType;
                }
                if (type === 'color') {
                    eventName += ' color';
                }
                if (type === 'viewtype') {
                    eventName += ' soldout';
                }
                if (type !== 'viewtype') {
                    customEventDetail.filter_status = status ? 'checked' : 'unchecked';
                }
                
                gtag('event', eventName, {
                    'filter_value': val,
                    ...customEventDetail
                });

                // category events
                const categoryTitle = $('.category-menu-toggle').text().trim();
                if(type === 'size') {
                  var sizeType = $(this).closest('.filter-variant-list').prev('.filter-variant').text();
                  gtag('event', `${categoryTitle}_Size Filter_${sizeType}_${val}`);
                }
                if(type === 'color') {
                  gtag('event', `${categoryTitle}_Color Filter_${val}`);
                }
            }
console.log('>> pagination removal 1')
            if(!searchString.length) {
              console.log('>> pagination removal 2')
              // ajaxLoadMoreAfterClearFilters();
              
            ajaxLoadMoreAfterClearFilters();
                console.log('manage state 0.3', window.location.search);
                aldsec.filteringShowHideActive();
                return;
            }

            console.log('CLICK :: AJAX INVOKE')
            remainingProductsFromFilters = [];

            console.log('pagination 2');

                var filtersUrl = 'https://ald-filter-staging.herokuapp.com/api/filter_products_paginated';

                let params = new URLSearchParams(document.location.search);
                let filtersPage = params.get('page');
                if(filtersPage === null) {
                  filtersPage = 1;
                }

                filterJson['pagination'] = {'page': filtersPage}

                $('.next-category-container').hide();
                $('html, body').scrollTop(0);

            var filterRequest = $.ajax({
              url: filtersUrl,
              type: 'post',
              data: JSON.stringify(filterJson),
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
    
              success: function(response) {

                
                if(response.number_of_pages == 1 || response.number_of_pages == response.page_number) {
                  $('.products-collection').css('padding-bottom', '60px');
                  $('.next-category-container').show();
                }

                $('.collection-title sup').text(response.length);

                // $('.products-collection.grid-products > *').not('.loading-collection-products').remove();
                $('.products-collection.grid-products > .plp-product').remove();

                $('.loading-collection-products').css('display', 'none');
                $('.loading-collection-products-text').hide();

                    var products = withValidLocalPrice(response.products);

                for(var i in products) {
                  $('#response-length').text(products.length);
if(i < 64) {
                  var soldout = '';
                  var colorsAvailable = '';
                  if(products[i].swatch_count === '1') {
                    colorsAvailable = "1 Color Available";
                  } else {
                    colorsAvailable = products[i].swatch_count+" Colors Available";
                    if(products[i].swatch_count === null) {
                      colorsAvailable = '';
                    }
                  }
                  if(products[i].sold_out) {
                    soldout = '<div class="plp-product__tag">SOLD OUT</div>';
                  }

                  var dataFP = '';
                  var dataCAFP = ' data-xcafp ';
                  var dataCAFPClass = ' '
                  var dataCAFPGEM = ' '
                  var customTagSupress = '';
                  if(products[i].metafields != null) {
                    for(var j in products[i].metafields) {
                      if(products[i].metafields[j]['data-fp']) {
                        dataFP = 'data-fp="'+products[i].metafields[j]['data-fp']+'"';
                      }
                      if(products[i].metafields[j]['data-cafp']) {
                        dataCAFP = 'data-xcafp="'+products[i].metafields[j]['data-cafp']+'"';
                        dataCAFPClass = ' temp-hidden-price '
                        dataCAFPGEM = ' data-gem-ignore '
                      }
                      if(products[i].metafields[j]['custom_tag_name_text']) {
                        customTagSupress = products[i].metafields[j]['custom_tag_name_text'];  
                      }
                    }
                  }
                  dataFP = dataFP.replace(/\s/g, '');
                  dataCAFP = dataCAFP.replace(/\s/g, '');
                  dataCAFP = dataCAFP.replace('"', '').replace('"', '');

                  var price = products[i].local_price.price + '';
                  var compareAtPrice = '';
                  if(!!products[i].local_price.compare_at_price && !products[i].sold_out) {
                    if(products[i].local_price.compare_at_price > products[i].local_price.price) {
                      var clocalizedString = Shopify.locale+'-'+Shopify.country;
                      var clocalizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: products[i].local_price.currency, maximumFractionDigits: 0}).format(products[i].local_price.compare_at_price)

                      clocalizedPriceWithSymbol = formatPrice(products[i].local_price.compare_at_price, products[i].local_price.currency);
                      compareAtPrice = '<s class="product__price product__price--sale"  style="font-size: inherit">'+clocalizedPriceWithSymbol+'</s>';
                    }
                  }
                  var imgToDisplay = products[i].images[1] ? products[i].images[1].url : products[i].image_url;

                  imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';

                  if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

                      for(var j in products[i].images) {
                        if(j > 0) {
                          if(products[i].images[j].alt != 'dev-product-image-swatch') {
                            if(j > 1) {
                              imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" style="display: none" loading="lazy"></div></li>';
                            } else {
                              if(i >= 64) {
                                imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';
                              } else {
                                imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+products[i].images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';  
                              }
                            }

                          }
                        }
                      }
  imgToDisplay += '</ul></div></div>';

                    // imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel">';

                    // for(var j in products[i].images) {
                    //   if(j > 0) {
                    //     if(products[i].images[j].alt != 'dev-product-image-swatch') {
                    //       if(j > 1) {
                    //         imgToDisplay += '<div class="plp-carousel__item"><img src="'+products[i].images[j].url+'" alt="" class="plp-carousel__image" loading="lazy"></div>';
                    //       } else {
                    //         imgToDisplay += '<div class="plp-carousel__item"><img src="'+products[i].images[j].url+'" alt="" class="plp-carousel__image"></div>';
                    //       }

                    //     }
                    //   }
                    // }
                    // imgToDisplay += '</div></div>';
                  }

                  var product = products[i];
                  var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$' + price;
                  var additionalClassWide = '';

                  var customTag = '';
                  if(!product.sold_out) {
                    if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                      customTag = '<div class="plp-product__tag">Reserve</div>';
                    }
                    if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                      customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                    }
                    if(product.tags.indexOf('NEW_PRODUCT') > -1) {
                      customTag = '<div class="plp-product__tag">NEW</div>  ';
                    }
            customTag = getOverImageBadges(product);

                    // if(product.tags.indexOf(customTagName) > -1) {
                    //   if(customTagSupress != '') {
                    //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
                    //   } else {
                    //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
                    //   }

                    // }
                  } else {
                    if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                      soldOutHTML = 'RESERVATIONS FULL';
                    }
                    if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                      soldOutHTML = 'ENTER THE DRAW';
                    }
                    if(product.tags.indexOf('dev-in-store-only') > -1) {
                      soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['instorelabel']) {
                          soldOutHTML = product.metafields[0]['instorelabel'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['instorelabel']) {
                              soldOutHTML = product.metafields[1]['instorelabel'];  
                            }
                          }
                        }
                      }
                    }
                    if(product.tags.indexOf('dev-coming-soon') > -1) {
                      soldOutHTML = 'COMING SOON';
                    }
            customTag = getOverImageBadges(product);

                    if(product.tags.indexOf('dev-product-wide-plp') > -1) {
                      additionalClassWide = ' product-image-wide';
                      soldOutHTML = widePlp;
                    }
                  }

                  var displayIt = true;
                  if(product.tags.indexOf('dev-product-wide-plp') > -1) {
                    if(sizesArr.length > 0 || colorsArr.length > 0) {
                      displayIt = false;
                    }

                    imgToDisplay = '';
                    for(var j in products[i].images) {
                      var wideProductImgClass = '';
                      if(products[i].images[j].alt != null) {
                        if(products[i].images[j].alt.indexOf('dev-wide-plp') > -1) {
                          if(products[i].images[j].alt == 'dev-wide-plp-1') {
                            wideProductImgClass = ' product-image--oc';
                          }
                          if(products[i].images[j].alt == 'dev-wide-plp-2') {
                            wideProductImgClass = ' product-image--tc';
                          }
                          if(products[i].images[j].alt == 'dev-wide-plp-4') {
                            wideProductImgClass = ' product-image--fc';
                          }

                          imgToDisplay += '<img src="'+products[i].images[j].url+'" alt="" class="product-wide'+wideProductImgClass+'">';
                        }
                      }
                    }
                  }

                  var localizedString = Shopify.locale+'-'+Shopify.country;
                  var localizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: products[i].local_price.currency, maximumFractionDigits: 0}).format(products[i].local_price.price)

                  localizedPriceWithSymbol = formatPrice(products[i].local_price.price, products[i].local_price.currency);

  if(window.location.href.indexOf('end-of-season-sale') > -1) {
    if(!!products[i].local_price.compare_at_price) {
    if(products[i].local_price.compare_at_price == products[i].local_price.price) {
      displayIt = false;
    }
    }
  }
  
                  if(displayIt) {
                    const createdAtStr = products[i]?.created_at;
                    const createdAtMs = new Date(createdAtStr).getTime(); 
                    let hasNewArrivals = false;
                    if (products[i]?.tags && products[i].tags.indexOf('newarrivals') !== -1) {
                      hasNewArrivals = true;
                    }
                    let shouldHidePrice = false;
                    if (products[i].tags && products[i].tags.indexOf('dev-hide-product-price') !== -1) {
                      shouldHidePrice = true;
                    }

                      var customHidingStyle = '';
                      if(i >= 64) {
                        customHidingStyle = ' style="display: none"';
                      }

                    if(product.tags.indexOf('dev-non-us-oos') > -1) {
                      if(Shopify.country !== 'US') {
                        for(const i in product.metafields) {
                          if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                            localizedPriceWithSymbol = product.metafields[i]['non_us_oos_label']
                          }
                        }
                      }
                    }

                    // sold out products show their status label instead of the price
                    if(product.sold_out) {
                      localizedPriceWithSymbol = soldOutHTML;
                    }

                    $('.products-collection.grid-products').append(`<a href="/products/${products[i].handle}" class="plp-product ${additionalClassWide} ${shouldHidePrice ? 'plp-product--hide-price' : ''}" data-product-id="4798156800097" data-price="${price}" data-title="${products[i].title}" data-created-at="${createdAtMs}" data-newarrival="${hasNewArrivals}" data-index="${i}" ${customHidingStyle}>

                      <div class="image-4-5 product-image">
                        ${customTag}
                        ${imgToDisplay}
                      </div>
            <div class="temp-fix-scaling"></div>
                      <div class="short-desc plp-product__details">

                        <h3 class="plp-product__title">${products[i].title}</h3>
                        <div class="plp-product__price ${ (products[i].local_price.compare_at_price > price && !products[i].sold_out) ? 'plp-product__price--compare' : ''}">

                          <span style="display: none;" class="money xxx2money" ${dataFP} data-currency-usd="${price}" data-currency="USD" data-ge-price  style="visibility: visible;">${ soldOutHTML }</span>
                          <span style="display: none;">${compareAtPrice}</span>
                          <span class="money">${ localizedPriceWithSymbol }</span>
                          ${compareAtPrice}
                        </div>
                        </div>
                      </a>`)
                  }


                  if(typeof sortProducts === 'function') {
                    sortProducts();
                  }

                }
                }

                    // build pagination
                $('html, body').scrollTop(0);
                    if(response.number_of_pages > 1) {
                      $('.container .pagination').remove();
                      var paginationOutput = '';
                      var prevArrowOutput = '';
                      var nextArrowOutput = '';
                      var pagesOutput = '';

                      if(response.page_number == 1) {
                        prevArrowOutput = `
                          <span class="prev pagination-disabled">
                            <a></a>
                          </span>`;
                      } else {
                        prevArrowOutput = `
                          <span class="prev">
                            <a href="#" data-searchpage="${response.page_number - 1}"></a>
                          </span>`;
                      }

                      if(response.page_number == response.number_of_pages) {
                        nextArrowOutput = `
                          <span class="next pagination-disabled">
                            <a></a>
                          </span>`;
                      } else {
                        nextArrowOutput = `
                          <span class="next">
                            <a href="#" data-searchpage="${response.page_number + 1}"></a>
                          </span>`;
                      }

                      // for(let i = 1; i <= response.number_of_pages; i++) {
                      //   let numberDisplay = i;
                      //   if(i < 10) {
                      //     numberDisplay = '0'+i;
                      //   }
                      //   if(i == (response.page_number)) {
                      //     pagesOutput += `
                      //       <span class="page current">${numberDisplay}</span>`;
                      //   } else {
                      //     pagesOutput += `
                      //       <span class="page">
                      //         <a href="#" data-searchpage="${i}">${numberDisplay}</a>
                      //       </span>`;          
                      //   }
                      // }

                      var displayPages = getPagination(response.page_number, response.number_of_pages);

console.log('pagination results 1', response.page_number, response.number_of_pages)

                      for(let i = 0; i < displayPages.length; i++) {
                        let numberDisplay = displayPages[i];
                        if(numberDisplay < 10) {
                          numberDisplay = '0'+numberDisplay;
                        }
                        if(response.page_number == displayPages[i]) {
                          pagesOutput += `
                            <span class="page current">${numberDisplay}</span>`;
                        } else {
                          if(displayPages[i] == '...') {
                            pagesOutput += `<span class="page">...</span>`;
                          } else {
                            pagesOutput += `
                              <span class="page">
                                <a href="#" data-searchpage="${displayPages[i]}">${numberDisplay}</a>
                              </span>`;    
                          }
                        }
                      }

                      paginationOutput = `
                        <div class="pagination pagination-plp">
                          ${prevArrowOutput}
                          ${pagesOutput}
                          ${nextArrowOutput}
                        </div>`;

                      $('.main-wrapper .container').append(paginationOutput);
                    }

                console.log('manage state 0.4', window.location.search);
                aldsec.filteringShowHideActive();

                $('.product__price--sale').each(function() {
                  var curEl = $(this);

                  var cafp = curEl.attr('data-xcafp');
                  var cafp = '';
                  cafp = cafp.replace(/'/g, '"')
                  if(cafp != '') {
                    cafp = JSON.parse(cafp);
                  }

                  if(cafp != '') {
                    if(cafp.defaults.hasOwnProperty(globalEsetcurrency)) {
                      var pricePrint = cafp.defaults[globalEsetcurrency] + '';
                      var currentPrice = curEl.prev().text();
                      var onlyPrice = currentPrice.match(/\d*\,?\d*?/g).join('');
                      pricePrint = currentPrice.replace(onlyPrice, pricePrint);
                      curEl.text(pricePrint).removeClass('temp-hidden-price');
                      curEl.removeClass('temp-hidden-price');
                    } else {
                      if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                        curEl.removeClass('temp-hidden-price')
                      } else {
                        var priceDetails2 = {
                          "Price": curEl.text().replace(',', '').replace('$', ''),
                          "Quantity": 1
                        };

                        var callback3 = function(localizedPrice) {
                          curEl.text(localizedPrice.SymboledPrice).removeClass('temp-hidden-price')
                        };
                      }

                    }

                    setTimeout(function() {
                      $('.product__price--sale').each(function() {
                        var curEl = $(this);

                        var cafp = curEl.attr('data-xcafp');
                        var cafp = '';
                        cafp = cafp.replace(/'/g, '"')
                        if(cafp != '') {
                          cafp = JSON.parse(cafp);
                        }

                        if(cafp != '') {
                          if(cafp.defaults.hasOwnProperty(globalEsetcurrency)) {

                            var pricePrint = cafp.defaults[globalEsetcurrency] + '';
                            var currentPrice = curEl.prev().text();
                            var onlyPrice = currentPrice.match(/\d*\,?\d*?/g).join('');

                            pricePrint = currentPrice.replace(onlyPrice, pricePrint);

                            curEl.text(pricePrint).removeClass('temp-hidden-price');
                            curEl.removeClass('temp-hidden-price');
                          } else {
                            if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                              curEl.removeClass('temp-hidden-price')
                            } else {
                              var priceDetails2 = {
                                "Price": curEl.text().replace(',', '').replace('$', ''),
                                "Quantity": 1
                              };

                              var callback3 = function(localizedPrice) {
                                curEl.text(localizedPrice.SymboledPrice).removeClass('temp-hidden-price')
                              };
                            }
                          }
                        }
                      });
                    }, 2000)
                  }
                });

              }

            });

            filterRequest.fail(function() {
              hideCollectionLoader();
            });
          }
        });
      }

      if($('body').hasClass('template-collection') && $('.filters-vintage').length === 1) {
        console.log('vintage filters');

        $('body').on('click', '.plp-product', function() {
          localStorage.setItem('persistentTop', $('html, body').scrollTop());
        });

/**************************************************/


        if(window.location.href.indexOf('&index') > -1) {

          console.log('>> persistent');

          var store = 'aime-leon-dore';
          if(window.location.host.indexOf('eu') > -1) {
            store = 'aime-leon-dore-eu';
          }
          if(window.location.host.indexOf('dev') > -1) {
            store = 'aime-leon-dore-dev-store';
          }
          if(window.location.host.indexOf('eu-dev') > -1) {
            store = 'aime-leon-dore-eu-dev';
          }
setTimeout(function() {
          var filters = decodeURIComponent(window.location.search.substring(1));
          filters = filters.split('&');
          var categoriesFilter = [];
          for(var i in filters) {

            var filter = filters[i];
            filter = filter.split('=');
            var filterKey = filter[0];
            var filterValue = filter[1];
            //console.log('>> filtervalue', filterValue, '[name='+filterValue+']', $('[name='+filterValue+']').length);
            if(filterKey==='index') {

$('.filter-toggle').trigger('mouseover');

              $('.current-collection').removeClass('current-collection');
              $('.vintages-list a').eq(filterValue).addClass('current-collection');

              var id = $('.vintages-list a').eq(filterValue).data('id');
              //id = $(this).data('id');
              $('.grid-products-vintage-visible').removeClass('grid-products-vintage-visible');
              // $('#vintage-products-'+id).addClass('grid-products-vintage-visible');
              $('.products-collection').parent().find('> div').eq(parseInt(id)-1).addClass('grid-products-vintage-visible');

              $('.collection-title').hide();
              $('.collection-title-'+id).show();

            } else if(filterKey === 'sold') {
              if(filterValue === 'true') {
                $('#showall').prop('checked', true);
                $('#xshowall').prop('checked', true);
                vintageHideSoldOut = true;
                // $('a.plp-product').hide();
                // $('a.plp-product[data-soldout=false]').show();
              } else {
                // $('a.plp-product').show();
              }
            } else if(filterKey === 'sort') {

              if(filterValue === 'asc') {
                $('#showall2, #xshowall2').prop('checked', true);
                vintageSortingEnabled = true;
              } else if(filterValue === 'desc') {
                $('#showall3, #xshowall3').prop('checked', true);
                vintageSortingEnabled = true;
              }

              if(filterValue === 'asc') {

                $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-0.products-collection');
                
                $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-1.products-collection');

                $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-2.products-collection');

                $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-3.products-collection');

                $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-4.products-collection');
              }

              if(filterValue === 'desc') {

                $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-0.products-collection');
                
                $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-1.products-collection');

                $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-2.products-collection');

                $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-3.products-collection');

                $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                  // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                  return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
                }).appendTo('#vintage-products-4.products-collection');
              }

            } else {
              // categoriesFilter.push(filterValue);
              var categoryName = filterValue;
              categoryName = categoryName.replace('--', '&');
              vintageCategoriesArray.push(categoryName);
              console.log('>>>>>>>>>>> oh my my >>>', vintageCategoriesArray)
            }

// $('#showall').trigger('change');
// $('#showall').trigger('change');

                // $('a.plp-product').each(function() {
                //   var type = $(this).data('type');
                //   if(categoriesFilter.indexOf(type) == -1) {
                //     $(this).show();
                //   }
                // });


            // if(vintageCategoriesArray.length === 0) {
            //   if(vintageHideSoldOut) {
            //     $('a.plp-product').hide();
            //     $('a.plp-product[data-soldout=false]').show();
            //   } else {
            //     $('a.plp-product').show();
            //   }
            // } else {
            //   if(vintageHideSoldOut) {
            //     $('a.plp-product').hide();
            //     $('a.plp-product[data-soldout=false]').each(function() {
            //       var type = $(this).data('type');
            //       if(vintageCategoriesArray.indexOf(type) > -1) {
            //         $(this).show();
            //       }
            //     });
            //   } else {
            //     $('a.plp-product').hide();
            //     $('a.plp-product').each(function() {
            //       var type = $(this).data('type');
            //       if(vintageCategoriesArray.indexOf(type) > -1) {
            //         $(this).show();
            //       }
            //     });
            //   }
            // }




            // $('[name='+filterValue+']').prop('checked', true);

            // if(filterKey == 'c') {
            //   colorsArr.push(filterValue);
            // } else if(filterKey == 's') {
            //   sizesArr.push(filterValue);
            // } else if(filterKey == 'v') {
            //   console.log(filterValue, '<<<<<<<<<<<<<<<<')
            //   if(filterValue === 'true') {
            //     soldout = false;
            //     $('#showall').prop('checked', true);
            //   }
            // }
          }



aldsec.vintageFiltersShowHideSummary();

}, 200);

          /*
          var jsonCollection = {
            'store_name': store,
            'collection': coll[2]
          }

          $.ajax({
            url: 'https://ald-filter-staging.herokuapp.com/api/collection_info',
            type: 'post',
            data: JSON.stringify(jsonCollection),
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
              console.log('> collection info >', response);
              var uniqueGroups = [];
              var uniqueSizes = 0;
              for(var i in response) {
                if(response[i].size_range != null) {
                  if(uniqueGroups.indexOf(response[i].size_range) == -1) {
                    uniqueGroups.push(response[i].size_range);
                  }
                  uniqueSizes++;
                }
              }
              if(uniqueSizes === 0) {
                $('.filter-menu__item').eq(0).hide();
              }

              var singleSize = true;
              if(uniqueGroups.length == 1) {

              } else {
                singleSize = false;
                for(var j in uniqueGroups) {
                  $('.filter-variant-list--sizes').append(`         <li>
                    <div class="filter-variant" role="button">${uniqueGroups[j]}<i class="filter-variant__ico"></i></div>
                    <ul class="filter-variant-list filter-variant-list-${j}"></ul>
                  </li>`);
                }
              }

              setTimeout(function() {
                var filters = decodeURIComponent(window.location.search.substring(1));
                filters = filters.split('&');
                var soldout = true;
                for(var i in filters) {
                  var filter = filters[i];
                  filter = filter.split('=');
                  var filterKey = filter[0];
                  var filterValue = filter[1];
                  console.log('>> filtervalue', filterValue, '[name='+filterValue+']', $('[name='+filterValue+']').length);

                  if(filterKey == 'c') {
                    $('[name='+filterValue+']').prop('checked', true);
                    colorsArr.push(filterValue);
                  } else if(filterKey.indexOf('s.') === 0) {
                    var range = slugToSizeRange(filterKey.substring(2));
                    $('input[data-type="size"][name="'+filterValue+'"][data-size-range="'+range+'"]').prop('checked', true);
                    if (findSizeIndex(sizesArr, filterValue, range) === -1) {
                      sizesArr.push({ name: filterValue, size_range: range });
                    }
                  } else if(filterKey == 'v') {
                    console.log(filterValue, '<<<<<<<<<<<<<<<<')
                    if(filterValue === 'true') {
                      soldout = false;
                      $('#showall').prop('checked', true);
                    }
                  }
                }

                var store = 'aime-leon-dore';
                if(window.location.host.indexOf('eu') > -1) {
                  store = 'aime-leon-dore-eu';
                }
                if(window.location.host.indexOf('dev') > -1) {
                  store = 'aime-leon-dore-dev-store';
                }
                if(window.location.host.indexOf('eu-dev') > -1) {
                  store = 'aime-leon-dore-eu-dev';
                }
                var filterJson = {
                  "store_name":store,
                  "collection": coll[2],
                  "sizes": sizesArr,
                  "colors": colorsArr,
                  "display_sold_out": soldout
                }
                // console.log('ga','Select Filter ' + type,'Filter value: '+val)
                // ga('send','event','Filtering','Select Filter ' + type,'Filter value: '+val);

                $.ajax({
                  url: 'https://ald-filter-staging.herokuapp.com/api/filter_products',
                  type: 'post',
                  data: JSON.stringify(filterJson),
                  cache: false,
                  dataType: 'json',
                  contentType: 'application/json',
                  success: function(response) {
                    $('.collection-title sup').text(response.length);

                    $('.products-collection.grid-products > *').remove();
                    for(var i in response) {
                      var soldout = '';
                      var colorsAvailable = '';
                      if(response[i].swatch_count === '1') {
                        colorsAvailable = "1 Color Available";
                      } else {
                        colorsAvailable = response[i].swatch_count+" Colors Available";
                      }
                      if(response[i].sold_out) {
                        soldout = '<div class="plp-product__tag">Sold out</div>';
                      }
                      $('.products-collection.grid-products').append(`<a href="/products/${response[i].handle}" class="plp-product" data-product-id="4798156800097">
                  <div class="image-4-5 product-image">
                    <img srcset="${response[i].image_url}" alt="Fleece Long-sleeve Tee">
                  </div>
                  <div class="short-desc plp-product__details">
                      ${soldout}
                    <h3 class="plp-product__title">${response[i].title}</h3>
                    <div class="plp-product__price">

                      <span class="money" data-currency-usd="$${response[i].handle}" data-currency="USD" style="visibility: visible;">$${response[i].local_price.price}</span>
                    </div>
                    <div class="plp-product__variants color-mg">
                      ${colorsAvailable}
                    </div>
                  </div>
                </a>`)
                    }

                    aldsec.filteringShowHideActive();

                    
                    var params = new URLSearchParams(window.location.search);
                    var startIndex = Number(params.get('startIndex'));
                    if(startIndex) {
                      handleStartIndexScroll();
                    } else {
                      // set position based on ls
                      $('html, body').scrollTop(localStorage.getItem('persistentTop'));
                    }
                  }
                });
              }, 500);
            }
          });
          */
        }


/**************************************************/

        $('.remove-all-vintage-filters').on('click', function() {
          $('#showall, #showall2, #showall3, #xshowall, #xshowall2, #xshowall3').prop('checked', false);
          vintageSortingEnabled = false;
          vintageCategoriesArray = [];
          vintageHideSoldOut = false;
          $('.filter-variant-list--categories input:checked').prop('checked', false);
          $('.vintage-noresults').hide();
          $('.applied-vintage-filters').hide();
            $('#vintage-products-0 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-0.products-collection');
          
            $('#vintage-products-1 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-1.products-collection');

            $('#vintage-products-2 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-2.products-collection');

            $('#vintage-products-3 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-3.products-collection');

            $('#vintage-products-4 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-4.products-collection');
          $('.plp-product').show();


            // build search location
            var searchString = '?';
            for(var i in colorsArr) {
              searchString += 'c='+colorsArr[i]+'&';
            }
            var sizesQs = sizesToSearchString(sizesArr);
            if (sizesQs) {
              searchString += sizesQs + '&';
            }
            if($('#showall').prop('checked') == true || $('#xshowall').prop('checked') == true) {
              searchString += 'v=true&';
            } else {
              searchString += 'v=false&';
            }

            if($('#showsale').prop('checked') == true) {
              searchString += 'ss=true';
            } else {
              searchString += 'ss=false';
            }

            searchString = '';

            console.log(searchString);
            window.history.pushState('', '', window.location.protocol+'//'+window.location.host+window.location.pathname+searchString);

          return false;
        });

        collectionHandle = window.location.pathname;
        coll = collectionHandle.split("/");

        $('.filter-dropdown').on('mouseover', function() {
          console.log('hover vintage');
          if(!$(this).hasClass('loaded')) {
            /*
            $('#vintage-products-loaded').load(location.href + '?view=all #vintage-all-products', function() {
              $('#vintage-products-loaded').show();
              $('#vintage-products-initial').hide();
              $('.pagination').hide();
            });
            */

            var store = 'aime-leon-dore';
            if(window.location.host.indexOf('eu') > -1) {
              store = 'aime-leon-dore-eu';
            }
            if(window.location.host.indexOf('dev') > -1) {
              store = 'aime-leon-dore-dev-store';
            }
            if(window.location.host.indexOf('eu-dev') > -1) {
              store = 'aime-leon-dore-eu-dev';
            }
            var jsonCollection = {
              'store_name': store,
              'collection': coll[2],
              'location_id': 60893495393,
            }

            $.ajax({
              url: 'https://ald-filter-staging.herokuapp.com/api/collection_info',
              type: 'post',
              data: JSON.stringify(jsonCollection),
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
    
              success: function(response) {
                console.log('> collection info >', response);

                var store = 'aime-leon-dore';
                if(window.location.host.indexOf('eu') > -1) {
                  store = 'aime-leon-dore-eu';
                }
                if(window.location.host.indexOf('dev') > -1) {
                  store = 'aime-leon-dore-dev-store';
                }
                if(window.location.host.indexOf('eu-dev') > -1) {
                  store = 'aime-leon-dore-eu-dev';
                }
                var filterJson = {
                  "store_name":store,
                  "collection": coll[2],
                  "sizes": [],
                  "colors": [],
                  "display_sold_out": true,
                  "location_id": 60893495393,
            'for_sales': false
                }
                if(typeof ga === 'function') {
                  //ga('send','event','Filtering','Select Filter ' + type,'Filter value: '+val);
                }
remainingProductsFromFilters = [];
                // vintage call
                $.ajax({
                  url: 'https://ald-filter-staging.herokuapp.com/api/filter_products',
                  type: 'post',
                  data: JSON.stringify(filterJson),
                  cache: false,
                  dataType: 'json',
                  contentType: 'application/json',
    
                  success: function(response) {
                    console.log('>> hello results >>', response);$('.loading-filters').remove();

                    var uniqueCategoriesList = [];

                    for(var i in response) {
                      var tags = response[i].tags;
                      tags = tags.split(', ');
                      for(var j in tags) {
                        if(tags[j].indexOf('vintage-category') === 0) {
                          var tag = tags[j].slice(17);
                          if(!uniqueCategoriesList.includes(tag)) {
                            uniqueCategoriesList.push(tag);
                          }
                        }
                      }
                    }

                    console.log(uniqueCategoriesList);

                    uniqueCategoriesList.sort();

                    if(vintageCategoriesArray.length > 0 || vintageHideSoldOut || vintageFilteringEnabled) {
                      if(vintageCategoriesArray.length > 0) {
                        for(var i in vintageCategoriesArray) {
                          $('[data-name="'+vintageCategoriesArray[i]+'"]').prop('checked', true);
                        }
                      }
                      aldsec.customRenderVintage();
                    }

                    aldsec.filteringShowHideActive();
                  }
                });
              }
            });

            $(this).addClass('loaded');
          }
        });

        $('.filter-variant-list--categories').on('change', 'input', function() {
          var selected = $(this).prop('checked');

          if(selected === false) {
            var index = vintageCategoriesArray.indexOf($(this).data('name'));
            vintageCategoriesArray.splice(index, 1);
          }

          if(selected === true) {
            vintageCategoriesArray.push($(this).data('name'));
          }

          console.log('vintageCategoriesArray');
          console.log(vintageCategoriesArray);

          if(vintageCategoriesArray.length === 0) {
            if(vintageHideSoldOut) {
              $('a.plp-product').hide();
              $('a.plp-product[data-soldout=false]').show();
            } else {
              $('a.plp-product').show();
            }
          } else {
            if(vintageHideSoldOut) {
              $('a.plp-product').hide();
              $('a.plp-product[data-soldout=false]').each(function() {
                var type = $(this).data('type');
                if(vintageCategoriesArray.indexOf(type) > -1) {
                  $(this).show();
                }
              });
            } else {
              $('a.plp-product').hide();
              $('a.plp-product').each(function() {
                var type = $(this).data('type');
                if(vintageCategoriesArray.indexOf(type) > -1) {
                  $(this).show();
                }
              });
            }
          }

          aldsec.vintageFiltersShowHideSummary();

        });

        $('.filter-variant-list--vintage-options, .filter-custom-checkbox-rightaligned').on('change', 'input', function() {
          var setting = $(this).prop('checked');
          var type = $(this).data('type');

          console.log('>> ', setting, type);

          if(setting && (type === 'sortdesc' || type === 'sortasc')) {
            vintageSortingEnabled = true;

            if(type === 'sortasc') {
              $('#showall3, #xshowall3').prop('checked', false);

              $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-0.products-collection');

              $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-1.products-collection');

              $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-2.products-collection');

              $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-3.products-collection');

              $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-4.products-collection');
            }

            if(type === 'sortdesc') {
              $('#showall2, #xshowall2').prop('checked', false);

              $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-0.products-collection');

              $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-1.products-collection');

              $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-2.products-collection');

              $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-3.products-collection');

              $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-4.products-collection');
            }
          }

          if(!setting && (type === 'sortdesc' || type === 'sortasc')) {
            vintageSortingEnabled = false;

            $('#vintage-products-0 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-0.products-collection');

            $('#vintage-products-1 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-1.products-collection');

            $('#vintage-products-2 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-2.products-collection');

            $('#vintage-products-3 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-3.products-collection');

            $('#vintage-products-4 a.plp-product').sort(function(a, b) {
              // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
              return parseInt(($(a).data('originalorder')+'').replace(',', '')) - parseInt(($(b).data('originalorder')+'').replace(',', ''))
            }).appendTo('#vintage-products-4.products-collection');
          }

          if(setting && type === 'viewtype') {
            vintageHideSoldOut = true;

            //$('#vintage-products-loaded a.plp-product[data-soldout=true]').hide();

            if(vintageCategoriesArray.length === 0) {
              if(vintageHideSoldOut) {
                $('a.plp-product').hide();
                $('a.plp-product[data-soldout=false]').show();
              } else {
                $('a.plp-product').show();
              }
            } else {
              if(vintageHideSoldOut) {
                $('a.plp-product').hide();
                $('a.plp-product[data-soldout=false]').each(function() {
                  var type = $(this).data('type');
                  if(vintageCategoriesArray.indexOf(type) > -1) {
                    $(this).show();
                  }
                });
              } else {
                $('a.plp-product').hide();
                $('a.plp-product').each(function() {
                  var type = $(this).data('type');
                  if(vintageCategoriesArray.indexOf(type) > -1) {
                    $(this).show();
                  }
                });
              }
            }
          }

          if(!setting && type === 'viewtype') {
            vintageHideSoldOut = false;

            //$('#vintage-products-loaded a.plp-product[data-soldout=true]').show();

            if(vintageCategoriesArray.length === 0) {
              if(vintageHideSoldOut) {
                $('a.plp-product').hide();
                $('a.plp-product[data-soldout=false]').show();
              } else {
                $('a.plp-product').show();
              }
            } else {
              if(vintageHideSoldOut) {
                $('a.plp-product').hide();
                $('a.plp-product[data-soldout=false]').each(function() {
                  var type = $(this).data('type');
                  if(vintageCategoriesArray.indexOf(type) > -1) {
                    $(this).show();
                  }
                });
              } else {
                $('a.plp-product').hide();
                $('a.plp-product').each(function() {
                  var type = $(this).data('type');
                  if(vintageCategoriesArray.indexOf(type) > -1) {
                    $(this).show();
                  }
                });
              }
            }
          }



          aldsec.vintageFiltersShowHideSummary();
        });
      }
      
        //track Clear all filters
        var $clearFilters = $('.remove-all-filters');
        $clearFilters.on('click', function() {
            if(typeof gtag === 'function') {
                gtag('event', 'Filtering remove all filters');

                // category events
                const categoryTitle = $('.category-menu-toggle').text().trim();
                gtag('event', `${categoryTitle}_Clear All Filters`);
            }
        })
        
        //track Collection select
        var $collectionsMenus = $('.filter-variant-list--mainline, .filter-variant-list--partnership, .filter-variant-list--categories')
        $collectionsMenus.on('click','.filter-variant', function(e) {
            var collectionType = $(this).closest('.filter-menu__item').children('.filter-variant').text();
            if(typeof gtag === 'function') {
                gtag('event', 'Filtering Collections', {
                    'filter_value': $(this).text(),
                    'filter_type': collectionType
                })
            }
            
        })
    },

    vintageFiltersShowHideSummary: function() {
      $('.vintage-noresults').hide();
      console.log(' . . . - - - ');

      if(vintageCategoriesArray.length > 0 || vintageHideSoldOut || vintageSortingEnabled) {
        $('.applied-vintage-filters__list *').remove();

        $('.applied-vintage-filters').show();

        for(var i in vintageCategoriesArray) {
          $('.applied-vintage-filters__list').append(`<li>${vintageCategoriesArray[i]}</li>`);
        }

        if(vintageHideSoldOut) {
          $('.applied-vintage-filters__list').append(`<li>Hide sold out products</li>`);
        }

        if(vintageSortingEnabled) {
          var txt = 'Ascending price';
          if($('#showall3').prop('checked') || $('#xshowall3').prop('checked')) {
            txt = 'Descending price';
          }

          $('.applied-vintage-filters__list').append(`<li>${txt}</li>`);
        }
      } else {
        $('.applied-vintage-filters').hide();

        $('.applied-vintage-filters__list *').remove();
      }

      $('.grid-products-vintage').each(function() {
        var visibleElements = $(this).find('a:not([style*="display: none"])');

        if(visibleElements.length === 0) {
          $(this).find('.vintage-noresults').show();
        }

        console.log('visible elements:', $(this).find('a').length, visibleElements.length)
      });


            // build search location
            var searchString = '?';
            for(var i in vintageCategoriesArray) {
              var categoryName = vintageCategoriesArray[i];
              categoryName = categoryName.replace('&', '--');
              searchString += 'c='+categoryName+'&';
            }
            if(vintageHideSoldOut) {
              searchString += 'sold=true&';
            } else {
              searchString += 'sold=false&';
            }
            if(vintageSortingEnabled) {
              if($('#showall3').prop('checked') || $('#xshowall3').prop('checked')) {
                searchString += 'sort=desc&';
              }
              if($('#showall2').prop('checked') || $('#xshowall2').prop('checked')) {
                searchString += 'sort=asc&';
              }
            } else {
              searchString += 'sort=false&';
            }
            searchString += 'index='+$('.current-collection').index();

            // const defaultSearchStringParams = [
            //     'sold=false',
            //     'sort=false',
            //     'index='+$('.current-collection').index()
            // ]
            const isDefaultFiltering = function (searchString) {
                const defaults = [
                    'sold=false',
                    'sort=false',
                    'index=0'
                ]
                const params = searchString?.split('&').map((param) => param.replace('?','')) || []
                return !params.filter((param) => !defaults.includes(param)).length
            }

            console.log(searchString);
            if(isDefaultFiltering(searchString)) {
                searchString = '';
            }
            window.history.pushState('', '', window.location.protocol+'//'+window.location.host+window.location.pathname+searchString);


    },

    filteringShowHideActive: function() {
      console.log('manage state', window.location.search);
      var sizesArrLen = sizesArr.length;
      var colorsArrLen = colorsArr.length;
      if(sizesArrLen+colorsArrLen > 0) {
        $('.applied-filters').show();
        $('.applied-filters__list *').remove();
        for(var i in sizesArr) {
          $('.applied-filters__list').append(`<li data-size-range="${sizesArr[i].size_range}">${sizesArr[i].name}</li>`);
        }
        for(var i in colorsArr) {
          $('.applied-filters__list').append(`<li>${colorsArr[i]}</li>`);
        }
      } else {
        $('.applied-filters__list *').remove();
        $('.applied-filters').hide();
      }
      if(sizesArr.length == 0 && colorsArr.length == 0) {
        $('.filter-toggle sup').text('');
      } else {
        $('.filter-toggle sup').text(sizesArr.length + colorsArr.length);
      }
      console.log('manage state 2', window.location.search);
      handleStartIndexScroll();
    },

    filteringVintageDisplaySwitch: function() {
      if(vintageSortingEnabled || vintageHideSoldOut || vintageFilteringEnabled) {
        $('#vintage-products-loaded').show();
        $('#vintage-products-initial').hide();
      } else {
        $('#vintage-products-loaded').hide();
        $('#vintage-products-initial').show();
      }
    },

    customRenderVintage: function() {
console.log('>> custom render vintage', vintageCategoriesArray, vintageHideSoldOut);

          if(vintageSortingEnabled) {

            if(window.location.search.indexOf('=asc') > -1) {
              // $('#showall3').prop('checked', false);

              $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-0.products-collection');
              
              $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-1.products-collection');

              $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-2.products-collection');

              $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-3.products-collection');

              $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(a).data('price')+'').replace(',', '')) - parseInt(($(b).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-4.products-collection');
            }

            if(window.location.search.indexOf('=desc') > -1) {
              // $('#showall2').prop('checked', false);

              $('#vintage-products-0 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-0.products-collection');
              
              $('#vintage-products-1 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-1.products-collection');

              $('#vintage-products-2 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-2.products-collection');

              $('#vintage-products-3 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-3.products-collection');

              $('#vintage-products-4 a.plp-product').sort(function(a, b) {
                // console.log(parseInt($(a).data('price')), parseInt($(b).data('price')))
                return parseInt(($(b).data('price')+'').replace(',', '')) - parseInt(($(a).data('price')+'').replace(',', ''))
              }).appendTo('#vintage-products-4.products-collection');
            }
          }


          if(vintageCategoriesArray.length === 0) {
            if(vintageHideSoldOut) {
              $('a.plp-product').hide();
              $('a.plp-product[data-soldout=false]').show();
            } else {
              $('a.plp-product').show();
            }
          } else {
            if(vintageHideSoldOut) {
              $('a.plp-product').hide();
              $('a.plp-product[data-soldout=false]').each(function() {
                var type = $(this).data('type');
                if(vintageCategoriesArray.indexOf(type) > -1) {
                  $(this).show();
                }
              });
            } else {
              $('a.plp-product').hide();
              $('a.plp-product').each(function() {
                var type = $(this).data('type');
                if(vintageCategoriesArray.indexOf(type) > -1) {
                  $(this).show();
                }
              });
            }
          }

          aldsec.vintageFiltersShowHideSummary();

          var params = new URLSearchParams(window.location.search);
          var startIndex = Number(params.get('startIndex'));
          if(startIndex) {
            handleStartIndexScroll();
          } else {
            $('html, body').scrollTop(localStorage.getItem('persistentTop'));
          }
    }
  };

  // exposed so the view-all handler can intercept the filter path
  window.aldsec = aldsec;

  $(function () {
    aldsec.init();
  });

})(jQuery);

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}

function handleInfinityScroll() {
  console.log('handle inifnity scroll <<< ')
  var itemsPerPage = 64;

  // initial load
  var params = new URLSearchParams(window.location.search);
  var startIndex = Number(params.get('startIndex'));
  var startIndexOffset = Number(params.get('startIndexOffset'));
  if(startIndex) {

    $(".plp-product:lt(" + Math.ceil(startIndex/itemsPerPage) * itemsPerPage + ")").each(function() {
      $(this).find('img').each(function() {
        $(this).attr('src', $(this).data('src'));
      });
    });

    $(".plp-product:lt(" + Math.ceil(startIndex/itemsPerPage) * itemsPerPage + ")").show();

    setTimeout(function () {
      if($('.plp-product').eq(startIndex).length) {
        var scrollPosition = $('.plp-product').eq(startIndex).offset().top - startIndexOffset;
        if($(window).scrollTop() === 0 && scrollPosition > 100) {
          $('html').scrollTop(scrollPosition);
        }
      }
    }, 1000)
  } else {
    $(".plp-product:lt(" + itemsPerPage + ")").each(function() {
      $(this).find('img').each(function() {
        $(this).removeAttr('style');
        $(this).attr('src', $(this).data('src'));
      });
    });

    $(".plp-product:lt(" + itemsPerPage + ")").show();
  }

  function loadMoreItems() {
    console.log('filter products load more items - decision', remainingProductsFromFilters.length);

    if(remainingProductsFromFilters.length) {
      console.log('filter products load more items - remaining from memory', remainingProductsFromFilters.length);

      remainingProductsFromFilters.forEach(function(item, index) {
        if(index < 64) {

                        var soldout = '';
                        var colorsAvailable = '';
                        if(item.swatch_count === '1') {
                          colorsAvailable = "1 Color Available";
                        } else {
                          colorsAvailable = item.swatch_count+" Colors Available";
                          if(item.swatch_count === null) {
                            colorsAvailable = '';
                          }
                        }
                        if(item.sold_out) {
                          soldout = '<div class="plp-product__tag">SOLD OUT</div>';
                        }

                        var dataFP = '';
                        if(item.metafields != null) {
                          var metaLength = item.metafields.length;
                          dataFP = 'data-fp="'+item.metafields[0]['data-fp']+'"';
                          if(metaLength > 1) {
                            if(dataFP == 'data-fp=""') {
                              dataFP = 'data-fp="'+item.metafields[1]['data-fp']+'"';
                            }
                          }
                        }
                        dataFP = dataFP.replace(/\s/g, '');

                        var customTagSupress = '';
                        if(item.metafields != null) {
                          var metaLength = item.metafields.length;
                          if(item.metafields[0]['custom_tag_name_text']) {
                            customTagSupress = item.metafields[0]['custom_tag_name_text'];  
                          }
                          if(metaLength > 1) {
                            if(item.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = item.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        var price = item.local_price.price + '';

                        var compareAtPrice = '';
                        if(!!item.local_price.compare_at_price && !item.sold_out) {
                          if(item.local_price.compare_at_price > item.local_price.price) {
                            var clocalizedString = Shopify.locale+'-'+Shopify.country;
                            var clocalizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: item.local_price.currency, maximumFractionDigits: 0}).format(item.local_price.compare_at_price)
                            clocalizedPriceWithSymbol = formatPrice(item.local_price.compare_at_price, item.local_price.currency);
                            compareAtPrice = '<s class="product__price product__price--sale"  style="font-size: inherit">'+clocalizedPriceWithSymbol+'</s>';
                          }
                        }

                        var imgToDisplay = item.images[1] ? item.images[1].url : item.image_url;
                        imgToDisplay = '<img data-srcset="'+imgToDisplay+'" alt="">';

                        if(plpCarousel) {
                          imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

                          for(var j in item.images) {
                            if(j > 0) {
                              if(item.images[j].alt != 'dev-product-image-swatch') {
                                if(j > 1) {
                                  imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+item.images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" style="display: none" loading="lazy"></div></li>';
                                } else {
                                  if(i >= 64) {
                                    imgToDisplay += '<li><div class="plp-carousel__item"><img data-src="'+item.images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';
                                  } else {
                                    imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+item.images[j].url+'&width=600" alt="" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)"></div></li>';
                                  }
                                }
                                
                              }
                            }
                          }
                          imgToDisplay += '</ul></div></div>';
                        }

                        var product = item;

                        var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$' + price;

                        var customTag = '';
                        var additionalClassWide = '';
                        if(!product.sold_out) {
                          if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                            customTag = '<div class="plp-product__tag">Reserve</div>';
                          }
                          if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                            customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                          }
                          if(product.tags.indexOf('NEW_PRODUCT') > -1) {
                            customTag = '<div class="plp-product__tag">NEW</div>  ';
                          }
            customTag = getOverImageBadges(product);

                          // if(product.tags.indexOf(customTagName) > -1) {
                          //   if(customTagSupress != '') {
                          //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
                          //   } else {
                          //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
                          //   }
                            
                          // }
                        } else {
                          if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                            soldOutHTML = 'RESERVATIONS FULL';
                          }
                          if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                            soldOutHTML = 'ENTER THE DRAW';
                          }
                          if(product.tags.indexOf('dev-in-store-only') > -1) {
                            soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
                            if(product.metafields != null) {
                              var metaLength = product.metafields.length;
                              if(product.metafields[0]['instorelabel']) {
                                soldOutHTML = product.metafields[0]['instorelabel'];  
                              }
                              if(metaLength > 1) {
                                if(customTagSupress == '') {
                                 if(product.metafields[1]['instorelabel']) {
                                    soldOutHTML = product.metafields[1]['instorelabel'];  
                                  }
                                }
                              }
                            }
                          }
                          if(product.tags.indexOf('dev-coming-soon') > -1) {
                            soldOutHTML = 'COMING SOON';
                          }
            customTag = getOverImageBadges(product);
                                      if(product.tags.indexOf('dev-product-wide-plp') > -1) {
                            additionalClassWide = ' product-image-wide';
                            soldOutHTML = widePlp;
                          }
                        }

                        var displayIt = true;
                        if(product.tags.indexOf('dev-product-wide-plp') > -1) {
                          if(sizesArr.length > 0 || colorsArr.length > 0) {
                            displayIt = false;
                          }
                          
                          imgToDisplay = '';
                          for(var j in item.images) {
                            var wideProductImgClass = '';
                            if(item.images[j].alt != null) {
                              if(item.images[j].alt.indexOf('dev-wide-plp') > -1) {
                                if(item.images[j].alt == 'dev-wide-plp-1') {
                                  wideProductImgClass = ' product-image--oc';
                                }
                                if(item.images[j].alt == 'dev-wide-plp-2') {
                                  wideProductImgClass = ' product-image--tc';
                                }
                                if(item.images[j].alt == 'dev-wide-plp-4') {
                                  wideProductImgClass = ' product-image--fc';
                                }

                                imgToDisplay += '<img src="'+item.images[j].url+'" alt="" class="product-wide'+wideProductImgClass+'">';
                              }
                            }
                          }
                        }

                        var localizedString = Shopify.locale+'-'+Shopify.country;
                        var localizedPriceWithSymbol = new Intl.NumberFormat(localizedString, {style: 'currency', currency: item.local_price.currency, maximumFractionDigits: 0}).format(item.local_price.price)

                        localizedPriceWithSymbol = formatPrice(item.local_price.price, item.local_price.currency);

  if(window.location.href.indexOf('end-of-season-sale') > -1) {
    if(!!item.local_price.compare_at_price) {
    if(item.local_price.compare_at_price == item.local_price.price) {
      displayIt = false;
    }
      }
  }
          
                        if(displayIt) {
                          const createdAtStr = item?.created_at;
                          const createdAtMs = new Date(createdAtStr).getTime(); 
                          let hasNewArrivals = false;
                          if (item.tags && item.tags.indexOf('newarrivals') !== -1) {
                            hasNewArrivals = true;
                          }
                          let shouldHidePrice = false;
                          if (item.tags && item.tags.indexOf('dev-hide-product-price') !== -1) {
                            shouldHidePrice = true;
                          }

                          var customHidingStyle = '';
                          if(i >= 64) {
                              customHidingStyle = ' style="display: none"';
                          }
                          // sold out products show their status label instead of the price
                          if(product.sold_out) {
                            localizedPriceWithSymbol = soldOutHTML;
                          }

                          $('.products-collection.grid-products').append(`
                            <a href="/products/${item.handle}" class="plp-product ${additionalClassWide} ${shouldHidePrice ? 'plp-product--hide-price' : ''}" data-product-id="4798156800097" data-price="${price}" data-title="${item.title}" data-created-at="${createdAtMs}" data-newarrival="${hasNewArrivals}" data-index="${i}" ${customHidingStyle}>

                              <div class="image-4-5 product-image">
                                ${customTag}
                                ${imgToDisplay}
                              </div>
                              <div class="temp-fix-scaling"></div>
                              <div class="short-desc plp-product__details">
                                <h3 class="plp-product__title">${item.title}</h3>
                                <div class="plp-product__price ${ (item.local_price.compare_at_price > price && !item.sold_out) ? 'plp-product__price--compare' : ''}">
                                  <span style="display: none;" class="money xxx2money" ${dataFP} data-currency-usd="${price}" data-currency="USD" data-ge-price  style="visibility: visible;">${ soldOutHTML }</span>
                                  <span style="display: none;">${compareAtPrice}</span>
                                  <span class="money">${ localizedPriceWithSymbol }</span>
                                  ${compareAtPrice}
                                </div>
                              </div>
                            </a>`
                          );
                        }

        }
      });
      console.log('filter products before removal', remainingProductsFromFilters.length, remainingProductsFromFilters);
      remainingProductsFromFilters = remainingProductsFromFilters.slice(64);
      console.log('filter products after removal', remainingProductsFromFilters.length, remainingProductsFromFilters);

    } else {
      console.log('filter products load more items - regular load', remainingProductsFromFilters, remainingProductsFromFilters.length);

      $(".plp-product:hidden:lt(" + itemsPerPage + ") img").each(function() {
        $(this).attr('src', $(this).data('src'));
      });

      $(".plp-product:hidden:lt(" + itemsPerPage + ")").show();
    }

  }

  // handleInfinityScroll runs again on every sort and clear-sort, so bind through
  // a namespace and drop the previous handlers first. Without this they accumulate:
  // after N sorts each scroll event runs the :hidden lookup N times, and jQuery's
  // :hidden forces a layout - which costs more now View All can load a whole
  // collection into the grid.
  $(window).off('scroll.infinityScroll').on('scroll.infinityScroll', function() {
    if ($(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
      loadMoreItems();
    }
  });

  $(".plp-product").off('click.startIndex').on("click.startIndex", function (e) {
    var clickedIndex = $(e.currentTarget).index();
    var offset = Math.floor(e.currentTarget.getBoundingClientRect().top || 0);
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('startIndex', clickedIndex);
    if(offset) {
      currentUrl.searchParams.set('startIndexOffset', offset);
    }
    window.history.replaceState(null, null, currentUrl.toString());
  });
};


function handleStartIndexScroll() {
  var params = new URLSearchParams(window.location.search);
  var startIndex = Number(params.get('startIndex'));
  var startIndexOffset = Number(params.get('startIndexOffset'));
  if(startIndex) {
    setTimeout(function () {
      var scrollPosition = $('.plp-product').eq(startIndex).offset().top - startIndexOffset;
      if($(window).scrollTop() === 0 && scrollPosition > 100) {
        $('html').scrollTop(scrollPosition);
      }
    }, 1000)
  }

  $(".plp-product").on("click", function (e) {
    var clickedIndex = $(e.currentTarget).index();
    var offset = Math.floor(e.currentTarget.getBoundingClientRect().top || 0);
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('startIndex', clickedIndex);
    if(offset) {
      currentUrl.searchParams.set('startIndexOffset', offset);
    }
    window.history.replaceState(null, null, currentUrl.toString());
  });
};

/* new page - collections */
$(document).ready(function() {
  if(window.location.href.indexOf('') > -1) {
    console.log('yay');

    var collectionsInfo = [];

    $('.products-collection').each(function() {
      collectionsInfo.push({
            'handle': $(this).data('handle'),
            'productsToReturn': 8,

      "display_sold_out": true
      })
    });

    var store = 'aime-leon-dore';
    if(window.location.host.indexOf('eu') > -1) {
      store = 'aime-leon-dore-eu';
    }
    if(window.location.host.indexOf('dev') > -1) {
      store = 'aime-leon-dore-dev-store';
    }
    if(window.location.host.indexOf('eu-dev') > -1) {
      store = 'aime-leon-dore-eu-dev';
    }

    var dataObject = {
      'store_name': store,
      'collections_info': collectionsInfo,
      "display_sold_out": true,
      "iso_code": Shopify.country
    }

    if(window.location.host.indexOf('eu') > -1) {
      var locationId = 50003247253;
      if($('body').attr('data-country') == 'GB') {
        locationId = 74146152597;
      }

      var dataObject = {
        "store_name":store,
        'collections_info': collectionsInfo,
        "display_sold_out": true,
        "iso_code": Shopify.country,
        "location_id": locationId
      }
    }

    if(window.location.host.indexOf('eu-dev') > -1) {
      var locationId = 53200584866;
      if($('body').attr('data-country') == 'GB') {
        locationId = 70879314089;
      }

      var dataObject = {
        "store_name":store,
        'collections_info': collectionsInfo,
        "display_sold_out": true,
        "iso_code": Shopify.country,
        "location_id": locationId
      }
    }

    var counter = 0;
    $.ajax({
      url: 'https://ald-filter-staging.herokuapp.com/api/get_collections_products',
      type: 'post',
      data: JSON.stringify(dataObject),
      cache: false,
      dataType: 'json',
      contentType: 'application/json',
    
      success: function(response) {
        console.log('getcollectionsproducts', response)

        for(var i in response[0].products) {
          console.log(response[0].products[i]);
          var product = response[0].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;

          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
          var imgToDisplay = product.images[1] ? Object.keys(product.images[1])[0] : product.image_url;

                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          /*
              
                <div class="plp-product__tag">
                  
                  <!-- Sold out -->
                  
                </div>
              
              
              */

          var customTag = '';
          var additionalClassWide = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
              
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'

              var clocalizedPriceWithSymbol = formatPrice(product.local_price.compare_at_price, product.local_price.currency);
              compareAtPrice = '<span class="plp-product__price__compare">'+clocalizedPriceWithSymbol+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
                        if(product.tags.indexOf('dev-product-wide-plp') > -1) {
              additionalClassWide = ' product-image-wide';
              soldOutHTML = widePlp;
            }
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';

var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);

          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }


          var nonUSProduct = '';
          var nonUSProductTpl = '';
          if(product.tags.indexOf('dev-non-us-oos') > -1) {

            if(Shopify.country !== 'US') {
              for(const i in product.metafields) {
                if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                  soldOutHTML = product.metafields[i]['non_us_oos_label']
                }
              }
            }
          }
console.log('badge 2', customTag)
          $('#collection-1').append(`
          <a href="/products/${product.handle}" class="plp-product ${additionalClassWide} ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ localizedPriceWithSymbol }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }

        if(counter < 8) {
          $('#collection-1').next().find('a').text('view collection');
        }

        counter = 0;

        for(var i in response[1].products) {
          console.log(response[1].products[i]);
          var product = response[1].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalClassWide = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              var clocalizedPriceWithSymbol = formatPrice(product.local_price.compare_at_price, product.local_price.currency);
              compareAtPrice = '<span class="plp-product__price__compare">'+clocalizedPriceWithSymbol+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
                        if(product.tags.indexOf('dev-product-wide-plp') > -1) {
              additionalClassWide = ' product-image-wide';
              soldOutHTML = widePlp;
            }
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';


var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }

          $('#collection-2').append(`
          <a href="/products/${product.handle}" class="plp-product ${additionalClassWide} ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }

        if(counter < 8) {
          $('#collection-2').next().find('a').text('view collection');
        }

        counter = 0;

        for(var i in response[2].products) {
          console.log(response[2].products[i]);
          var product = response[2].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              var clocalizedPriceWithSymbol = formatPrice(product.local_price.compare_at_price, product.local_price.currency);
              compareAtPrice = '<span class="plp-product__price__compare">'+clocalizedPriceWithSymbol+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';


var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);

          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-3').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }

        if(counter < 8) {
          $('#collection-3').next().find('a').text('view collection');
        }

        counter = 0;

        for(var i in response[3].products) {
          console.log(response[3].products[i]);
          var product = response[3].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              var clocalizedPriceWithSymbol = formatPrice(product.local_price.compare_at_price, product.local_price.currency);
              compareAtPrice = '<span class="plp-product__price__compare">'+clocalizedPriceWithSymbol+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';


var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-4').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }

        if(counter < 8) {
          $('#collection-4').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 4) {
        for(var i in response[4].products) {
          console.log(response[4].products[i]);
          var product = response[4].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';


var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-5').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}

        if(counter < 8) {
          $('#collection-5').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 5) {
        for(var i in response[5].products) {
          console.log(response[5].products[i]);
          var product = response[5].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-6').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-6').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 5) {
        for(var i in response[6].products) {
          console.log(response[6].products[i]);
          var product = response[6].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-7').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-7').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 7) {
        for(var i in response[7].products) {
          console.log(response[7].products[i]);
          var product = response[7].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';

                      var customTagSupress = '';
                      if(product.metafields != null) {
                        var metaLength = product.metafields.length;
                        if(product.metafields[0]['custom_tag_name_text']) {
                          customTagSupress = product.metafields[0]['custom_tag_name_text'];  
                        }
                        if(metaLength > 1) {
                          if(customTagSupress == '') {
                           if(product.metafields[1]['custom_tag_name_text']) {
                              customTagSupress = product.metafields[1]['custom_tag_name_text'];  
                            }
                          }
                        }
                        
                      }

          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   if(customTagSupress != '') {
            //     customTag = '<div class="plp-product__tag">'+customTagSupress+'</div>  ';
            //   } else {
            //       customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            //   }
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            if(product.tags.indexOf('dev-product-wide-plp') > -1) {
              soldOutHTML = '';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-8').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-8').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 7) {
        for(var i in response[8].products) {
          console.log(response[8].products[i]);
          var product = response[8].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            if(product.tags.indexOf(customTagName) > -1 && customTagName != '') {
              customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }
console.log('9 custag', customTag);
          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          // if(customTag != '') {
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-9').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          // }
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-9').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 9) {
        for(var i in response[9].products) {
          console.log(response[9].products[i]);
          var product = response[9].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var localizedPriceWithSymbol = formatPrice(product.local_price.price, product.local_price.currency);
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = localizedPriceWithSymbol;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-10').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-10').next().find('a').text('view collection');
        }

        counter = 0;

if(response.length > 10) {
        for(var i in response[10].products) {
          console.log(response[10].products[i]);
          var product = response[10].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-11').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-11').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 15) {
        for(var i in response[11].products) {
          console.log(response[11].products[i]);
          var product = response[11].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-12').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-12').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 15) {
        for(var i in response[12].products) {
          console.log(response[12].products[i]);
          var product = response[12].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-13').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-13').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 15) {
        for(var i in response[13].products) {
          console.log(response[13].products[i]);
          var product = response[13].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-14').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-14').next().find('a').text('view collection');
        }

        counter = 0;
if(response.length > 15) {
        for(var i in response[14].products) {
          console.log(response[14].products[i]);
          var product = response[14].products[i];
          var swatchCount = product.swatch_count === null ? swatchCount = 1 : swatchCount = product.swatch_count;
          var soldOutHTML = product.sold_out ? soldOutHTML = "SOLD OUT" : soldOutHTML = '$'+product.price;
                      var imgToDisplay = product.images[1] ? product.images[1].url : product.image_url;
                      imgToDisplay = '<img srcset="'+imgToDisplay+'" alt="">';
if(plpCarousel) {
  imgToDisplay = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

  for(var j in product.images) {
    if(j > 0) {
      if(product.images[j].alt != 'dev-product-image-swatch') {
        if(j > 1) {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" style="display: none" alt="'+product.title+'"></div></li>';
        } else {
          imgToDisplay += '<li><div class="plp-carousel__item"><img src="'+product.images[j].url+'&width=800" class="plp-carousel__image" draggable="false" onload="plpFirstImageLoaded(this)" alt="'+product.title+'"></div></li>';
        }
        
      }
    }
  }
  imgToDisplay += '</ul></div></div>';
}

          var customTag = '';
          var additionalPriceClass = '';
          var compareAtPrice = '';
          if(!product.sold_out) {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">Reserve</div>';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
            }
            if(product.tags.indexOf('NEW_PRODUCT') > -1) {
              customTag = '<div class="plp-product__tag">NEW</div>  ';
            }
            customTag = getOverImageBadges(product);
            // if(product.tags.indexOf(customTagName) > -1) {
            //   customTag = '<div class="plp-product__tag">'+customTagText+'</div>  ';
            // }
            if(product.compare_at_price > product.price && !product.sold_out) {
              additionalPriceClass = ' plp-product__price--compare'
              compareAtPrice = '<span class="plp-product__price__compare">$'+product.compare_at_price+'</span>';
            }
          } else {
            if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
              soldOutHTML = 'RESERVATIONS FULL';
            }
            if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
              soldOutHTML = 'ENTER THE DRAW';
            }
            if(product.tags.indexOf('dev-in-store-only') > -1) {
              soldOutHTML = 'IN&nbsp;STORE&nbsp;ONLY'; 
              if(product.metafields != null) {
                var metaLength = product.metafields.length;
                if(product.metafields[0]['instorelabel']) {
                  soldOutHTML = product.metafields[0]['instorelabel'];  
                }
                if(metaLength > 1) {
                  if(customTagSupress == '') {
                   if(product.metafields[1]['instorelabel']) {
                      soldOutHTML = product.metafields[1]['instorelabel'];  
                    }
                  }
                }
              }
            }
            if(product.tags.indexOf('dev-coming-soon') > -1) {
              soldOutHTML = 'COMING SOON';
            }
            customTag = getOverImageBadges(product);
          }

          var fpval = product.metafields ? product.metafields[0]['data-fp'] : '';
          
          let shouldHidePrice = false;
          if (product?.tags.indexOf('dev-hide-product-price') !== -1) {
            shouldHidePrice = true;
          }
          $('#collection-15').append(`
          <a href="/products/${product.handle}" class="plp-product ${shouldHidePrice ? 'plp-product--hide-price' : ''}">
            <div class="image-4-5 product-image">
              ${customTag}
              ${imgToDisplay}
            </div>
            <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">

              <h3 class="plp-product__title">${product.title}</h3>
              <div class="plp-product__price ${ additionalPriceClass }">
                  <span class="money" data-currency-usd="${ product.price }" data-currency="USD" data-fp="${ fpval }">${ soldOutHTML }</span>
                  ${ compareAtPrice }
              </div>
              <div class="plp-product__variants color-mg" style="display: none !important">

                      ${ swatchCount } Color Available

              </div>
            </div>
          </a>

            `)
          counter++;
        }
}
        if(counter < 8) {
          $('#collection-15').next().find('a').text('view collection');
        }

        counter = 0;

  $('.plp-carousel').scrollLeft(0);

  setTimeout(function() {
    $('.plp-carousel').scrollLeft(0);
  }, 500);

  setTimeout(function() {
    $('.plp-carousel').scrollLeft(0);
  }, 1000);

  setTimeout(function() {
    $('.plp-carousel').scrollLeft(0);
    $('.plp-carousel__image').css('visibility', 'visible')
  }, 1500);
      }
    })

    // Show jarallax banners when products loaded
    setTimeout(function() {
      $('.page-collection-super .jarallax').removeClass('d-none');
    }, 1000);

                // var filterJson = {
                //   "store_name":store,
                //   "collection": coll[2],
                //   "sizes": sizesArr,
                //   "colors": colorsArr,
                //   "display_sold_out": soldout
                // }
                // console.log('ga','Select Filter ' + type,'Filter value: '+val)
                // ga('send','event','Filtering','Select Filter ' + type,'Filter value: '+val);

  }
});

$(document).ready(function() {
  if($('body').hasClass('template-product')) {
    var numOfImages = $('.product__carousel-new .product__image-item, .product__carousel-newxx.product__image-item').length / 2;
    console.log(numOfImages, '<<');
    var availableHeight = window.innerHeight - 60;
    var productHeight = $('.product__image-item .product-image img:visible').outerHeight();
    if(numOfImages > 0) {
      if(window.innerWidth > 1024) {
        if(availableHeight < productHeight) {
          console.log('start acting now!', availableHeight, productHeight);

          $('.product-image.image-4-5').removeClass('image-4-5');
          $('.product__image-item .product-image img').height(availableHeight - 70);
          $('.product__image-item .product-image img').css('margin', '0 auto');
          $('.product__image-item .product-image img').css('display', 'block');


          $('.product-video.image-4-5').removeClass('image-4-5')
          $('.product__image-item .product-video video').height(availableHeight - 70);
          $('.product__image-item .product-video video').css('margin', '0 auto');
          $('.product__image-item .product-video video').css('display', 'block');
        }
      }
    }

    console.log('debug: ', numOfImages, window.innerWidth, availableHeight, productHeight);
    setTimeout(function() {
      console.log('debug2: ', numOfImages, window.innerWidth, availableHeight, productHeight);
    }, 500)
  }
});

function formatPrice(price, currencyCode) {
  var format = Shop.moneyFormatCurrency;
  var priceToDisplay = '';
  if(format.indexOf('$') == 0 || currencyCode == 'SRD' || currencyCode == 'MYR' || currencyCode == 'AMD' || currencyCode == 'MDL' || currencyCode == 'RSD' || currencyCode == 'CHF') { 
    priceToDisplay = format;
    if(currencyCode == 'USD') {
      priceToDisplay = format.replace(currencyCode, '');
    }
  } else {
    priceToDisplay = format.replace(currencyCode, '');
  }

  // if(currencyCode == 'DKK' or norwegian)
// Denmark/Norway - kr is missing
// Hungary - amount showing formula instead of value
// Moldova - MDL is missing
// Serbia - RSD is missing
// Switzerland - CHF is missing
// Sweden - amount showing formula, kr is missing

  if(currencyCode == 'DKK' || currencyCode == 'NOK' || currencyCode == 'SEK') {
    priceToDisplay += ' kr';
  }

  if(priceToDisplay.indexOf("\{\{amount_with_comma_separator\}\}") > -1) {
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    priceToDisplay = priceToDisplay.replace("\{\{amount_with_comma_separator\}\}", price);
  }

  if(priceToDisplay.indexOf("\{\{amount\}\}") > -1) {
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    priceToDisplay = priceToDisplay.replace("\{\{amount\}\}", price);
  }

  if(priceToDisplay.indexOf("\{\{amount_no_decimals\}\}") > -1) {
    if(currencyCode == 'CLP') {
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    } else if(currencyCode == 'SEK') {
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    priceToDisplay = priceToDisplay.replace("\{\{amount_no_decimals\}\}", price);
  }

  if(priceToDisplay.indexOf("\{\{amount_no_decimals_with_comma_separator\}\}") > -1) {
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    priceToDisplay = priceToDisplay.replace("\{\{amount_no_decimals_with_comma_separator\}\}", price);
  }

  if(priceToDisplay.indexOf("\{\{amount_no_decimals\}\}") > -1) {
    if(currencyCode == 'SEK') {
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      priceToDisplay = priceToDisplay.replace("\{\{amount_no_decimals\}\}", price);
    } else {
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      priceToDisplay = priceToDisplay.replace("\{\{amount_no_decimals\}\}", price);      
    }
  }

  if(priceToDisplay.indexOf("\{\{amount_with_space_separator\}\}") > -1) {
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    priceToDisplay = priceToDisplay.replace("\{\{amount_with_space_separator\}\}", price);
  }

  if(currencyCode == 'CVE') {
    priceToDisplay += ' CVE';
  }

  return priceToDisplay;
}

// Quick cart - remove non-raffle items and add raffle item


$(document).ready(function() {
  if($('.preorder-box').length && $('.product__short-info').length) {
    $('.preorder-box').css('margin-bottom', '30px')
  }
});






// how many cards get an eager image; everything after relies on native lazy
var PLP_VIEW_ALL_EAGER = 32;
var PLP_VIEW_ALL_PARAM = 'show';

var plpViewAllActive = false;
var plpViewAllRequest = null;

// requested page size. the api caps this at FILTER_MAX_PAGE_SIZE (2000 today)
// and serves AT the cap rather than erroring, so number_of_pages is followed
// regardless - lowering the cap server-side just turns this into a page walk.
var PLP_VIEW_ALL_PAGE_SIZE = 2000;

// retires late pages from a run that a newer one has superseded
var plpViewAllRunId = 0;

// the search string the grid currently reflects, so popstate can tell whether
// the entry it landed on needs a redraw
var plpViewAllRenderedSearch = null;


var PLP_VIEW_ALL_ENABLED = false;

var PLP_VIEW_ALL_LABEL = "View all";


var PLP_VIEW_ALL_AUTOLOAD = true;


function plpViewAllInUrl() {
  return new URLSearchParams(window.location.search).get(PLP_VIEW_ALL_PARAM) == 'all';
}

// the filter ui keeps its state in the url, so read it from there rather than
// from the checkboxes - same params getFilteredProducts parses
function plpViewAllFilterState() {
  var params = new URLSearchParams(window.location.search);
  var hideSoldOut = params.get('v') === 'true' || params.get('ss') === 'true';

  return {
    'colors': params.getAll('c'),
    'sizes': typeof parseSizesFromSearch === 'function' ? parseSizesFromSearch(window.location.search) : [],
    'display_sold_out': !hideSoldOut,
    'for_sales': params.get('ss') === 'true'
  };
}

function plpViewAllPayload() {
  var host = window.location.host;
  var filters = plpViewAllFilterState();

  var store = 'aime-leon-dore';
  if(host.indexOf('eu') > -1) {
    store = 'aime-leon-dore-eu';
  }
  if(host.indexOf('dev') > -1) {
    store = 'aime-leon-dore-dev-store';
  }
  if(host.indexOf('eu-dev') > -1) {
    store = 'aime-leon-dore-eu-dev';
  }

  var payload = {
    'store_name': store,
    'collection': currentCollectionHandle(),
    'sizes': filters.sizes,
    'colors': filters.colors,
    'display_sold_out': filters.display_sold_out,
    'for_sales': filters.for_sales,
    'iso_code': Shopify.country
  };

  if(host.indexOf('eu') > -1) {
    payload['location_id'] = $('body').attr('data-country') == 'GB' ? 74146152597 : 50003247253;
  }

  // keep whatever sort the shopper already picked
  if(window.location.href.indexOf('price') > -1) {
    payload['sort_type'] = 'price';
  }
  if(window.location.href.indexOf('created') > -1) {
    payload['sort_type'] = 'created_at';
  }
  if(window.location.href.indexOf('descending') > -1) {
    payload['sort_order'] = 'desc';
  }
  if(window.location.href.indexOf('ascending') > -1) {
    payload['sort_order'] = 'asc';
  }

  return payload;
}

function plpViewAllImages(product, index) {
  var lazy = index < PLP_VIEW_ALL_EAGER ? '' : ' loading="lazy"';
  var images = product.images || [];

  if(typeof plpCarousel !== 'undefined' && plpCarousel && images.length > 1) {
    var out = '<div class="plp-carousel-container"><div class="plp-carousel"><ul>';

    for(var j = 1; j < images.length; j++) {
      if(images[j].alt == 'dev-product-image-swatch') {
        continue;
      }
      var url = images[j].url + '&width=600';

      if(j == 1) {
        // the rest of the carousel is revealed once this one lands
        out += '<li><div class="plp-carousel__item"><img src="' + url + '" alt="" class="plp-carousel__image" draggable="false"' + lazy + ' onload="plpFirstImageLoaded(this)"></div></li>';
      } else {
        out += '<li><div class="plp-carousel__item"><img src="' + url + '" alt="" class="plp-carousel__image" draggable="false" style="display: none" loading="lazy"></div></li>';
      }
    }

    return out + '</ul></div></div>';
  }

  var single = images[1] ? images[1].url : product.image_url;
  return '<img src="' + single + '" alt=""' + lazy + '>';
}

function plpViewAllCard(product, index) {
  var price = product.local_price.price;
  var priceLabel = formatPrice(price, product.local_price.currency);
  var compareAt = '';

  if(!!product.local_price.compare_at_price && !product.sold_out) {
    if(product.local_price.compare_at_price > price) {
      compareAt = '<s class="product__price product__price--sale" style="font-size: inherit">' + formatPrice(product.local_price.compare_at_price, product.local_price.currency) + '</s>';
    }
  }

  if(product.sold_out) {
    priceLabel = 'SOLD&nbsp;OUT';
  }

  var badges = product.tags ? getOverImageBadges(product) : '';
  var hidePrice = product.tags && product.tags.indexOf('dev-hide-product-price') > -1;
  var title = (product.title || '').replace(/"/g, '&quot;');

  return '<a href="/products/' + product.handle + '" class="plp-product' + (hidePrice ? ' plp-product--hide-price' : '') + '"' +
           ' data-product-id="' + product.id + '" title="' + title + '" data-price="' + price + '" data-title="' + title + '" data-index="' + index + '">' +
           '<div class="image-4-5 product-image">' + badges + plpViewAllImages(product, index) + '</div>' +
           '<div class="temp-fix-scaling"></div>' +
           '<div class="short-desc plp-product__details">' +
             '<h3 class="plp-product__title">' + product.title + '</h3>' +
             '<div class="plp-product__price' + (compareAt ? ' plp-product__price--compare' : '') + '">' +
               '<span class="money">' + priceLabel + '</span>' + compareAt +
             '</div>' +
           '</div>' +
         '</a>';
}

// ---- view all analytics ----

// report engagement every this many products passed, so a long collection does
// not fire one event per row
var PLP_VIEW_ALL_STEP = 24;

var plpViewAllReported = 0;
var plpViewAllScrollBound = false;
var plpViewAllScrollTimer = null;

function plpViewAllTrack(name, params) {
  if(typeof gtag !== 'function') {
    return;
  }
  gtag('event', name, params);
}

function plpViewAllDeviceType() {
  return $(window).width() < 1025 ? 'mobile' : 'desktop';
}

// columns currently on screen - read the grid first, fall back to the stored
// preference the toolbar writes (plpdesktop 3 = eight up, 5 = four, 2 = two)
function plpViewAllColumns() {
  var $grid = $('.products-collection');

  if(plpViewAllDeviceType() === 'mobile') {
    if($grid.hasClass('grid-products--four-mobile')) {
      return 4;
    }
    if($grid.hasClass('grid-products--one')) {
      return 1;
    }
    var mobilePref = parseInt(localStorage.getItem('plpmobile'), 10);
    return mobilePref > 0 ? mobilePref : 2;
  }

  if($grid.hasClass('grid-products--eight')) {
    return 8;
  }
  if($grid.hasClass('grid-products--two')) {
    return 2;
  }
  if($grid.hasClass('grid-products--four')) {
    return 4;
  }

  var desktopPref = parseInt(localStorage.getItem('plpdesktop'), 10);
  if(desktopPref === 3) {
    return 8;
  }
  if(desktopPref === 2) {
    return 2;
  }
  return 4;
}

function plpViewAllActiveFilters() {
  var params = new URLSearchParams(window.location.search);
  var parts = [];

  var colors = params.getAll('c');
  if(colors.length) {
    parts.push('color:' + colors.join('+'));
  }

  var sizes = typeof parseSizesFromSearch === 'function' ? parseSizesFromSearch(window.location.search) : [];
  if(sizes.length) {
    var names = [];
    for(var i = 0; i < sizes.length; i++) {
      names.push(sizes[i].name);
    }
    parts.push('size:' + names.join('+'));
  }

  if(params.get('v') === 'true') {
    parts.push('hide_sold_out');
  }
  if(params.get('ss') === 'true') {
    parts.push('sale_only');
  }

  return parts.length ? parts.join('|') : 'none';
}

function plpViewAllPageNumber() {
  var page = new URLSearchParams(window.location.search).get('page');
  return page ? parseInt(page, 10) : 1;
}

// products scrolled past, counted from the first card view all pulled in
function plpViewAllProductsPassed() {
  var $items = $('.products-collection.grid-products > .plp-product');
  if(!$items.length) {
    return 0;
  }

  var rowHeight = $items.first().outerHeight();
  if(!rowHeight) {
    return 0;
  }

  var viewportBottom = $(window).scrollTop() + $(window).height();
  var rows = Math.floor((viewportBottom - $items.first().offset().top) / rowHeight);
  if(rows < 1) {
    return 0;
  }

  return Math.min(rows * plpViewAllColumns(), $items.length);
}

function plpViewAllReportEngagement(force) {
  var passed = plpViewAllProductsPassed();

  if(passed <= plpViewAllReported) {
    return;
  }
  if(!force && passed < plpViewAllReported + PLP_VIEW_ALL_STEP) {
    return;
  }

  plpViewAllReported = passed;

  plpViewAllTrack('view_all_engagement', {
    'collection_path': window.location.pathname,
    'device_type': plpViewAllDeviceType(),
    'view_type': plpViewAllColumns() + ' across',
    'product_count_total': passed
  });
}

function plpViewAllBindEngagement() {
  if(plpViewAllScrollBound) {
    return;
  }
  plpViewAllScrollBound = true;

  $(window).on('scroll.plpViewAll', function() {
    clearTimeout(plpViewAllScrollTimer);
    plpViewAllScrollTimer = setTimeout(function() {
      plpViewAllReportEngagement(false);
    }, 300);
  });

  // a shopper usually leaves mid-milestone, so flush the real depth on the way out
  $(window).on('pagehide.plpViewAll', function() {
    plpViewAllReportEngagement(true);
  });

  $(document).on('visibilitychange.plpViewAll', function() {
    if(document.visibilityState === 'hidden') {
      plpViewAllReportEngagement(true);
    }
  });
}

// the liquid cards carry no id we can rely on, but every card links to its
// product, so the handle in the href is the key both sides share
function plpViewAllHandleOf(el) {
  var href = el.getAttribute('href') || '';
  var match = href.match(/\/products\/([^\/?#]+)/);
  return match ? match[1] : '';
}

function plpViewAllRender(rawProducts, totalCount) {
  var products = withValidLocalPrice(rawProducts);
  var $grid = $('.products-collection.grid-products');
  var i;

  // index what is already rendered - those cards have their images decoded, so
  // reusing the node avoids the wipe-and-refetch flash
  var existing = {};
  $grid.find('> .plp-product').each(function() {
    var handle = plpViewAllHandleOf(this);
    if(handle) {
      existing[handle] = this;
    }
  });

  // build only the cards we are missing, and parse them in one go rather than
  // once per product
  var missingHtml = '';
  for(i = 0; i < products.length; i++) {
    if(!existing[products[i].handle]) {
      missingHtml += plpViewAllCard(products[i], i);
    }
  }

  var parsed = document.createElement('div');
  parsed.innerHTML = missingHtml;

  var fresh = {};
  $(parsed).children('.plp-product').each(function() {
    var handle = plpViewAllHandleOf(this);
    if(handle) {
      fresh[handle] = this;
    }
  });

  // appending to a fragment moves an existing node rather than copying it, so
  // the grid ends up in api order without recreating anything we kept. this
  // also fixes the order when view all is hit from page 2 or later.
  var frag = document.createDocumentFragment();
  var kept = 0;
  var added = 0;

  for(i = 0; i < products.length; i++) {
    var key = products[i].handle;
    var node = existing[key];

    if(node) {
      node.style.display = '';
      delete existing[key];
      kept++;
    } else {
      node = fresh[key];
      added++;
    }

    if(node) {
      node.setAttribute('data-index', i);
      frag.appendChild(node);
    }
  }

  // anything still here dropped out of the result set on a filter change
  for(var stale in existing) {
    if(existing[stale].parentNode) {
      existing[stale].parentNode.removeChild(existing[stale]);
    }
  }

  $grid.append(frag);
  hideCollectionLoader();
  $grid.removeClass('loading-products-patch');

  // total_count is the collection's own figure; products.length is what we could
  // actually render, which is lower whenever a product came back without a local
  // price for this market
  var counted = totalCount == null ? products.length : totalCount;
  $('.collection-title sup').text(counted);
  console.log('view all:', products.length, 'rendered of', counted, '-', kept, 'kept,', added, 'added');
  if(totalCount != null && totalCount !== products.length) {
    console.warn('view all: ' + (totalCount - products.length) + ' product(s) dropped with no local price');
  }

  // no pagination in view-all mode, and the button has done its job
  $('.pagination').remove();
  $('.pagination-plp').remove();

  // take the .break-row wrapper with it, or the button alone if it has none
  var $viewAll = $('#plp-view-all');
  var $viewAllRow = $viewAll.closest('.break-row');
  ($viewAllRow.length ? $viewAllRow : $viewAll).remove();
  $('.next-category-container').show();

  // the aborted request would have cleared the refine panel's spinner as the
  // first line of its success handler. the panel content loads separately via
  // collection_info and is gated behind a one-shot .loaded class, so if this
  // overlay is left up nothing ever takes it down again.
  $('.loading-filters').remove();

  // filtering() normally does this in its own success handler
  if(window.aldsec && typeof window.aldsec.filteringShowHideActive === 'function') {
    window.aldsec.filteringShowHideActive();
  }

  plpViewAllRenderedSearch = window.location.search;

  // a filter change is a new set, so depth restarts from its first card
  plpViewAllReported = 0;
  plpViewAllBindEngagement();
}

function plpViewAllFetchPage(page) {
  var payload = plpViewAllPayload();

  payload.pagination = { 'page': page, 'page_size': PLP_VIEW_ALL_PAGE_SIZE };

  return $.ajax({
    url: 'https://ald-filter-staging.herokuapp.com/api/filter_products_paginated',
    plpViewAll: true,
    type: 'post',
    data: JSON.stringify(payload),
    cache: false,
    dataType: 'json',
    contentType: 'application/json'
  });
}

function plpViewAllLoad() {
  var $button = $('#plp-view-all');
  var label = $button.data('label') || PLP_VIEW_ALL_LABEL;

  if($button.length) {
    $button.prop('disabled', true).text('Loading...');
  }
  // no spinner: showCollectionLoader() empties the grid, and even just showing
  // .loading-collection-products inserts a flex item above every card and shifts
  // the whole grid down. the button label carries the loading state instead.

  // a filter change while view-all is on supersedes whatever is in flight, and
  // the run id retires any pages still arriving from the previous one
  if(plpViewAllRequest) {
    plpViewAllRequest.abort();
  }
  var runId = ++plpViewAllRunId;

  var collected = [];
  var totalCount = null;

  function fetchFrom(page) {
    plpViewAllRequest = plpViewAllFetchPage(page);

    plpViewAllRequest.done(function(response) {
      if(runId !== plpViewAllRunId) {
        return;
      }

      collected = collected.concat(response.products || []);
      if(response.total_count != null) {
        totalCount = response.total_count;
      }

      // page_size is capped server-side (FILTER_MAX_PAGE_SIZE), and a request
      // over the cap is served AT the cap rather than refused - so one response
      // is not proof we have the whole set. number_of_pages is.
      var pages = response.number_of_pages || 1;
      if(page < pages) {
        fetchFrom(page + 1);
        return;
      }

      plpViewAllRequest = null;
      plpViewAllRender(collected, totalCount);
    });

    plpViewAllRequest.fail(function(xhr, textStatus) {
      if(textStatus == 'abort' || runId !== plpViewAllRunId) {
        return;
      }
      plpViewAllRequest = null;
      hideCollectionLoader();
      console.error('view all failed on page', page, xhr && xhr.status);
      if($button.length) {
        $button.prop('disabled', false).text(label + ' - retry');
      }
    });
  }

  fetchFrom(1);
}

// filtering tears down the liquid pagination and appends its own .pagination-plp,
// which takes the button with it. put it back so a shopper who filtered while
// paginated can still jump straight to the filtered full set.
function plpViewAllEnsureButton() {
  if(!PLP_VIEW_ALL_ENABLED || plpViewAllActive) {
    return;
  }
  if(document.querySelector('#plp-view-all')) {
    return;
  }

  // no pagination means the filtered results already fit on one page
  var $pagination = $('.pagination').first();
  if(!$pagination.length) {
    return;
  }

  var $button = $('<button type="button" id="plp-view-all"></button>')
    .attr('data-label', PLP_VIEW_ALL_LABEL)
    .text(PLP_VIEW_ALL_LABEL);

  // .break-row is a full-basis flex item, which is what drops the button onto
  // its own line under the page numbers. the liquid markup wraps it the same
  // way, so the rebuilt pagination has to match or the button sits inline.
  var $row = $('<div class="break-row"></div>').append($button);

  // the rebuilt markup carries the theme's own class, not the modifier the
  // centering rules are scoped to
  $pagination.addClass('pagination--plp').append($row);
}

$(document).ajaxSuccess(function(event, jqXHR, settings) {
  if(!settings || !settings.url || settings.plpViewAll) {
    return;
  }
  if(settings.url.indexOf('/api/filter_products') === -1) {
    return;
  }
  // runs after their success handler, so the new pagination is already in place
  plpViewAllEnsureButton();
});

// entering view-all is a history entry, so back returns to the paginated view
$(document).on('click', '#plp-view-all', function() {
  // read the state the shopper actually clicked from, before pushState moves it
  plpViewAllTrack('view_all_click', {
    'collection_path': window.location.pathname,
    'device_type': plpViewAllDeviceType(),
    'filter_applied': plpViewAllActiveFilters(),
    'pagination_page': plpViewAllPageNumber()
  });

  var url = new URL(window.location);
  url.searchParams.set(PLP_VIEW_ALL_PARAM, 'all');
  url.searchParams.delete('page');
  history.pushState({ plpViewAll: true }, '', url);

  plpViewAllActive = true;
  plpViewAllLoad();
});

$(window).on('popstate', function() {
  // leave ordinary paginated history alone
  if(!plpViewAllActive && !plpViewAllInUrl()) {
    return;
  }

  // going back out of view-all cannot be un-rendered into pages, and going back
  // to an earlier filter state has to restore the filter ui too, so in both
  // cases let the server redraw whatever url we landed on
  if(window.location.search !== plpViewAllRenderedSearch) {
    window.location.reload();
  }
});

// there are two filter implementations - getFilteredProducts() and filtering() -
// and only one of them is reachable by patching aldsec. catching the request
// itself covers both, whichever endpoint they picked.
$.ajaxPrefilter(function(options, originalOptions, jqXHR) {
  if(!plpViewAllActive || originalOptions.plpViewAll) {
    return;
  }
  if(!options.url || options.url.indexOf('/api/filter_products') === -1) {
    return;
  }

  jqXHR.abort();

  // filtering() rebuilds the url from its own filter string and drops show=all,
  // so put it back before the loader reads the filters out of the url again
  var url = new URL(window.location);
  if(url.searchParams.get(PLP_VIEW_ALL_PARAM) !== 'all') {
    url.searchParams.set(PLP_VIEW_ALL_PARAM, 'all');
    url.searchParams.delete('page');
    history.replaceState(history.state, '', url);
  }

  plpViewAllLoad();
});

// filtering while view-all is on stays on one page rather than dropping back
// into pagination - patched at parse time so aldsec.init() already sees it
if(plpViewAllInUrl()) {
  if(PLP_VIEW_ALL_AUTOLOAD) {
    plpViewAllActive = true;
  } else {
    // restore is switched off, so this load stays paginated. drop the marker so
    // the url matches what is on screen and the button reads as not-yet-clicked.
    var plpViewAllStaleUrl = new URL(window.location);
    plpViewAllStaleUrl.searchParams.delete(PLP_VIEW_ALL_PARAM);
    history.replaceState(history.state, '', plpViewAllStaleUrl);
  }
}

if(window.aldsec && typeof window.aldsec.getFilteredProducts === 'function') {
  var plpOriginalGetFilteredProducts = window.aldsec.getFilteredProducts;

  window.aldsec.getFilteredProducts = function() {
    if(plpViewAllActive) {
      return plpViewAllLoad();
    }
    return plpOriginalGetFilteredProducts.apply(this, arguments);
  };
}

$(function() {
  // with filters in the url aldsec.init() triggers the patched fetch itself
  if(plpViewAllActive && !hasCollectionFilterParams()) {
    plpViewAllLoad();
  }
  plpViewAllEnsureButton();
});
